// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("emoji-datasource-google/img/google/sheets-256/64.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../static/generated/emoji/images-google-64/1f419.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.emoji,
span.emoji
{
    display: inline-block;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-size: 6100.000%;
    background-repeat: no-repeat;

    /* Hide the text. */
    text-indent: 100%;
    white-space: nowrap;
    overflow: hidden;
}

.emoji-1f419
{
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) !important;
    background-position: 0% 0% !important;
    background-size: contain !important;
}

.emoji-0023-20e3 {
    background-position: 0.000% 0.000%;
}
.emoji-002a-20e3 {
    background-position: 0.000% 1.667%;
}
.emoji-0030-20e3 {
    background-position: 0.000% 3.333%;
}
.emoji-0031-20e3 {
    background-position: 0.000% 5.000%;
}
.emoji-0032-20e3 {
    background-position: 0.000% 6.667%;
}
.emoji-0033-20e3 {
    background-position: 0.000% 8.333%;
}
.emoji-0034-20e3 {
    background-position: 0.000% 10.000%;
}
.emoji-0035-20e3 {
    background-position: 0.000% 11.667%;
}
.emoji-0036-20e3 {
    background-position: 0.000% 13.333%;
}
.emoji-0037-20e3 {
    background-position: 0.000% 15.000%;
}
.emoji-0038-20e3 {
    background-position: 0.000% 16.667%;
}
.emoji-0039-20e3 {
    background-position: 0.000% 18.333%;
}
.emoji-00a9 {
    background-position: 0.000% 20.000%;
}
.emoji-00ae {
    background-position: 0.000% 21.667%;
}
.emoji-1f004 {
    background-position: 0.000% 23.333%;
}
.emoji-1f0cf {
    background-position: 0.000% 25.000%;
}
.emoji-1f170 {
    background-position: 0.000% 26.667%;
}
.emoji-1f171 {
    background-position: 0.000% 28.333%;
}
.emoji-1f17e {
    background-position: 0.000% 30.000%;
}
.emoji-1f17f {
    background-position: 0.000% 31.667%;
}
.emoji-1f18e {
    background-position: 0.000% 33.333%;
}
.emoji-1f191 {
    background-position: 0.000% 35.000%;
}
.emoji-1f192 {
    background-position: 0.000% 36.667%;
}
.emoji-1f193 {
    background-position: 0.000% 38.333%;
}
.emoji-1f194 {
    background-position: 0.000% 40.000%;
}
.emoji-1f195 {
    background-position: 0.000% 41.667%;
}
.emoji-1f196 {
    background-position: 0.000% 43.333%;
}
.emoji-1f197 {
    background-position: 0.000% 45.000%;
}
.emoji-1f198 {
    background-position: 0.000% 46.667%;
}
.emoji-1f199 {
    background-position: 0.000% 48.333%;
}
.emoji-1f19a {
    background-position: 0.000% 50.000%;
}
.emoji-1f1e6-1f1e8 {
    background-position: 0.000% 51.667%;
}
.emoji-1f1e6-1f1e9 {
    background-position: 0.000% 53.333%;
}
.emoji-1f1e6-1f1ea {
    background-position: 0.000% 55.000%;
}
.emoji-1f1e6-1f1eb {
    background-position: 0.000% 56.667%;
}
.emoji-1f1e6-1f1ec {
    background-position: 0.000% 58.333%;
}
.emoji-1f1e6-1f1ee {
    background-position: 0.000% 60.000%;
}
.emoji-1f1e6-1f1f1 {
    background-position: 0.000% 61.667%;
}
.emoji-1f1e6-1f1f2 {
    background-position: 0.000% 63.333%;
}
.emoji-1f1e6-1f1f4 {
    background-position: 0.000% 65.000%;
}
.emoji-1f1e6-1f1f6 {
    background-position: 0.000% 66.667%;
}
.emoji-1f1e6-1f1f7 {
    background-position: 0.000% 68.333%;
}
.emoji-1f1e6-1f1f8 {
    background-position: 0.000% 70.000%;
}
.emoji-1f1e6-1f1f9 {
    background-position: 0.000% 71.667%;
}
.emoji-1f1e6-1f1fa {
    background-position: 0.000% 73.333%;
}
.emoji-1f1e6-1f1fc {
    background-position: 0.000% 75.000%;
}
.emoji-1f1e6-1f1fd {
    background-position: 0.000% 76.667%;
}
.emoji-1f1e6-1f1ff {
    background-position: 0.000% 78.333%;
}
.emoji-1f1e7-1f1e6 {
    background-position: 0.000% 80.000%;
}
.emoji-1f1e7-1f1e7 {
    background-position: 0.000% 81.667%;
}
.emoji-1f1e7-1f1e9 {
    background-position: 0.000% 83.333%;
}
.emoji-1f1e7-1f1ea {
    background-position: 0.000% 85.000%;
}
.emoji-1f1e7-1f1eb {
    background-position: 0.000% 86.667%;
}
.emoji-1f1e7-1f1ec {
    background-position: 0.000% 88.333%;
}
.emoji-1f1e7-1f1ed {
    background-position: 0.000% 90.000%;
}
.emoji-1f1e7-1f1ee {
    background-position: 0.000% 91.667%;
}
.emoji-1f1e7-1f1ef {
    background-position: 0.000% 93.333%;
}
.emoji-1f1e7-1f1f1 {
    background-position: 0.000% 95.000%;
}
.emoji-1f1e7-1f1f2 {
    background-position: 0.000% 96.667%;
}
.emoji-1f1e7-1f1f3 {
    background-position: 0.000% 98.333%;
}
.emoji-1f1e7-1f1f4 {
    background-position: 0.000% 100.000%;
}
.emoji-1f1e7-1f1f6 {
    background-position: 1.667% 0.000%;
}
.emoji-1f1e7-1f1f7 {
    background-position: 1.667% 1.667%;
}
.emoji-1f1e7-1f1f8 {
    background-position: 1.667% 3.333%;
}
.emoji-1f1e7-1f1f9 {
    background-position: 1.667% 5.000%;
}
.emoji-1f1e7-1f1fb {
    background-position: 1.667% 6.667%;
}
.emoji-1f1e7-1f1fc {
    background-position: 1.667% 8.333%;
}
.emoji-1f1e7-1f1fe {
    background-position: 1.667% 10.000%;
}
.emoji-1f1e7-1f1ff {
    background-position: 1.667% 11.667%;
}
.emoji-1f1e8-1f1e6 {
    background-position: 1.667% 13.333%;
}
.emoji-1f1e8-1f1e8 {
    background-position: 1.667% 15.000%;
}
.emoji-1f1e8-1f1e9 {
    background-position: 1.667% 16.667%;
}
.emoji-1f1e8-1f1eb {
    background-position: 1.667% 18.333%;
}
.emoji-1f1e8-1f1ec {
    background-position: 1.667% 20.000%;
}
.emoji-1f1e8-1f1ed {
    background-position: 1.667% 21.667%;
}
.emoji-1f1e8-1f1ee {
    background-position: 1.667% 23.333%;
}
.emoji-1f1e8-1f1f0 {
    background-position: 1.667% 25.000%;
}
.emoji-1f1e8-1f1f1 {
    background-position: 1.667% 26.667%;
}
.emoji-1f1e8-1f1f2 {
    background-position: 1.667% 28.333%;
}
.emoji-1f1e8-1f1f3 {
    background-position: 1.667% 30.000%;
}
.emoji-1f1e8-1f1f4 {
    background-position: 1.667% 31.667%;
}
.emoji-1f1e8-1f1f5 {
    background-position: 1.667% 33.333%;
}
.emoji-1f1e8-1f1f7 {
    background-position: 1.667% 35.000%;
}
.emoji-1f1e8-1f1fa {
    background-position: 1.667% 36.667%;
}
.emoji-1f1e8-1f1fb {
    background-position: 1.667% 38.333%;
}
.emoji-1f1e8-1f1fc {
    background-position: 1.667% 40.000%;
}
.emoji-1f1e8-1f1fd {
    background-position: 1.667% 41.667%;
}
.emoji-1f1e8-1f1fe {
    background-position: 1.667% 43.333%;
}
.emoji-1f1e8-1f1ff {
    background-position: 1.667% 45.000%;
}
.emoji-1f1e9-1f1ea {
    background-position: 1.667% 46.667%;
}
.emoji-1f1e9-1f1ec {
    background-position: 1.667% 48.333%;
}
.emoji-1f1e9-1f1ef {
    background-position: 1.667% 50.000%;
}
.emoji-1f1e9-1f1f0 {
    background-position: 1.667% 51.667%;
}
.emoji-1f1e9-1f1f2 {
    background-position: 1.667% 53.333%;
}
.emoji-1f1e9-1f1f4 {
    background-position: 1.667% 55.000%;
}
.emoji-1f1e9-1f1ff {
    background-position: 1.667% 56.667%;
}
.emoji-1f1ea-1f1e6 {
    background-position: 1.667% 58.333%;
}
.emoji-1f1ea-1f1e8 {
    background-position: 1.667% 60.000%;
}
.emoji-1f1ea-1f1ea {
    background-position: 1.667% 61.667%;
}
.emoji-1f1ea-1f1ec {
    background-position: 1.667% 63.333%;
}
.emoji-1f1ea-1f1ed {
    background-position: 1.667% 65.000%;
}
.emoji-1f1ea-1f1f7 {
    background-position: 1.667% 66.667%;
}
.emoji-1f1ea-1f1f8 {
    background-position: 1.667% 68.333%;
}
.emoji-1f1ea-1f1f9 {
    background-position: 1.667% 70.000%;
}
.emoji-1f1ea-1f1fa {
    background-position: 1.667% 71.667%;
}
.emoji-1f1eb-1f1ee {
    background-position: 1.667% 73.333%;
}
.emoji-1f1eb-1f1ef {
    background-position: 1.667% 75.000%;
}
.emoji-1f1eb-1f1f0 {
    background-position: 1.667% 76.667%;
}
.emoji-1f1eb-1f1f2 {
    background-position: 1.667% 78.333%;
}
.emoji-1f1eb-1f1f4 {
    background-position: 1.667% 80.000%;
}
.emoji-1f1eb-1f1f7 {
    background-position: 1.667% 81.667%;
}
.emoji-1f1ec-1f1e6 {
    background-position: 1.667% 83.333%;
}
.emoji-1f1ec-1f1e7 {
    background-position: 1.667% 85.000%;
}
.emoji-1f1ec-1f1e9 {
    background-position: 1.667% 86.667%;
}
.emoji-1f1ec-1f1ea {
    background-position: 1.667% 88.333%;
}
.emoji-1f1ec-1f1eb {
    background-position: 1.667% 90.000%;
}
.emoji-1f1ec-1f1ec {
    background-position: 1.667% 91.667%;
}
.emoji-1f1ec-1f1ed {
    background-position: 1.667% 93.333%;
}
.emoji-1f1ec-1f1ee {
    background-position: 1.667% 95.000%;
}
.emoji-1f1ec-1f1f1 {
    background-position: 1.667% 96.667%;
}
.emoji-1f1ec-1f1f2 {
    background-position: 1.667% 98.333%;
}
.emoji-1f1ec-1f1f3 {
    background-position: 1.667% 100.000%;
}
.emoji-1f1ec-1f1f5 {
    background-position: 3.333% 0.000%;
}
.emoji-1f1ec-1f1f6 {
    background-position: 3.333% 1.667%;
}
.emoji-1f1ec-1f1f7 {
    background-position: 3.333% 3.333%;
}
.emoji-1f1ec-1f1f8 {
    background-position: 3.333% 5.000%;
}
.emoji-1f1ec-1f1f9 {
    background-position: 3.333% 6.667%;
}
.emoji-1f1ec-1f1fa {
    background-position: 3.333% 8.333%;
}
.emoji-1f1ec-1f1fc {
    background-position: 3.333% 10.000%;
}
.emoji-1f1ec-1f1fe {
    background-position: 3.333% 11.667%;
}
.emoji-1f1ed-1f1f0 {
    background-position: 3.333% 13.333%;
}
.emoji-1f1ed-1f1f2 {
    background-position: 3.333% 15.000%;
}
.emoji-1f1ed-1f1f3 {
    background-position: 3.333% 16.667%;
}
.emoji-1f1ed-1f1f7 {
    background-position: 3.333% 18.333%;
}
.emoji-1f1ed-1f1f9 {
    background-position: 3.333% 20.000%;
}
.emoji-1f1ed-1f1fa {
    background-position: 3.333% 21.667%;
}
.emoji-1f1ee-1f1e8 {
    background-position: 3.333% 23.333%;
}
.emoji-1f1ee-1f1e9 {
    background-position: 3.333% 25.000%;
}
.emoji-1f1ee-1f1ea {
    background-position: 3.333% 26.667%;
}
.emoji-1f1ee-1f1f1 {
    background-position: 3.333% 28.333%;
}
.emoji-1f1ee-1f1f2 {
    background-position: 3.333% 30.000%;
}
.emoji-1f1ee-1f1f3 {
    background-position: 3.333% 31.667%;
}
.emoji-1f1ee-1f1f4 {
    background-position: 3.333% 33.333%;
}
.emoji-1f1ee-1f1f6 {
    background-position: 3.333% 35.000%;
}
.emoji-1f1ee-1f1f7 {
    background-position: 3.333% 36.667%;
}
.emoji-1f1ee-1f1f8 {
    background-position: 3.333% 38.333%;
}
.emoji-1f1ee-1f1f9 {
    background-position: 3.333% 40.000%;
}
.emoji-1f1ef-1f1ea {
    background-position: 3.333% 41.667%;
}
.emoji-1f1ef-1f1f2 {
    background-position: 3.333% 43.333%;
}
.emoji-1f1ef-1f1f4 {
    background-position: 3.333% 45.000%;
}
.emoji-1f1ef-1f1f5 {
    background-position: 3.333% 46.667%;
}
.emoji-1f1f0-1f1ea {
    background-position: 3.333% 48.333%;
}
.emoji-1f1f0-1f1ec {
    background-position: 3.333% 50.000%;
}
.emoji-1f1f0-1f1ed {
    background-position: 3.333% 51.667%;
}
.emoji-1f1f0-1f1ee {
    background-position: 3.333% 53.333%;
}
.emoji-1f1f0-1f1f2 {
    background-position: 3.333% 55.000%;
}
.emoji-1f1f0-1f1f3 {
    background-position: 3.333% 56.667%;
}
.emoji-1f1f0-1f1f5 {
    background-position: 3.333% 58.333%;
}
.emoji-1f1f0-1f1f7 {
    background-position: 3.333% 60.000%;
}
.emoji-1f1f0-1f1fc {
    background-position: 3.333% 61.667%;
}
.emoji-1f1f0-1f1fe {
    background-position: 3.333% 63.333%;
}
.emoji-1f1f0-1f1ff {
    background-position: 3.333% 65.000%;
}
.emoji-1f1f1-1f1e6 {
    background-position: 3.333% 66.667%;
}
.emoji-1f1f1-1f1e7 {
    background-position: 3.333% 68.333%;
}
.emoji-1f1f1-1f1e8 {
    background-position: 3.333% 70.000%;
}
.emoji-1f1f1-1f1ee {
    background-position: 3.333% 71.667%;
}
.emoji-1f1f1-1f1f0 {
    background-position: 3.333% 73.333%;
}
.emoji-1f1f1-1f1f7 {
    background-position: 3.333% 75.000%;
}
.emoji-1f1f1-1f1f8 {
    background-position: 3.333% 76.667%;
}
.emoji-1f1f1-1f1f9 {
    background-position: 3.333% 78.333%;
}
.emoji-1f1f1-1f1fa {
    background-position: 3.333% 80.000%;
}
.emoji-1f1f1-1f1fb {
    background-position: 3.333% 81.667%;
}
.emoji-1f1f1-1f1fe {
    background-position: 3.333% 83.333%;
}
.emoji-1f1f2-1f1e6 {
    background-position: 3.333% 85.000%;
}
.emoji-1f1f2-1f1e8 {
    background-position: 3.333% 86.667%;
}
.emoji-1f1f2-1f1e9 {
    background-position: 3.333% 88.333%;
}
.emoji-1f1f2-1f1ea {
    background-position: 3.333% 90.000%;
}
.emoji-1f1f2-1f1eb {
    background-position: 3.333% 91.667%;
}
.emoji-1f1f2-1f1ec {
    background-position: 3.333% 93.333%;
}
.emoji-1f1f2-1f1ed {
    background-position: 3.333% 95.000%;
}
.emoji-1f1f2-1f1f0 {
    background-position: 3.333% 96.667%;
}
.emoji-1f1f2-1f1f1 {
    background-position: 3.333% 98.333%;
}
.emoji-1f1f2-1f1f2 {
    background-position: 3.333% 100.000%;
}
.emoji-1f1f2-1f1f3 {
    background-position: 5.000% 0.000%;
}
.emoji-1f1f2-1f1f4 {
    background-position: 5.000% 1.667%;
}
.emoji-1f1f2-1f1f5 {
    background-position: 5.000% 3.333%;
}
.emoji-1f1f2-1f1f6 {
    background-position: 5.000% 5.000%;
}
.emoji-1f1f2-1f1f7 {
    background-position: 5.000% 6.667%;
}
.emoji-1f1f2-1f1f8 {
    background-position: 5.000% 8.333%;
}
.emoji-1f1f2-1f1f9 {
    background-position: 5.000% 10.000%;
}
.emoji-1f1f2-1f1fa {
    background-position: 5.000% 11.667%;
}
.emoji-1f1f2-1f1fb {
    background-position: 5.000% 13.333%;
}
.emoji-1f1f2-1f1fc {
    background-position: 5.000% 15.000%;
}
.emoji-1f1f2-1f1fd {
    background-position: 5.000% 16.667%;
}
.emoji-1f1f2-1f1fe {
    background-position: 5.000% 18.333%;
}
.emoji-1f1f2-1f1ff {
    background-position: 5.000% 20.000%;
}
.emoji-1f1f3-1f1e6 {
    background-position: 5.000% 21.667%;
}
.emoji-1f1f3-1f1e8 {
    background-position: 5.000% 23.333%;
}
.emoji-1f1f3-1f1ea {
    background-position: 5.000% 25.000%;
}
.emoji-1f1f3-1f1eb {
    background-position: 5.000% 26.667%;
}
.emoji-1f1f3-1f1ec {
    background-position: 5.000% 28.333%;
}
.emoji-1f1f3-1f1ee {
    background-position: 5.000% 30.000%;
}
.emoji-1f1f3-1f1f1 {
    background-position: 5.000% 31.667%;
}
.emoji-1f1f3-1f1f4 {
    background-position: 5.000% 33.333%;
}
.emoji-1f1f3-1f1f5 {
    background-position: 5.000% 35.000%;
}
.emoji-1f1f3-1f1f7 {
    background-position: 5.000% 36.667%;
}
.emoji-1f1f3-1f1fa {
    background-position: 5.000% 38.333%;
}
.emoji-1f1f3-1f1ff {
    background-position: 5.000% 40.000%;
}
.emoji-1f1f4-1f1f2 {
    background-position: 5.000% 41.667%;
}
.emoji-1f1f5-1f1e6 {
    background-position: 5.000% 43.333%;
}
.emoji-1f1f5-1f1ea {
    background-position: 5.000% 45.000%;
}
.emoji-1f1f5-1f1eb {
    background-position: 5.000% 46.667%;
}
.emoji-1f1f5-1f1ec {
    background-position: 5.000% 48.333%;
}
.emoji-1f1f5-1f1ed {
    background-position: 5.000% 50.000%;
}
.emoji-1f1f5-1f1f0 {
    background-position: 5.000% 51.667%;
}
.emoji-1f1f5-1f1f1 {
    background-position: 5.000% 53.333%;
}
.emoji-1f1f5-1f1f2 {
    background-position: 5.000% 55.000%;
}
.emoji-1f1f5-1f1f3 {
    background-position: 5.000% 56.667%;
}
.emoji-1f1f5-1f1f7 {
    background-position: 5.000% 58.333%;
}
.emoji-1f1f5-1f1f8 {
    background-position: 5.000% 60.000%;
}
.emoji-1f1f5-1f1f9 {
    background-position: 5.000% 61.667%;
}
.emoji-1f1f5-1f1fc {
    background-position: 5.000% 63.333%;
}
.emoji-1f1f5-1f1fe {
    background-position: 5.000% 65.000%;
}
.emoji-1f1f6-1f1e6 {
    background-position: 5.000% 66.667%;
}
.emoji-1f1f7-1f1ea {
    background-position: 5.000% 68.333%;
}
.emoji-1f1f7-1f1f4 {
    background-position: 5.000% 70.000%;
}
.emoji-1f1f7-1f1f8 {
    background-position: 5.000% 71.667%;
}
.emoji-1f1f7-1f1fa {
    background-position: 5.000% 73.333%;
}
.emoji-1f1f7-1f1fc {
    background-position: 5.000% 75.000%;
}
.emoji-1f1f8-1f1e6 {
    background-position: 5.000% 76.667%;
}
.emoji-1f1f8-1f1e7 {
    background-position: 5.000% 78.333%;
}
.emoji-1f1f8-1f1e8 {
    background-position: 5.000% 80.000%;
}
.emoji-1f1f8-1f1e9 {
    background-position: 5.000% 81.667%;
}
.emoji-1f1f8-1f1ea {
    background-position: 5.000% 83.333%;
}
.emoji-1f1f8-1f1ec {
    background-position: 5.000% 85.000%;
}
.emoji-1f1f8-1f1ed {
    background-position: 5.000% 86.667%;
}
.emoji-1f1f8-1f1ee {
    background-position: 5.000% 88.333%;
}
.emoji-1f1f8-1f1ef {
    background-position: 5.000% 90.000%;
}
.emoji-1f1f8-1f1f0 {
    background-position: 5.000% 91.667%;
}
.emoji-1f1f8-1f1f1 {
    background-position: 5.000% 93.333%;
}
.emoji-1f1f8-1f1f2 {
    background-position: 5.000% 95.000%;
}
.emoji-1f1f8-1f1f3 {
    background-position: 5.000% 96.667%;
}
.emoji-1f1f8-1f1f4 {
    background-position: 5.000% 98.333%;
}
.emoji-1f1f8-1f1f7 {
    background-position: 5.000% 100.000%;
}
.emoji-1f1f8-1f1f8 {
    background-position: 6.667% 0.000%;
}
.emoji-1f1f8-1f1f9 {
    background-position: 6.667% 1.667%;
}
.emoji-1f1f8-1f1fb {
    background-position: 6.667% 3.333%;
}
.emoji-1f1f8-1f1fd {
    background-position: 6.667% 5.000%;
}
.emoji-1f1f8-1f1fe {
    background-position: 6.667% 6.667%;
}
.emoji-1f1f8-1f1ff {
    background-position: 6.667% 8.333%;
}
.emoji-1f1f9-1f1e6 {
    background-position: 6.667% 10.000%;
}
.emoji-1f1f9-1f1e8 {
    background-position: 6.667% 11.667%;
}
.emoji-1f1f9-1f1e9 {
    background-position: 6.667% 13.333%;
}
.emoji-1f1f9-1f1eb {
    background-position: 6.667% 15.000%;
}
.emoji-1f1f9-1f1ec {
    background-position: 6.667% 16.667%;
}
.emoji-1f1f9-1f1ed {
    background-position: 6.667% 18.333%;
}
.emoji-1f1f9-1f1ef {
    background-position: 6.667% 20.000%;
}
.emoji-1f1f9-1f1f0 {
    background-position: 6.667% 21.667%;
}
.emoji-1f1f9-1f1f1 {
    background-position: 6.667% 23.333%;
}
.emoji-1f1f9-1f1f2 {
    background-position: 6.667% 25.000%;
}
.emoji-1f1f9-1f1f3 {
    background-position: 6.667% 26.667%;
}
.emoji-1f1f9-1f1f4 {
    background-position: 6.667% 28.333%;
}
.emoji-1f1f9-1f1f7 {
    background-position: 6.667% 30.000%;
}
.emoji-1f1f9-1f1f9 {
    background-position: 6.667% 31.667%;
}
.emoji-1f1f9-1f1fb {
    background-position: 6.667% 33.333%;
}
.emoji-1f1f9-1f1fc {
    background-position: 6.667% 35.000%;
}
.emoji-1f1f9-1f1ff {
    background-position: 6.667% 36.667%;
}
.emoji-1f1fa-1f1e6 {
    background-position: 6.667% 38.333%;
}
.emoji-1f1fa-1f1ec {
    background-position: 6.667% 40.000%;
}
.emoji-1f1fa-1f1f2 {
    background-position: 6.667% 41.667%;
}
.emoji-1f1fa-1f1f3 {
    background-position: 6.667% 43.333%;
}
.emoji-1f1fa-1f1f8 {
    background-position: 6.667% 45.000%;
}
.emoji-1f1fa-1f1fe {
    background-position: 6.667% 46.667%;
}
.emoji-1f1fa-1f1ff {
    background-position: 6.667% 48.333%;
}
.emoji-1f1fb-1f1e6 {
    background-position: 6.667% 50.000%;
}
.emoji-1f1fb-1f1e8 {
    background-position: 6.667% 51.667%;
}
.emoji-1f1fb-1f1ea {
    background-position: 6.667% 53.333%;
}
.emoji-1f1fb-1f1ec {
    background-position: 6.667% 55.000%;
}
.emoji-1f1fb-1f1ee {
    background-position: 6.667% 56.667%;
}
.emoji-1f1fb-1f1f3 {
    background-position: 6.667% 58.333%;
}
.emoji-1f1fb-1f1fa {
    background-position: 6.667% 60.000%;
}
.emoji-1f1fc-1f1eb {
    background-position: 6.667% 61.667%;
}
.emoji-1f1fc-1f1f8 {
    background-position: 6.667% 63.333%;
}
.emoji-1f1fd-1f1f0 {
    background-position: 6.667% 65.000%;
}
.emoji-1f1fe-1f1ea {
    background-position: 6.667% 66.667%;
}
.emoji-1f1fe-1f1f9 {
    background-position: 6.667% 68.333%;
}
.emoji-1f1ff-1f1e6 {
    background-position: 6.667% 70.000%;
}
.emoji-1f1ff-1f1f2 {
    background-position: 6.667% 71.667%;
}
.emoji-1f1ff-1f1fc {
    background-position: 6.667% 73.333%;
}
.emoji-1f201 {
    background-position: 6.667% 75.000%;
}
.emoji-1f202 {
    background-position: 6.667% 76.667%;
}
.emoji-1f21a {
    background-position: 6.667% 78.333%;
}
.emoji-1f22f {
    background-position: 6.667% 80.000%;
}
.emoji-1f232 {
    background-position: 6.667% 81.667%;
}
.emoji-1f233 {
    background-position: 6.667% 83.333%;
}
.emoji-1f234 {
    background-position: 6.667% 85.000%;
}
.emoji-1f235 {
    background-position: 6.667% 86.667%;
}
.emoji-1f236 {
    background-position: 6.667% 88.333%;
}
.emoji-1f237 {
    background-position: 6.667% 90.000%;
}
.emoji-1f238 {
    background-position: 6.667% 91.667%;
}
.emoji-1f239 {
    background-position: 6.667% 93.333%;
}
.emoji-1f23a {
    background-position: 6.667% 95.000%;
}
.emoji-1f250 {
    background-position: 6.667% 96.667%;
}
.emoji-1f251 {
    background-position: 6.667% 98.333%;
}
.emoji-1f300 {
    background-position: 6.667% 100.000%;
}
.emoji-1f301 {
    background-position: 8.333% 0.000%;
}
.emoji-1f302 {
    background-position: 8.333% 1.667%;
}
.emoji-1f303 {
    background-position: 8.333% 3.333%;
}
.emoji-1f304 {
    background-position: 8.333% 5.000%;
}
.emoji-1f305 {
    background-position: 8.333% 6.667%;
}
.emoji-1f306 {
    background-position: 8.333% 8.333%;
}
.emoji-1f307 {
    background-position: 8.333% 10.000%;
}
.emoji-1f308 {
    background-position: 8.333% 11.667%;
}
.emoji-1f309 {
    background-position: 8.333% 13.333%;
}
.emoji-1f30a {
    background-position: 8.333% 15.000%;
}
.emoji-1f30b {
    background-position: 8.333% 16.667%;
}
.emoji-1f30c {
    background-position: 8.333% 18.333%;
}
.emoji-1f30d {
    background-position: 8.333% 20.000%;
}
.emoji-1f30e {
    background-position: 8.333% 21.667%;
}
.emoji-1f30f {
    background-position: 8.333% 23.333%;
}
.emoji-1f310 {
    background-position: 8.333% 25.000%;
}
.emoji-1f311 {
    background-position: 8.333% 26.667%;
}
.emoji-1f312 {
    background-position: 8.333% 28.333%;
}
.emoji-1f313 {
    background-position: 8.333% 30.000%;
}
.emoji-1f314 {
    background-position: 8.333% 31.667%;
}
.emoji-1f315 {
    background-position: 8.333% 33.333%;
}
.emoji-1f316 {
    background-position: 8.333% 35.000%;
}
.emoji-1f317 {
    background-position: 8.333% 36.667%;
}
.emoji-1f318 {
    background-position: 8.333% 38.333%;
}
.emoji-1f319 {
    background-position: 8.333% 40.000%;
}
.emoji-1f31a {
    background-position: 8.333% 41.667%;
}
.emoji-1f31b {
    background-position: 8.333% 43.333%;
}
.emoji-1f31c {
    background-position: 8.333% 45.000%;
}
.emoji-1f31d {
    background-position: 8.333% 46.667%;
}
.emoji-1f31e {
    background-position: 8.333% 48.333%;
}
.emoji-1f31f {
    background-position: 8.333% 50.000%;
}
.emoji-1f320 {
    background-position: 8.333% 51.667%;
}
.emoji-1f321 {
    background-position: 8.333% 53.333%;
}
.emoji-1f324 {
    background-position: 8.333% 55.000%;
}
.emoji-1f325 {
    background-position: 8.333% 56.667%;
}
.emoji-1f326 {
    background-position: 8.333% 58.333%;
}
.emoji-1f327 {
    background-position: 8.333% 60.000%;
}
.emoji-1f328 {
    background-position: 8.333% 61.667%;
}
.emoji-1f329 {
    background-position: 8.333% 63.333%;
}
.emoji-1f32a {
    background-position: 8.333% 65.000%;
}
.emoji-1f32b {
    background-position: 8.333% 66.667%;
}
.emoji-1f32c {
    background-position: 8.333% 68.333%;
}
.emoji-1f32d {
    background-position: 8.333% 70.000%;
}
.emoji-1f32e {
    background-position: 8.333% 71.667%;
}
.emoji-1f32f {
    background-position: 8.333% 73.333%;
}
.emoji-1f330 {
    background-position: 8.333% 75.000%;
}
.emoji-1f331 {
    background-position: 8.333% 76.667%;
}
.emoji-1f332 {
    background-position: 8.333% 78.333%;
}
.emoji-1f333 {
    background-position: 8.333% 80.000%;
}
.emoji-1f334 {
    background-position: 8.333% 81.667%;
}
.emoji-1f335 {
    background-position: 8.333% 83.333%;
}
.emoji-1f336 {
    background-position: 8.333% 85.000%;
}
.emoji-1f337 {
    background-position: 8.333% 86.667%;
}
.emoji-1f338 {
    background-position: 8.333% 88.333%;
}
.emoji-1f339 {
    background-position: 8.333% 90.000%;
}
.emoji-1f33a {
    background-position: 8.333% 91.667%;
}
.emoji-1f33b {
    background-position: 8.333% 93.333%;
}
.emoji-1f33c {
    background-position: 8.333% 95.000%;
}
.emoji-1f33d {
    background-position: 8.333% 96.667%;
}
.emoji-1f33e {
    background-position: 8.333% 98.333%;
}
.emoji-1f33f {
    background-position: 8.333% 100.000%;
}
.emoji-1f340 {
    background-position: 10.000% 0.000%;
}
.emoji-1f341 {
    background-position: 10.000% 1.667%;
}
.emoji-1f342 {
    background-position: 10.000% 3.333%;
}
.emoji-1f343 {
    background-position: 10.000% 5.000%;
}
.emoji-1f344 {
    background-position: 10.000% 6.667%;
}
.emoji-1f345 {
    background-position: 10.000% 8.333%;
}
.emoji-1f346 {
    background-position: 10.000% 10.000%;
}
.emoji-1f347 {
    background-position: 10.000% 11.667%;
}
.emoji-1f348 {
    background-position: 10.000% 13.333%;
}
.emoji-1f349 {
    background-position: 10.000% 15.000%;
}
.emoji-1f34a {
    background-position: 10.000% 16.667%;
}
.emoji-1f34b {
    background-position: 10.000% 18.333%;
}
.emoji-1f34c {
    background-position: 10.000% 20.000%;
}
.emoji-1f34d {
    background-position: 10.000% 21.667%;
}
.emoji-1f34e {
    background-position: 10.000% 23.333%;
}
.emoji-1f34f {
    background-position: 10.000% 25.000%;
}
.emoji-1f350 {
    background-position: 10.000% 26.667%;
}
.emoji-1f351 {
    background-position: 10.000% 28.333%;
}
.emoji-1f352 {
    background-position: 10.000% 30.000%;
}
.emoji-1f353 {
    background-position: 10.000% 31.667%;
}
.emoji-1f354 {
    background-position: 10.000% 33.333%;
}
.emoji-1f355 {
    background-position: 10.000% 35.000%;
}
.emoji-1f356 {
    background-position: 10.000% 36.667%;
}
.emoji-1f357 {
    background-position: 10.000% 38.333%;
}
.emoji-1f358 {
    background-position: 10.000% 40.000%;
}
.emoji-1f359 {
    background-position: 10.000% 41.667%;
}
.emoji-1f35a {
    background-position: 10.000% 43.333%;
}
.emoji-1f35b {
    background-position: 10.000% 45.000%;
}
.emoji-1f35c {
    background-position: 10.000% 46.667%;
}
.emoji-1f35d {
    background-position: 10.000% 48.333%;
}
.emoji-1f35e {
    background-position: 10.000% 50.000%;
}
.emoji-1f35f {
    background-position: 10.000% 51.667%;
}
.emoji-1f360 {
    background-position: 10.000% 53.333%;
}
.emoji-1f361 {
    background-position: 10.000% 55.000%;
}
.emoji-1f362 {
    background-position: 10.000% 56.667%;
}
.emoji-1f363 {
    background-position: 10.000% 58.333%;
}
.emoji-1f364 {
    background-position: 10.000% 60.000%;
}
.emoji-1f365 {
    background-position: 10.000% 61.667%;
}
.emoji-1f366 {
    background-position: 10.000% 63.333%;
}
.emoji-1f367 {
    background-position: 10.000% 65.000%;
}
.emoji-1f368 {
    background-position: 10.000% 66.667%;
}
.emoji-1f369 {
    background-position: 10.000% 68.333%;
}
.emoji-1f36a {
    background-position: 10.000% 70.000%;
}
.emoji-1f36b {
    background-position: 10.000% 71.667%;
}
.emoji-1f36c {
    background-position: 10.000% 73.333%;
}
.emoji-1f36d {
    background-position: 10.000% 75.000%;
}
.emoji-1f36e {
    background-position: 10.000% 76.667%;
}
.emoji-1f36f {
    background-position: 10.000% 78.333%;
}
.emoji-1f370 {
    background-position: 10.000% 80.000%;
}
.emoji-1f371 {
    background-position: 10.000% 81.667%;
}
.emoji-1f372 {
    background-position: 10.000% 83.333%;
}
.emoji-1f373 {
    background-position: 10.000% 85.000%;
}
.emoji-1f374 {
    background-position: 10.000% 86.667%;
}
.emoji-1f375 {
    background-position: 10.000% 88.333%;
}
.emoji-1f376 {
    background-position: 10.000% 90.000%;
}
.emoji-1f377 {
    background-position: 10.000% 91.667%;
}
.emoji-1f378 {
    background-position: 10.000% 93.333%;
}
.emoji-1f379 {
    background-position: 10.000% 95.000%;
}
.emoji-1f37a {
    background-position: 10.000% 96.667%;
}
.emoji-1f37b {
    background-position: 10.000% 98.333%;
}
.emoji-1f37c {
    background-position: 10.000% 100.000%;
}
.emoji-1f37d {
    background-position: 11.667% 0.000%;
}
.emoji-1f37e {
    background-position: 11.667% 1.667%;
}
.emoji-1f37f {
    background-position: 11.667% 3.333%;
}
.emoji-1f380 {
    background-position: 11.667% 5.000%;
}
.emoji-1f381 {
    background-position: 11.667% 6.667%;
}
.emoji-1f382 {
    background-position: 11.667% 8.333%;
}
.emoji-1f383 {
    background-position: 11.667% 10.000%;
}
.emoji-1f384 {
    background-position: 11.667% 11.667%;
}
.emoji-1f385 {
    background-position: 11.667% 13.333%;
}
.emoji-1f386 {
    background-position: 11.667% 23.333%;
}
.emoji-1f387 {
    background-position: 11.667% 25.000%;
}
.emoji-1f388 {
    background-position: 11.667% 26.667%;
}
.emoji-1f389 {
    background-position: 11.667% 28.333%;
}
.emoji-1f38a {
    background-position: 11.667% 30.000%;
}
.emoji-1f38b {
    background-position: 11.667% 31.667%;
}
.emoji-1f38c {
    background-position: 11.667% 33.333%;
}
.emoji-1f38d {
    background-position: 11.667% 35.000%;
}
.emoji-1f38e {
    background-position: 11.667% 36.667%;
}
.emoji-1f38f {
    background-position: 11.667% 38.333%;
}
.emoji-1f390 {
    background-position: 11.667% 40.000%;
}
.emoji-1f391 {
    background-position: 11.667% 41.667%;
}
.emoji-1f392 {
    background-position: 11.667% 43.333%;
}
.emoji-1f393 {
    background-position: 11.667% 45.000%;
}
.emoji-1f396 {
    background-position: 11.667% 46.667%;
}
.emoji-1f397 {
    background-position: 11.667% 48.333%;
}
.emoji-1f399 {
    background-position: 11.667% 50.000%;
}
.emoji-1f39a {
    background-position: 11.667% 51.667%;
}
.emoji-1f39b {
    background-position: 11.667% 53.333%;
}
.emoji-1f39e {
    background-position: 11.667% 55.000%;
}
.emoji-1f39f {
    background-position: 11.667% 56.667%;
}
.emoji-1f3a0 {
    background-position: 11.667% 58.333%;
}
.emoji-1f3a1 {
    background-position: 11.667% 60.000%;
}
.emoji-1f3a2 {
    background-position: 11.667% 61.667%;
}
.emoji-1f3a3 {
    background-position: 11.667% 63.333%;
}
.emoji-1f3a4 {
    background-position: 11.667% 65.000%;
}
.emoji-1f3a5 {
    background-position: 11.667% 66.667%;
}
.emoji-1f3a6 {
    background-position: 11.667% 68.333%;
}
.emoji-1f3a7 {
    background-position: 11.667% 70.000%;
}
.emoji-1f3a8 {
    background-position: 11.667% 71.667%;
}
.emoji-1f3a9 {
    background-position: 11.667% 73.333%;
}
.emoji-1f3aa {
    background-position: 11.667% 75.000%;
}
.emoji-1f3ab {
    background-position: 11.667% 76.667%;
}
.emoji-1f3ac {
    background-position: 11.667% 78.333%;
}
.emoji-1f3ad {
    background-position: 11.667% 80.000%;
}
.emoji-1f3ae {
    background-position: 11.667% 81.667%;
}
.emoji-1f3af {
    background-position: 11.667% 83.333%;
}
.emoji-1f3b0 {
    background-position: 11.667% 85.000%;
}
.emoji-1f3b1 {
    background-position: 11.667% 86.667%;
}
.emoji-1f3b2 {
    background-position: 11.667% 88.333%;
}
.emoji-1f3b3 {
    background-position: 11.667% 90.000%;
}
.emoji-1f3b4 {
    background-position: 11.667% 91.667%;
}
.emoji-1f3b5 {
    background-position: 11.667% 93.333%;
}
.emoji-1f3b6 {
    background-position: 11.667% 95.000%;
}
.emoji-1f3b7 {
    background-position: 11.667% 96.667%;
}
.emoji-1f3b8 {
    background-position: 11.667% 98.333%;
}
.emoji-1f3b9 {
    background-position: 11.667% 100.000%;
}
.emoji-1f3ba {
    background-position: 13.333% 0.000%;
}
.emoji-1f3bb {
    background-position: 13.333% 1.667%;
}
.emoji-1f3bc {
    background-position: 13.333% 3.333%;
}
.emoji-1f3bd {
    background-position: 13.333% 5.000%;
}
.emoji-1f3be {
    background-position: 13.333% 6.667%;
}
.emoji-1f3bf {
    background-position: 13.333% 8.333%;
}
.emoji-1f3c0 {
    background-position: 13.333% 10.000%;
}
.emoji-1f3c1 {
    background-position: 13.333% 11.667%;
}
.emoji-1f3c2 {
    background-position: 13.333% 13.333%;
}
.emoji-1f3c3-200d-2640 {
    background-position: 13.333% 23.333%;
}
.emoji-1f3c3-200d-2642 {
    background-position: 13.333% 33.333%;
}
.emoji-1f3c3 {
    background-position: 13.333% 43.333%;
}
.emoji-1f3c4-200d-2640 {
    background-position: 13.333% 53.333%;
}
.emoji-1f3c4-200d-2642 {
    background-position: 13.333% 63.333%;
}
.emoji-1f3c4 {
    background-position: 13.333% 73.333%;
}
.emoji-1f3c5 {
    background-position: 13.333% 83.333%;
}
.emoji-1f3c6 {
    background-position: 13.333% 85.000%;
}
.emoji-1f3c7 {
    background-position: 13.333% 86.667%;
}
.emoji-1f3c8 {
    background-position: 13.333% 96.667%;
}
.emoji-1f3c9 {
    background-position: 13.333% 98.333%;
}
.emoji-1f3ca-200d-2640 {
    background-position: 13.333% 100.000%;
}
.emoji-1f3ca-200d-2642 {
    background-position: 15.000% 8.333%;
}
.emoji-1f3ca {
    background-position: 15.000% 18.333%;
}
.emoji-1f3cb-200d-2640 {
    background-position: 15.000% 28.333%;
}
.emoji-1f3cb-200d-2642 {
    background-position: 15.000% 38.333%;
}
.emoji-1f3cb {
    background-position: 15.000% 48.333%;
}
.emoji-1f3cc-200d-2640 {
    background-position: 15.000% 58.333%;
}
.emoji-1f3cc-200d-2642 {
    background-position: 15.000% 68.333%;
}
.emoji-1f3cc {
    background-position: 15.000% 78.333%;
}
.emoji-1f3cd {
    background-position: 15.000% 88.333%;
}
.emoji-1f3ce {
    background-position: 15.000% 90.000%;
}
.emoji-1f3cf {
    background-position: 15.000% 91.667%;
}
.emoji-1f3d0 {
    background-position: 15.000% 93.333%;
}
.emoji-1f3d1 {
    background-position: 15.000% 95.000%;
}
.emoji-1f3d2 {
    background-position: 15.000% 96.667%;
}
.emoji-1f3d3 {
    background-position: 15.000% 98.333%;
}
.emoji-1f3d4 {
    background-position: 15.000% 100.000%;
}
.emoji-1f3d5 {
    background-position: 16.667% 0.000%;
}
.emoji-1f3d6 {
    background-position: 16.667% 1.667%;
}
.emoji-1f3d7 {
    background-position: 16.667% 3.333%;
}
.emoji-1f3d8 {
    background-position: 16.667% 5.000%;
}
.emoji-1f3d9 {
    background-position: 16.667% 6.667%;
}
.emoji-1f3da {
    background-position: 16.667% 8.333%;
}
.emoji-1f3db {
    background-position: 16.667% 10.000%;
}
.emoji-1f3dc {
    background-position: 16.667% 11.667%;
}
.emoji-1f3dd {
    background-position: 16.667% 13.333%;
}
.emoji-1f3de {
    background-position: 16.667% 15.000%;
}
.emoji-1f3df {
    background-position: 16.667% 16.667%;
}
.emoji-1f3e0 {
    background-position: 16.667% 18.333%;
}
.emoji-1f3e1 {
    background-position: 16.667% 20.000%;
}
.emoji-1f3e2 {
    background-position: 16.667% 21.667%;
}
.emoji-1f3e3 {
    background-position: 16.667% 23.333%;
}
.emoji-1f3e4 {
    background-position: 16.667% 25.000%;
}
.emoji-1f3e5 {
    background-position: 16.667% 26.667%;
}
.emoji-1f3e6 {
    background-position: 16.667% 28.333%;
}
.emoji-1f3e7 {
    background-position: 16.667% 30.000%;
}
.emoji-1f3e8 {
    background-position: 16.667% 31.667%;
}
.emoji-1f3e9 {
    background-position: 16.667% 33.333%;
}
.emoji-1f3ea {
    background-position: 16.667% 35.000%;
}
.emoji-1f3eb {
    background-position: 16.667% 36.667%;
}
.emoji-1f3ec {
    background-position: 16.667% 38.333%;
}
.emoji-1f3ed {
    background-position: 16.667% 40.000%;
}
.emoji-1f3ee {
    background-position: 16.667% 41.667%;
}
.emoji-1f3ef {
    background-position: 16.667% 43.333%;
}
.emoji-1f3f0 {
    background-position: 16.667% 45.000%;
}
.emoji-1f3f3-200d-1f308 {
    background-position: 16.667% 46.667%;
}
.emoji-1f3f3-200d-26a7 {
    background-position: 16.667% 48.333%;
}
.emoji-1f3f3 {
    background-position: 16.667% 50.000%;
}
.emoji-1f3f4-200d-2620 {
    background-position: 16.667% 51.667%;
}
.emoji-1f3f4-e0067-e0062-e0065-e006e-e0067-e007f {
    background-position: 16.667% 53.333%;
}
.emoji-1f3f4-e0067-e0062-e0073-e0063-e0074-e007f {
    background-position: 16.667% 55.000%;
}
.emoji-1f3f4-e0067-e0062-e0077-e006c-e0073-e007f {
    background-position: 16.667% 56.667%;
}
.emoji-1f3f4 {
    background-position: 16.667% 58.333%;
}
.emoji-1f3f5 {
    background-position: 16.667% 60.000%;
}
.emoji-1f3f7 {
    background-position: 16.667% 61.667%;
}
.emoji-1f3f8 {
    background-position: 16.667% 63.333%;
}
.emoji-1f3f9 {
    background-position: 16.667% 65.000%;
}
.emoji-1f3fa {
    background-position: 16.667% 66.667%;
}
.emoji-1f3fb {
    background-position: 16.667% 68.333%;
}
.emoji-1f3fc {
    background-position: 16.667% 70.000%;
}
.emoji-1f3fd {
    background-position: 16.667% 71.667%;
}
.emoji-1f3fe {
    background-position: 16.667% 73.333%;
}
.emoji-1f3ff {
    background-position: 16.667% 75.000%;
}
.emoji-1f400 {
    background-position: 16.667% 76.667%;
}
.emoji-1f401 {
    background-position: 16.667% 78.333%;
}
.emoji-1f402 {
    background-position: 16.667% 80.000%;
}
.emoji-1f403 {
    background-position: 16.667% 81.667%;
}
.emoji-1f404 {
    background-position: 16.667% 83.333%;
}
.emoji-1f405 {
    background-position: 16.667% 85.000%;
}
.emoji-1f406 {
    background-position: 16.667% 86.667%;
}
.emoji-1f407 {
    background-position: 16.667% 88.333%;
}
.emoji-1f408-200d-2b1b {
    background-position: 16.667% 90.000%;
}
.emoji-1f408 {
    background-position: 16.667% 91.667%;
}
.emoji-1f409 {
    background-position: 16.667% 93.333%;
}
.emoji-1f40a {
    background-position: 16.667% 95.000%;
}
.emoji-1f40b {
    background-position: 16.667% 96.667%;
}
.emoji-1f40c {
    background-position: 16.667% 98.333%;
}
.emoji-1f40d {
    background-position: 16.667% 100.000%;
}
.emoji-1f40e {
    background-position: 18.333% 0.000%;
}
.emoji-1f40f {
    background-position: 18.333% 1.667%;
}
.emoji-1f410 {
    background-position: 18.333% 3.333%;
}
.emoji-1f411 {
    background-position: 18.333% 5.000%;
}
.emoji-1f412 {
    background-position: 18.333% 6.667%;
}
.emoji-1f413 {
    background-position: 18.333% 8.333%;
}
.emoji-1f414 {
    background-position: 18.333% 10.000%;
}
.emoji-1f415-200d-1f9ba {
    background-position: 18.333% 11.667%;
}
.emoji-1f415 {
    background-position: 18.333% 13.333%;
}
.emoji-1f416 {
    background-position: 18.333% 15.000%;
}
.emoji-1f417 {
    background-position: 18.333% 16.667%;
}
.emoji-1f418 {
    background-position: 18.333% 18.333%;
}
.emoji-1f419 {
    background-position: 18.333% 20.000%;
}
.emoji-1f41a {
    background-position: 18.333% 21.667%;
}
.emoji-1f41b {
    background-position: 18.333% 23.333%;
}
.emoji-1f41c {
    background-position: 18.333% 25.000%;
}
.emoji-1f41d {
    background-position: 18.333% 26.667%;
}
.emoji-1f41e {
    background-position: 18.333% 28.333%;
}
.emoji-1f41f {
    background-position: 18.333% 30.000%;
}
.emoji-1f420 {
    background-position: 18.333% 31.667%;
}
.emoji-1f421 {
    background-position: 18.333% 33.333%;
}
.emoji-1f422 {
    background-position: 18.333% 35.000%;
}
.emoji-1f423 {
    background-position: 18.333% 36.667%;
}
.emoji-1f424 {
    background-position: 18.333% 38.333%;
}
.emoji-1f425 {
    background-position: 18.333% 40.000%;
}
.emoji-1f426-200d-2b1b {
    background-position: 18.333% 41.667%;
}
.emoji-1f426 {
    background-position: 18.333% 43.333%;
}
.emoji-1f427 {
    background-position: 18.333% 45.000%;
}
.emoji-1f428 {
    background-position: 18.333% 46.667%;
}
.emoji-1f429 {
    background-position: 18.333% 48.333%;
}
.emoji-1f42a {
    background-position: 18.333% 50.000%;
}
.emoji-1f42b {
    background-position: 18.333% 51.667%;
}
.emoji-1f42c {
    background-position: 18.333% 53.333%;
}
.emoji-1f42d {
    background-position: 18.333% 55.000%;
}
.emoji-1f42e {
    background-position: 18.333% 56.667%;
}
.emoji-1f42f {
    background-position: 18.333% 58.333%;
}
.emoji-1f430 {
    background-position: 18.333% 60.000%;
}
.emoji-1f431 {
    background-position: 18.333% 61.667%;
}
.emoji-1f432 {
    background-position: 18.333% 63.333%;
}
.emoji-1f433 {
    background-position: 18.333% 65.000%;
}
.emoji-1f434 {
    background-position: 18.333% 66.667%;
}
.emoji-1f435 {
    background-position: 18.333% 68.333%;
}
.emoji-1f436 {
    background-position: 18.333% 70.000%;
}
.emoji-1f437 {
    background-position: 18.333% 71.667%;
}
.emoji-1f438 {
    background-position: 18.333% 73.333%;
}
.emoji-1f439 {
    background-position: 18.333% 75.000%;
}
.emoji-1f43a {
    background-position: 18.333% 76.667%;
}
.emoji-1f43b-200d-2744 {
    background-position: 18.333% 78.333%;
}
.emoji-1f43b {
    background-position: 18.333% 80.000%;
}
.emoji-1f43c {
    background-position: 18.333% 81.667%;
}
.emoji-1f43d {
    background-position: 18.333% 83.333%;
}
.emoji-1f43e {
    background-position: 18.333% 85.000%;
}
.emoji-1f43f {
    background-position: 18.333% 86.667%;
}
.emoji-1f440 {
    background-position: 18.333% 88.333%;
}
.emoji-1f441-200d-1f5e8 {
    background-position: 18.333% 90.000%;
}
.emoji-1f441 {
    background-position: 18.333% 91.667%;
}
.emoji-1f442 {
    background-position: 18.333% 93.333%;
}
.emoji-1f443 {
    background-position: 20.000% 1.667%;
}
.emoji-1f444 {
    background-position: 20.000% 11.667%;
}
.emoji-1f445 {
    background-position: 20.000% 13.333%;
}
.emoji-1f446 {
    background-position: 20.000% 15.000%;
}
.emoji-1f447 {
    background-position: 20.000% 25.000%;
}
.emoji-1f448 {
    background-position: 20.000% 35.000%;
}
.emoji-1f449 {
    background-position: 20.000% 45.000%;
}
.emoji-1f44a {
    background-position: 20.000% 55.000%;
}
.emoji-1f44b {
    background-position: 20.000% 65.000%;
}
.emoji-1f44c {
    background-position: 20.000% 75.000%;
}
.emoji-1f44d {
    background-position: 20.000% 85.000%;
}
.emoji-1f44e {
    background-position: 20.000% 95.000%;
}
.emoji-1f44f {
    background-position: 21.667% 3.333%;
}
.emoji-1f450 {
    background-position: 21.667% 13.333%;
}
.emoji-1f451 {
    background-position: 21.667% 23.333%;
}
.emoji-1f452 {
    background-position: 21.667% 25.000%;
}
.emoji-1f453 {
    background-position: 21.667% 26.667%;
}
.emoji-1f454 {
    background-position: 21.667% 28.333%;
}
.emoji-1f455 {
    background-position: 21.667% 30.000%;
}
.emoji-1f456 {
    background-position: 21.667% 31.667%;
}
.emoji-1f457 {
    background-position: 21.667% 33.333%;
}
.emoji-1f458 {
    background-position: 21.667% 35.000%;
}
.emoji-1f459 {
    background-position: 21.667% 36.667%;
}
.emoji-1f45a {
    background-position: 21.667% 38.333%;
}
.emoji-1f45b {
    background-position: 21.667% 40.000%;
}
.emoji-1f45c {
    background-position: 21.667% 41.667%;
}
.emoji-1f45d {
    background-position: 21.667% 43.333%;
}
.emoji-1f45e {
    background-position: 21.667% 45.000%;
}
.emoji-1f45f {
    background-position: 21.667% 46.667%;
}
.emoji-1f460 {
    background-position: 21.667% 48.333%;
}
.emoji-1f461 {
    background-position: 21.667% 50.000%;
}
.emoji-1f462 {
    background-position: 21.667% 51.667%;
}
.emoji-1f463 {
    background-position: 21.667% 53.333%;
}
.emoji-1f464 {
    background-position: 21.667% 55.000%;
}
.emoji-1f465 {
    background-position: 21.667% 56.667%;
}
.emoji-1f466 {
    background-position: 21.667% 58.333%;
}
.emoji-1f467 {
    background-position: 21.667% 68.333%;
}
.emoji-1f468-200d-1f33e {
    background-position: 21.667% 78.333%;
}
.emoji-1f468-200d-1f373 {
    background-position: 21.667% 88.333%;
}
.emoji-1f468-200d-1f37c {
    background-position: 21.667% 98.333%;
}
.emoji-1f468-200d-1f393 {
    background-position: 23.333% 6.667%;
}
.emoji-1f468-200d-1f3a4 {
    background-position: 23.333% 16.667%;
}
.emoji-1f468-200d-1f3a8 {
    background-position: 23.333% 26.667%;
}
.emoji-1f468-200d-1f3eb {
    background-position: 23.333% 36.667%;
}
.emoji-1f468-200d-1f3ed {
    background-position: 23.333% 46.667%;
}
.emoji-1f468-200d-1f466-200d-1f466 {
    background-position: 23.333% 56.667%;
}
.emoji-1f468-200d-1f466 {
    background-position: 23.333% 58.333%;
}
.emoji-1f468-200d-1f467-200d-1f466 {
    background-position: 23.333% 60.000%;
}
.emoji-1f468-200d-1f467-200d-1f467 {
    background-position: 23.333% 61.667%;
}
.emoji-1f468-200d-1f467 {
    background-position: 23.333% 63.333%;
}
.emoji-1f468-200d-1f468-200d-1f466 {
    background-position: 23.333% 65.000%;
}
.emoji-1f468-200d-1f468-200d-1f466-200d-1f466 {
    background-position: 23.333% 66.667%;
}
.emoji-1f468-200d-1f468-200d-1f467 {
    background-position: 23.333% 68.333%;
}
.emoji-1f468-200d-1f468-200d-1f467-200d-1f466 {
    background-position: 23.333% 70.000%;
}
.emoji-1f468-200d-1f468-200d-1f467-200d-1f467 {
    background-position: 23.333% 71.667%;
}
.emoji-1f468-200d-1f469-200d-1f466 {
    background-position: 23.333% 73.333%;
}
.emoji-1f468-200d-1f469-200d-1f466-200d-1f466 {
    background-position: 23.333% 75.000%;
}
.emoji-1f468-200d-1f469-200d-1f467 {
    background-position: 23.333% 76.667%;
}
.emoji-1f468-200d-1f469-200d-1f467-200d-1f466 {
    background-position: 23.333% 78.333%;
}
.emoji-1f468-200d-1f469-200d-1f467-200d-1f467 {
    background-position: 23.333% 80.000%;
}
.emoji-1f468-200d-1f4bb {
    background-position: 23.333% 81.667%;
}
.emoji-1f468-200d-1f4bc {
    background-position: 23.333% 91.667%;
}
.emoji-1f468-200d-1f527 {
    background-position: 25.000% 0.000%;
}
.emoji-1f468-200d-1f52c {
    background-position: 25.000% 10.000%;
}
.emoji-1f468-200d-1f680 {
    background-position: 25.000% 20.000%;
}
.emoji-1f468-200d-1f692 {
    background-position: 25.000% 30.000%;
}
.emoji-1f468-200d-1f9af {
    background-position: 25.000% 40.000%;
}
.emoji-1f468-200d-1f9b0 {
    background-position: 25.000% 50.000%;
}
.emoji-1f468-200d-1f9b1 {
    background-position: 25.000% 60.000%;
}
.emoji-1f468-200d-1f9b2 {
    background-position: 25.000% 70.000%;
}
.emoji-1f468-200d-1f9b3 {
    background-position: 25.000% 80.000%;
}
.emoji-1f468-200d-1f9bc {
    background-position: 25.000% 90.000%;
}
.emoji-1f468-200d-1f9bd {
    background-position: 25.000% 100.000%;
}
.emoji-1f468-200d-2695 {
    background-position: 26.667% 8.333%;
}
.emoji-1f468-200d-2696 {
    background-position: 26.667% 18.333%;
}
.emoji-1f468-200d-2708 {
    background-position: 26.667% 28.333%;
}
.emoji-1f468-200d-2764-200d-1f468 {
    background-position: 26.667% 38.333%;
}
.emoji-1f468-200d-2764-200d-1f48b-200d-1f468 {
    background-position: 26.667% 81.667%;
}
.emoji-1f468 {
    background-position: 28.333% 23.333%;
}
.emoji-1f469-200d-1f33e {
    background-position: 28.333% 33.333%;
}
.emoji-1f469-200d-1f373 {
    background-position: 28.333% 43.333%;
}
.emoji-1f469-200d-1f37c {
    background-position: 28.333% 53.333%;
}
.emoji-1f469-200d-1f393 {
    background-position: 28.333% 63.333%;
}
.emoji-1f469-200d-1f3a4 {
    background-position: 28.333% 73.333%;
}
.emoji-1f469-200d-1f3a8 {
    background-position: 28.333% 83.333%;
}
.emoji-1f469-200d-1f3eb {
    background-position: 28.333% 93.333%;
}
.emoji-1f469-200d-1f3ed {
    background-position: 30.000% 1.667%;
}
.emoji-1f469-200d-1f466-200d-1f466 {
    background-position: 30.000% 11.667%;
}
.emoji-1f469-200d-1f466 {
    background-position: 30.000% 13.333%;
}
.emoji-1f469-200d-1f467-200d-1f466 {
    background-position: 30.000% 15.000%;
}
.emoji-1f469-200d-1f467-200d-1f467 {
    background-position: 30.000% 16.667%;
}
.emoji-1f469-200d-1f467 {
    background-position: 30.000% 18.333%;
}
.emoji-1f469-200d-1f469-200d-1f466 {
    background-position: 30.000% 20.000%;
}
.emoji-1f469-200d-1f469-200d-1f466-200d-1f466 {
    background-position: 30.000% 21.667%;
}
.emoji-1f469-200d-1f469-200d-1f467 {
    background-position: 30.000% 23.333%;
}
.emoji-1f469-200d-1f469-200d-1f467-200d-1f466 {
    background-position: 30.000% 25.000%;
}
.emoji-1f469-200d-1f469-200d-1f467-200d-1f467 {
    background-position: 30.000% 26.667%;
}
.emoji-1f469-200d-1f4bb {
    background-position: 30.000% 28.333%;
}
.emoji-1f469-200d-1f4bc {
    background-position: 30.000% 38.333%;
}
.emoji-1f469-200d-1f527 {
    background-position: 30.000% 48.333%;
}
.emoji-1f469-200d-1f52c {
    background-position: 30.000% 58.333%;
}
.emoji-1f469-200d-1f680 {
    background-position: 30.000% 68.333%;
}
.emoji-1f469-200d-1f692 {
    background-position: 30.000% 78.333%;
}
.emoji-1f469-200d-1f9af {
    background-position: 30.000% 88.333%;
}
.emoji-1f469-200d-1f9b0 {
    background-position: 30.000% 98.333%;
}
.emoji-1f469-200d-1f9b1 {
    background-position: 31.667% 6.667%;
}
.emoji-1f469-200d-1f9b2 {
    background-position: 31.667% 16.667%;
}
.emoji-1f469-200d-1f9b3 {
    background-position: 31.667% 26.667%;
}
.emoji-1f469-200d-1f9bc {
    background-position: 31.667% 36.667%;
}
.emoji-1f469-200d-1f9bd {
    background-position: 31.667% 46.667%;
}
.emoji-1f469-200d-2695 {
    background-position: 31.667% 56.667%;
}
.emoji-1f469-200d-2696 {
    background-position: 31.667% 66.667%;
}
.emoji-1f469-200d-2708 {
    background-position: 31.667% 76.667%;
}
.emoji-1f469-200d-2764-200d-1f468 {
    background-position: 31.667% 86.667%;
}
.emoji-1f469-200d-2764-200d-1f469 {
    background-position: 33.333% 28.333%;
}
.emoji-1f469-200d-2764-200d-1f48b-200d-1f468 {
    background-position: 33.333% 71.667%;
}
.emoji-1f469-200d-2764-200d-1f48b-200d-1f469 {
    background-position: 35.000% 13.333%;
}
.emoji-1f469 {
    background-position: 35.000% 56.667%;
}
.emoji-1f46a {
    background-position: 35.000% 66.667%;
}
.emoji-1f46b {
    background-position: 35.000% 68.333%;
}
.emoji-1f46c {
    background-position: 36.667% 10.000%;
}
.emoji-1f46d {
    background-position: 36.667% 53.333%;
}
.emoji-1f46e-200d-2640 {
    background-position: 36.667% 96.667%;
}
.emoji-1f46e-200d-2642 {
    background-position: 38.333% 5.000%;
}
.emoji-1f46e {
    background-position: 38.333% 15.000%;
}
.emoji-1f46f-200d-2640 {
    background-position: 38.333% 25.000%;
}
.emoji-1f46f-200d-2642 {
    background-position: 38.333% 26.667%;
}
.emoji-1f46f {
    background-position: 38.333% 28.333%;
}
.emoji-1f470-200d-2640 {
    background-position: 38.333% 30.000%;
}
.emoji-1f470-200d-2642 {
    background-position: 38.333% 40.000%;
}
.emoji-1f470 {
    background-position: 38.333% 50.000%;
}
.emoji-1f471-200d-2640 {
    background-position: 38.333% 60.000%;
}
.emoji-1f471-200d-2642 {
    background-position: 38.333% 70.000%;
}
.emoji-1f471 {
    background-position: 38.333% 80.000%;
}
.emoji-1f472 {
    background-position: 38.333% 90.000%;
}
.emoji-1f473-200d-2640 {
    background-position: 38.333% 100.000%;
}
.emoji-1f473-200d-2642 {
    background-position: 40.000% 8.333%;
}
.emoji-1f473 {
    background-position: 40.000% 18.333%;
}
.emoji-1f474 {
    background-position: 40.000% 28.333%;
}
.emoji-1f475 {
    background-position: 40.000% 38.333%;
}
.emoji-1f476 {
    background-position: 40.000% 48.333%;
}
.emoji-1f477-200d-2640 {
    background-position: 40.000% 58.333%;
}
.emoji-1f477-200d-2642 {
    background-position: 40.000% 68.333%;
}
.emoji-1f477 {
    background-position: 40.000% 78.333%;
}
.emoji-1f478 {
    background-position: 40.000% 88.333%;
}
.emoji-1f479 {
    background-position: 40.000% 98.333%;
}
.emoji-1f47a {
    background-position: 40.000% 100.000%;
}
.emoji-1f47b {
    background-position: 41.667% 0.000%;
}
.emoji-1f47c {
    background-position: 41.667% 1.667%;
}
.emoji-1f47d {
    background-position: 41.667% 11.667%;
}
.emoji-1f47e {
    background-position: 41.667% 13.333%;
}
.emoji-1f47f {
    background-position: 41.667% 15.000%;
}
.emoji-1f480 {
    background-position: 41.667% 16.667%;
}
.emoji-1f481-200d-2640 {
    background-position: 41.667% 18.333%;
}
.emoji-1f481-200d-2642 {
    background-position: 41.667% 28.333%;
}
.emoji-1f481 {
    background-position: 41.667% 38.333%;
}
.emoji-1f482-200d-2640 {
    background-position: 41.667% 48.333%;
}
.emoji-1f482-200d-2642 {
    background-position: 41.667% 58.333%;
}
.emoji-1f482 {
    background-position: 41.667% 68.333%;
}
.emoji-1f483 {
    background-position: 41.667% 78.333%;
}
.emoji-1f484 {
    background-position: 41.667% 88.333%;
}
.emoji-1f485 {
    background-position: 41.667% 90.000%;
}
.emoji-1f486-200d-2640 {
    background-position: 41.667% 100.000%;
}
.emoji-1f486-200d-2642 {
    background-position: 43.333% 8.333%;
}
.emoji-1f486 {
    background-position: 43.333% 18.333%;
}
.emoji-1f487-200d-2640 {
    background-position: 43.333% 28.333%;
}
.emoji-1f487-200d-2642 {
    background-position: 43.333% 38.333%;
}
.emoji-1f487 {
    background-position: 43.333% 48.333%;
}
.emoji-1f488 {
    background-position: 43.333% 58.333%;
}
.emoji-1f489 {
    background-position: 43.333% 60.000%;
}
.emoji-1f48a {
    background-position: 43.333% 61.667%;
}
.emoji-1f48b {
    background-position: 43.333% 63.333%;
}
.emoji-1f48c {
    background-position: 43.333% 65.000%;
}
.emoji-1f48d {
    background-position: 43.333% 66.667%;
}
.emoji-1f48e {
    background-position: 43.333% 68.333%;
}
.emoji-1f48f {
    background-position: 43.333% 70.000%;
}
.emoji-1f490 {
    background-position: 45.000% 11.667%;
}
.emoji-1f491 {
    background-position: 45.000% 13.333%;
}
.emoji-1f492 {
    background-position: 45.000% 56.667%;
}
.emoji-1f493 {
    background-position: 45.000% 58.333%;
}
.emoji-1f494 {
    background-position: 45.000% 60.000%;
}
.emoji-1f495 {
    background-position: 45.000% 61.667%;
}
.emoji-1f496 {
    background-position: 45.000% 63.333%;
}
.emoji-1f497 {
    background-position: 45.000% 65.000%;
}
.emoji-1f498 {
    background-position: 45.000% 66.667%;
}
.emoji-1f499 {
    background-position: 45.000% 68.333%;
}
.emoji-1f49a {
    background-position: 45.000% 70.000%;
}
.emoji-1f49b {
    background-position: 45.000% 71.667%;
}
.emoji-1f49c {
    background-position: 45.000% 73.333%;
}
.emoji-1f49d {
    background-position: 45.000% 75.000%;
}
.emoji-1f49e {
    background-position: 45.000% 76.667%;
}
.emoji-1f49f {
    background-position: 45.000% 78.333%;
}
.emoji-1f4a0 {
    background-position: 45.000% 80.000%;
}
.emoji-1f4a1 {
    background-position: 45.000% 81.667%;
}
.emoji-1f4a2 {
    background-position: 45.000% 83.333%;
}
.emoji-1f4a3 {
    background-position: 45.000% 85.000%;
}
.emoji-1f4a4 {
    background-position: 45.000% 86.667%;
}
.emoji-1f4a5 {
    background-position: 45.000% 88.333%;
}
.emoji-1f4a6 {
    background-position: 45.000% 90.000%;
}
.emoji-1f4a7 {
    background-position: 45.000% 91.667%;
}
.emoji-1f4a8 {
    background-position: 45.000% 93.333%;
}
.emoji-1f4a9 {
    background-position: 45.000% 95.000%;
}
.emoji-1f4aa {
    background-position: 45.000% 96.667%;
}
.emoji-1f4ab {
    background-position: 46.667% 5.000%;
}
.emoji-1f4ac {
    background-position: 46.667% 6.667%;
}
.emoji-1f4ad {
    background-position: 46.667% 8.333%;
}
.emoji-1f4ae {
    background-position: 46.667% 10.000%;
}
.emoji-1f4af {
    background-position: 46.667% 11.667%;
}
.emoji-1f4b0 {
    background-position: 46.667% 13.333%;
}
.emoji-1f4b1 {
    background-position: 46.667% 15.000%;
}
.emoji-1f4b2 {
    background-position: 46.667% 16.667%;
}
.emoji-1f4b3 {
    background-position: 46.667% 18.333%;
}
.emoji-1f4b4 {
    background-position: 46.667% 20.000%;
}
.emoji-1f4b5 {
    background-position: 46.667% 21.667%;
}
.emoji-1f4b6 {
    background-position: 46.667% 23.333%;
}
.emoji-1f4b7 {
    background-position: 46.667% 25.000%;
}
.emoji-1f4b8 {
    background-position: 46.667% 26.667%;
}
.emoji-1f4b9 {
    background-position: 46.667% 28.333%;
}
.emoji-1f4ba {
    background-position: 46.667% 30.000%;
}
.emoji-1f4bb {
    background-position: 46.667% 31.667%;
}
.emoji-1f4bc {
    background-position: 46.667% 33.333%;
}
.emoji-1f4bd {
    background-position: 46.667% 35.000%;
}
.emoji-1f4be {
    background-position: 46.667% 36.667%;
}
.emoji-1f4bf {
    background-position: 46.667% 38.333%;
}
.emoji-1f4c0 {
    background-position: 46.667% 40.000%;
}
.emoji-1f4c1 {
    background-position: 46.667% 41.667%;
}
.emoji-1f4c2 {
    background-position: 46.667% 43.333%;
}
.emoji-1f4c3 {
    background-position: 46.667% 45.000%;
}
.emoji-1f4c4 {
    background-position: 46.667% 46.667%;
}
.emoji-1f4c5 {
    background-position: 46.667% 48.333%;
}
.emoji-1f4c6 {
    background-position: 46.667% 50.000%;
}
.emoji-1f4c7 {
    background-position: 46.667% 51.667%;
}
.emoji-1f4c8 {
    background-position: 46.667% 53.333%;
}
.emoji-1f4c9 {
    background-position: 46.667% 55.000%;
}
.emoji-1f4ca {
    background-position: 46.667% 56.667%;
}
.emoji-1f4cb {
    background-position: 46.667% 58.333%;
}
.emoji-1f4cc {
    background-position: 46.667% 60.000%;
}
.emoji-1f4cd {
    background-position: 46.667% 61.667%;
}
.emoji-1f4ce {
    background-position: 46.667% 63.333%;
}
.emoji-1f4cf {
    background-position: 46.667% 65.000%;
}
.emoji-1f4d0 {
    background-position: 46.667% 66.667%;
}
.emoji-1f4d1 {
    background-position: 46.667% 68.333%;
}
.emoji-1f4d2 {
    background-position: 46.667% 70.000%;
}
.emoji-1f4d3 {
    background-position: 46.667% 71.667%;
}
.emoji-1f4d4 {
    background-position: 46.667% 73.333%;
}
.emoji-1f4d5 {
    background-position: 46.667% 75.000%;
}
.emoji-1f4d6 {
    background-position: 46.667% 76.667%;
}
.emoji-1f4d7 {
    background-position: 46.667% 78.333%;
}
.emoji-1f4d8 {
    background-position: 46.667% 80.000%;
}
.emoji-1f4d9 {
    background-position: 46.667% 81.667%;
}
.emoji-1f4da {
    background-position: 46.667% 83.333%;
}
.emoji-1f4db {
    background-position: 46.667% 85.000%;
}
.emoji-1f4dc {
    background-position: 46.667% 86.667%;
}
.emoji-1f4dd {
    background-position: 46.667% 88.333%;
}
.emoji-1f4de {
    background-position: 46.667% 90.000%;
}
.emoji-1f4df {
    background-position: 46.667% 91.667%;
}
.emoji-1f4e0 {
    background-position: 46.667% 93.333%;
}
.emoji-1f4e1 {
    background-position: 46.667% 95.000%;
}
.emoji-1f4e2 {
    background-position: 46.667% 96.667%;
}
.emoji-1f4e3 {
    background-position: 46.667% 98.333%;
}
.emoji-1f4e4 {
    background-position: 46.667% 100.000%;
}
.emoji-1f4e5 {
    background-position: 48.333% 0.000%;
}
.emoji-1f4e6 {
    background-position: 48.333% 1.667%;
}
.emoji-1f4e7 {
    background-position: 48.333% 3.333%;
}
.emoji-1f4e8 {
    background-position: 48.333% 5.000%;
}
.emoji-1f4e9 {
    background-position: 48.333% 6.667%;
}
.emoji-1f4ea {
    background-position: 48.333% 8.333%;
}
.emoji-1f4eb {
    background-position: 48.333% 10.000%;
}
.emoji-1f4ec {
    background-position: 48.333% 11.667%;
}
.emoji-1f4ed {
    background-position: 48.333% 13.333%;
}
.emoji-1f4ee {
    background-position: 48.333% 15.000%;
}
.emoji-1f4ef {
    background-position: 48.333% 16.667%;
}
.emoji-1f4f0 {
    background-position: 48.333% 18.333%;
}
.emoji-1f4f1 {
    background-position: 48.333% 20.000%;
}
.emoji-1f4f2 {
    background-position: 48.333% 21.667%;
}
.emoji-1f4f3 {
    background-position: 48.333% 23.333%;
}
.emoji-1f4f4 {
    background-position: 48.333% 25.000%;
}
.emoji-1f4f5 {
    background-position: 48.333% 26.667%;
}
.emoji-1f4f6 {
    background-position: 48.333% 28.333%;
}
.emoji-1f4f7 {
    background-position: 48.333% 30.000%;
}
.emoji-1f4f8 {
    background-position: 48.333% 31.667%;
}
.emoji-1f4f9 {
    background-position: 48.333% 33.333%;
}
.emoji-1f4fa {
    background-position: 48.333% 35.000%;
}
.emoji-1f4fb {
    background-position: 48.333% 36.667%;
}
.emoji-1f4fc {
    background-position: 48.333% 38.333%;
}
.emoji-1f4fd {
    background-position: 48.333% 40.000%;
}
.emoji-1f4ff {
    background-position: 48.333% 41.667%;
}
.emoji-1f500 {
    background-position: 48.333% 43.333%;
}
.emoji-1f501 {
    background-position: 48.333% 45.000%;
}
.emoji-1f502 {
    background-position: 48.333% 46.667%;
}
.emoji-1f503 {
    background-position: 48.333% 48.333%;
}
.emoji-1f504 {
    background-position: 48.333% 50.000%;
}
.emoji-1f505 {
    background-position: 48.333% 51.667%;
}
.emoji-1f506 {
    background-position: 48.333% 53.333%;
}
.emoji-1f507 {
    background-position: 48.333% 55.000%;
}
.emoji-1f508 {
    background-position: 48.333% 56.667%;
}
.emoji-1f509 {
    background-position: 48.333% 58.333%;
}
.emoji-1f50a {
    background-position: 48.333% 60.000%;
}
.emoji-1f50b {
    background-position: 48.333% 61.667%;
}
.emoji-1f50c {
    background-position: 48.333% 63.333%;
}
.emoji-1f50d {
    background-position: 48.333% 65.000%;
}
.emoji-1f50e {
    background-position: 48.333% 66.667%;
}
.emoji-1f50f {
    background-position: 48.333% 68.333%;
}
.emoji-1f510 {
    background-position: 48.333% 70.000%;
}
.emoji-1f511 {
    background-position: 48.333% 71.667%;
}
.emoji-1f512 {
    background-position: 48.333% 73.333%;
}
.emoji-1f513 {
    background-position: 48.333% 75.000%;
}
.emoji-1f514 {
    background-position: 48.333% 76.667%;
}
.emoji-1f515 {
    background-position: 48.333% 78.333%;
}
.emoji-1f516 {
    background-position: 48.333% 80.000%;
}
.emoji-1f517 {
    background-position: 48.333% 81.667%;
}
.emoji-1f518 {
    background-position: 48.333% 83.333%;
}
.emoji-1f519 {
    background-position: 48.333% 85.000%;
}
.emoji-1f51a {
    background-position: 48.333% 86.667%;
}
.emoji-1f51b {
    background-position: 48.333% 88.333%;
}
.emoji-1f51c {
    background-position: 48.333% 90.000%;
}
.emoji-1f51d {
    background-position: 48.333% 91.667%;
}
.emoji-1f51e {
    background-position: 48.333% 93.333%;
}
.emoji-1f51f {
    background-position: 48.333% 95.000%;
}
.emoji-1f520 {
    background-position: 48.333% 96.667%;
}
.emoji-1f521 {
    background-position: 48.333% 98.333%;
}
.emoji-1f522 {
    background-position: 48.333% 100.000%;
}
.emoji-1f523 {
    background-position: 50.000% 0.000%;
}
.emoji-1f524 {
    background-position: 50.000% 1.667%;
}
.emoji-1f525 {
    background-position: 50.000% 3.333%;
}
.emoji-1f526 {
    background-position: 50.000% 5.000%;
}
.emoji-1f527 {
    background-position: 50.000% 6.667%;
}
.emoji-1f528 {
    background-position: 50.000% 8.333%;
}
.emoji-1f529 {
    background-position: 50.000% 10.000%;
}
.emoji-1f52a {
    background-position: 50.000% 11.667%;
}
.emoji-1f52b {
    background-position: 50.000% 13.333%;
}
.emoji-1f52c {
    background-position: 50.000% 15.000%;
}
.emoji-1f52d {
    background-position: 50.000% 16.667%;
}
.emoji-1f52e {
    background-position: 50.000% 18.333%;
}
.emoji-1f52f {
    background-position: 50.000% 20.000%;
}
.emoji-1f530 {
    background-position: 50.000% 21.667%;
}
.emoji-1f531 {
    background-position: 50.000% 23.333%;
}
.emoji-1f532 {
    background-position: 50.000% 25.000%;
}
.emoji-1f533 {
    background-position: 50.000% 26.667%;
}
.emoji-1f534 {
    background-position: 50.000% 28.333%;
}
.emoji-1f535 {
    background-position: 50.000% 30.000%;
}
.emoji-1f536 {
    background-position: 50.000% 31.667%;
}
.emoji-1f537 {
    background-position: 50.000% 33.333%;
}
.emoji-1f538 {
    background-position: 50.000% 35.000%;
}
.emoji-1f539 {
    background-position: 50.000% 36.667%;
}
.emoji-1f53a {
    background-position: 50.000% 38.333%;
}
.emoji-1f53b {
    background-position: 50.000% 40.000%;
}
.emoji-1f53c {
    background-position: 50.000% 41.667%;
}
.emoji-1f53d {
    background-position: 50.000% 43.333%;
}
.emoji-1f549 {
    background-position: 50.000% 45.000%;
}
.emoji-1f54a {
    background-position: 50.000% 46.667%;
}
.emoji-1f54b {
    background-position: 50.000% 48.333%;
}
.emoji-1f54c {
    background-position: 50.000% 50.000%;
}
.emoji-1f54d {
    background-position: 50.000% 51.667%;
}
.emoji-1f54e {
    background-position: 50.000% 53.333%;
}
.emoji-1f550 {
    background-position: 50.000% 55.000%;
}
.emoji-1f551 {
    background-position: 50.000% 56.667%;
}
.emoji-1f552 {
    background-position: 50.000% 58.333%;
}
.emoji-1f553 {
    background-position: 50.000% 60.000%;
}
.emoji-1f554 {
    background-position: 50.000% 61.667%;
}
.emoji-1f555 {
    background-position: 50.000% 63.333%;
}
.emoji-1f556 {
    background-position: 50.000% 65.000%;
}
.emoji-1f557 {
    background-position: 50.000% 66.667%;
}
.emoji-1f558 {
    background-position: 50.000% 68.333%;
}
.emoji-1f559 {
    background-position: 50.000% 70.000%;
}
.emoji-1f55a {
    background-position: 50.000% 71.667%;
}
.emoji-1f55b {
    background-position: 50.000% 73.333%;
}
.emoji-1f55c {
    background-position: 50.000% 75.000%;
}
.emoji-1f55d {
    background-position: 50.000% 76.667%;
}
.emoji-1f55e {
    background-position: 50.000% 78.333%;
}
.emoji-1f55f {
    background-position: 50.000% 80.000%;
}
.emoji-1f560 {
    background-position: 50.000% 81.667%;
}
.emoji-1f561 {
    background-position: 50.000% 83.333%;
}
.emoji-1f562 {
    background-position: 50.000% 85.000%;
}
.emoji-1f563 {
    background-position: 50.000% 86.667%;
}
.emoji-1f564 {
    background-position: 50.000% 88.333%;
}
.emoji-1f565 {
    background-position: 50.000% 90.000%;
}
.emoji-1f566 {
    background-position: 50.000% 91.667%;
}
.emoji-1f567 {
    background-position: 50.000% 93.333%;
}
.emoji-1f56f {
    background-position: 50.000% 95.000%;
}
.emoji-1f570 {
    background-position: 50.000% 96.667%;
}
.emoji-1f573 {
    background-position: 50.000% 98.333%;
}
.emoji-1f574 {
    background-position: 50.000% 100.000%;
}
.emoji-1f575-200d-2640 {
    background-position: 51.667% 8.333%;
}
.emoji-1f575-200d-2642 {
    background-position: 51.667% 18.333%;
}
.emoji-1f575 {
    background-position: 51.667% 28.333%;
}
.emoji-1f576 {
    background-position: 51.667% 38.333%;
}
.emoji-1f577 {
    background-position: 51.667% 40.000%;
}
.emoji-1f578 {
    background-position: 51.667% 41.667%;
}
.emoji-1f579 {
    background-position: 51.667% 43.333%;
}
.emoji-1f57a {
    background-position: 51.667% 45.000%;
}
.emoji-1f587 {
    background-position: 51.667% 55.000%;
}
.emoji-1f58a {
    background-position: 51.667% 56.667%;
}
.emoji-1f58b {
    background-position: 51.667% 58.333%;
}
.emoji-1f58c {
    background-position: 51.667% 60.000%;
}
.emoji-1f58d {
    background-position: 51.667% 61.667%;
}
.emoji-1f590 {
    background-position: 51.667% 63.333%;
}
.emoji-1f595 {
    background-position: 51.667% 73.333%;
}
.emoji-1f596 {
    background-position: 51.667% 83.333%;
}
.emoji-1f5a4 {
    background-position: 51.667% 93.333%;
}
.emoji-1f5a5 {
    background-position: 51.667% 95.000%;
}
.emoji-1f5a8 {
    background-position: 51.667% 96.667%;
}
.emoji-1f5b1 {
    background-position: 51.667% 98.333%;
}
.emoji-1f5b2 {
    background-position: 51.667% 100.000%;
}
.emoji-1f5bc {
    background-position: 53.333% 0.000%;
}
.emoji-1f5c2 {
    background-position: 53.333% 1.667%;
}
.emoji-1f5c3 {
    background-position: 53.333% 3.333%;
}
.emoji-1f5c4 {
    background-position: 53.333% 5.000%;
}
.emoji-1f5d1 {
    background-position: 53.333% 6.667%;
}
.emoji-1f5d2 {
    background-position: 53.333% 8.333%;
}
.emoji-1f5d3 {
    background-position: 53.333% 10.000%;
}
.emoji-1f5dc {
    background-position: 53.333% 11.667%;
}
.emoji-1f5dd {
    background-position: 53.333% 13.333%;
}
.emoji-1f5de {
    background-position: 53.333% 15.000%;
}
.emoji-1f5e1 {
    background-position: 53.333% 16.667%;
}
.emoji-1f5e3 {
    background-position: 53.333% 18.333%;
}
.emoji-1f5e8 {
    background-position: 53.333% 20.000%;
}
.emoji-1f5ef {
    background-position: 53.333% 21.667%;
}
.emoji-1f5f3 {
    background-position: 53.333% 23.333%;
}
.emoji-1f5fa {
    background-position: 53.333% 25.000%;
}
.emoji-1f5fb {
    background-position: 53.333% 26.667%;
}
.emoji-1f5fc {
    background-position: 53.333% 28.333%;
}
.emoji-1f5fd {
    background-position: 53.333% 30.000%;
}
.emoji-1f5fe {
    background-position: 53.333% 31.667%;
}
.emoji-1f5ff {
    background-position: 53.333% 33.333%;
}
.emoji-1f600 {
    background-position: 53.333% 35.000%;
}
.emoji-1f601 {
    background-position: 53.333% 36.667%;
}
.emoji-1f602 {
    background-position: 53.333% 38.333%;
}
.emoji-1f603 {
    background-position: 53.333% 40.000%;
}
.emoji-1f604 {
    background-position: 53.333% 41.667%;
}
.emoji-1f605 {
    background-position: 53.333% 43.333%;
}
.emoji-1f606 {
    background-position: 53.333% 45.000%;
}
.emoji-1f607 {
    background-position: 53.333% 46.667%;
}
.emoji-1f608 {
    background-position: 53.333% 48.333%;
}
.emoji-1f609 {
    background-position: 53.333% 50.000%;
}
.emoji-1f60a {
    background-position: 53.333% 51.667%;
}
.emoji-1f60b {
    background-position: 53.333% 53.333%;
}
.emoji-1f60c {
    background-position: 53.333% 55.000%;
}
.emoji-1f60d {
    background-position: 53.333% 56.667%;
}
.emoji-1f60e {
    background-position: 53.333% 58.333%;
}
.emoji-1f60f {
    background-position: 53.333% 60.000%;
}
.emoji-1f610 {
    background-position: 53.333% 61.667%;
}
.emoji-1f611 {
    background-position: 53.333% 63.333%;
}
.emoji-1f612 {
    background-position: 53.333% 65.000%;
}
.emoji-1f613 {
    background-position: 53.333% 66.667%;
}
.emoji-1f614 {
    background-position: 53.333% 68.333%;
}
.emoji-1f615 {
    background-position: 53.333% 70.000%;
}
.emoji-1f616 {
    background-position: 53.333% 71.667%;
}
.emoji-1f617 {
    background-position: 53.333% 73.333%;
}
.emoji-1f618 {
    background-position: 53.333% 75.000%;
}
.emoji-1f619 {
    background-position: 53.333% 76.667%;
}
.emoji-1f61a {
    background-position: 53.333% 78.333%;
}
.emoji-1f61b {
    background-position: 53.333% 80.000%;
}
.emoji-1f61c {
    background-position: 53.333% 81.667%;
}
.emoji-1f61d {
    background-position: 53.333% 83.333%;
}
.emoji-1f61e {
    background-position: 53.333% 85.000%;
}
.emoji-1f61f {
    background-position: 53.333% 86.667%;
}
.emoji-1f620 {
    background-position: 53.333% 88.333%;
}
.emoji-1f621 {
    background-position: 53.333% 90.000%;
}
.emoji-1f622 {
    background-position: 53.333% 91.667%;
}
.emoji-1f623 {
    background-position: 53.333% 93.333%;
}
.emoji-1f624 {
    background-position: 53.333% 95.000%;
}
.emoji-1f625 {
    background-position: 53.333% 96.667%;
}
.emoji-1f626 {
    background-position: 53.333% 98.333%;
}
.emoji-1f627 {
    background-position: 53.333% 100.000%;
}
.emoji-1f628 {
    background-position: 55.000% 0.000%;
}
.emoji-1f629 {
    background-position: 55.000% 1.667%;
}
.emoji-1f62a {
    background-position: 55.000% 3.333%;
}
.emoji-1f62b {
    background-position: 55.000% 5.000%;
}
.emoji-1f62c {
    background-position: 55.000% 6.667%;
}
.emoji-1f62d {
    background-position: 55.000% 8.333%;
}
.emoji-1f62e-200d-1f4a8 {
    background-position: 55.000% 10.000%;
}
.emoji-1f62e {
    background-position: 55.000% 11.667%;
}
.emoji-1f62f {
    background-position: 55.000% 13.333%;
}
.emoji-1f630 {
    background-position: 55.000% 15.000%;
}
.emoji-1f631 {
    background-position: 55.000% 16.667%;
}
.emoji-1f632 {
    background-position: 55.000% 18.333%;
}
.emoji-1f633 {
    background-position: 55.000% 20.000%;
}
.emoji-1f634 {
    background-position: 55.000% 21.667%;
}
.emoji-1f635-200d-1f4ab {
    background-position: 55.000% 23.333%;
}
.emoji-1f635 {
    background-position: 55.000% 25.000%;
}
.emoji-1f636-200d-1f32b {
    background-position: 55.000% 26.667%;
}
.emoji-1f636 {
    background-position: 55.000% 28.333%;
}
.emoji-1f637 {
    background-position: 55.000% 30.000%;
}
.emoji-1f638 {
    background-position: 55.000% 31.667%;
}
.emoji-1f639 {
    background-position: 55.000% 33.333%;
}
.emoji-1f63a {
    background-position: 55.000% 35.000%;
}
.emoji-1f63b {
    background-position: 55.000% 36.667%;
}
.emoji-1f63c {
    background-position: 55.000% 38.333%;
}
.emoji-1f63d {
    background-position: 55.000% 40.000%;
}
.emoji-1f63e {
    background-position: 55.000% 41.667%;
}
.emoji-1f63f {
    background-position: 55.000% 43.333%;
}
.emoji-1f640 {
    background-position: 55.000% 45.000%;
}
.emoji-1f641 {
    background-position: 55.000% 46.667%;
}
.emoji-1f642 {
    background-position: 55.000% 48.333%;
}
.emoji-1f643 {
    background-position: 55.000% 50.000%;
}
.emoji-1f644 {
    background-position: 55.000% 51.667%;
}
.emoji-1f645-200d-2640 {
    background-position: 55.000% 53.333%;
}
.emoji-1f645-200d-2642 {
    background-position: 55.000% 63.333%;
}
.emoji-1f645 {
    background-position: 55.000% 73.333%;
}
.emoji-1f646-200d-2640 {
    background-position: 55.000% 83.333%;
}
.emoji-1f646-200d-2642 {
    background-position: 55.000% 93.333%;
}
.emoji-1f646 {
    background-position: 56.667% 1.667%;
}
.emoji-1f647-200d-2640 {
    background-position: 56.667% 11.667%;
}
.emoji-1f647-200d-2642 {
    background-position: 56.667% 21.667%;
}
.emoji-1f647 {
    background-position: 56.667% 31.667%;
}
.emoji-1f648 {
    background-position: 56.667% 41.667%;
}
.emoji-1f649 {
    background-position: 56.667% 43.333%;
}
.emoji-1f64a {
    background-position: 56.667% 45.000%;
}
.emoji-1f64b-200d-2640 {
    background-position: 56.667% 46.667%;
}
.emoji-1f64b-200d-2642 {
    background-position: 56.667% 56.667%;
}
.emoji-1f64b {
    background-position: 56.667% 66.667%;
}
.emoji-1f64c {
    background-position: 56.667% 76.667%;
}
.emoji-1f64d-200d-2640 {
    background-position: 56.667% 86.667%;
}
.emoji-1f64d-200d-2642 {
    background-position: 56.667% 96.667%;
}
.emoji-1f64d {
    background-position: 58.333% 5.000%;
}
.emoji-1f64e-200d-2640 {
    background-position: 58.333% 15.000%;
}
.emoji-1f64e-200d-2642 {
    background-position: 58.333% 25.000%;
}
.emoji-1f64e {
    background-position: 58.333% 35.000%;
}
.emoji-1f64f {
    background-position: 58.333% 45.000%;
}
.emoji-1f680 {
    background-position: 58.333% 55.000%;
}
.emoji-1f681 {
    background-position: 58.333% 56.667%;
}
.emoji-1f682 {
    background-position: 58.333% 58.333%;
}
.emoji-1f683 {
    background-position: 58.333% 60.000%;
}
.emoji-1f684 {
    background-position: 58.333% 61.667%;
}
.emoji-1f685 {
    background-position: 58.333% 63.333%;
}
.emoji-1f686 {
    background-position: 58.333% 65.000%;
}
.emoji-1f687 {
    background-position: 58.333% 66.667%;
}
.emoji-1f688 {
    background-position: 58.333% 68.333%;
}
.emoji-1f689 {
    background-position: 58.333% 70.000%;
}
.emoji-1f68a {
    background-position: 58.333% 71.667%;
}
.emoji-1f68b {
    background-position: 58.333% 73.333%;
}
.emoji-1f68c {
    background-position: 58.333% 75.000%;
}
.emoji-1f68d {
    background-position: 58.333% 76.667%;
}
.emoji-1f68e {
    background-position: 58.333% 78.333%;
}
.emoji-1f68f {
    background-position: 58.333% 80.000%;
}
.emoji-1f690 {
    background-position: 58.333% 81.667%;
}
.emoji-1f691 {
    background-position: 58.333% 83.333%;
}
.emoji-1f692 {
    background-position: 58.333% 85.000%;
}
.emoji-1f693 {
    background-position: 58.333% 86.667%;
}
.emoji-1f694 {
    background-position: 58.333% 88.333%;
}
.emoji-1f695 {
    background-position: 58.333% 90.000%;
}
.emoji-1f696 {
    background-position: 58.333% 91.667%;
}
.emoji-1f697 {
    background-position: 58.333% 93.333%;
}
.emoji-1f698 {
    background-position: 58.333% 95.000%;
}
.emoji-1f699 {
    background-position: 58.333% 96.667%;
}
.emoji-1f69a {
    background-position: 58.333% 98.333%;
}
.emoji-1f69b {
    background-position: 58.333% 100.000%;
}
.emoji-1f69c {
    background-position: 60.000% 0.000%;
}
.emoji-1f69d {
    background-position: 60.000% 1.667%;
}
.emoji-1f69e {
    background-position: 60.000% 3.333%;
}
.emoji-1f69f {
    background-position: 60.000% 5.000%;
}
.emoji-1f6a0 {
    background-position: 60.000% 6.667%;
}
.emoji-1f6a1 {
    background-position: 60.000% 8.333%;
}
.emoji-1f6a2 {
    background-position: 60.000% 10.000%;
}
.emoji-1f6a3-200d-2640 {
    background-position: 60.000% 11.667%;
}
.emoji-1f6a3-200d-2642 {
    background-position: 60.000% 21.667%;
}
.emoji-1f6a3 {
    background-position: 60.000% 31.667%;
}
.emoji-1f6a4 {
    background-position: 60.000% 41.667%;
}
.emoji-1f6a5 {
    background-position: 60.000% 43.333%;
}
.emoji-1f6a6 {
    background-position: 60.000% 45.000%;
}
.emoji-1f6a7 {
    background-position: 60.000% 46.667%;
}
.emoji-1f6a8 {
    background-position: 60.000% 48.333%;
}
.emoji-1f6a9 {
    background-position: 60.000% 50.000%;
}
.emoji-1f6aa {
    background-position: 60.000% 51.667%;
}
.emoji-1f6ab {
    background-position: 60.000% 53.333%;
}
.emoji-1f6ac {
    background-position: 60.000% 55.000%;
}
.emoji-1f6ad {
    background-position: 60.000% 56.667%;
}
.emoji-1f6ae {
    background-position: 60.000% 58.333%;
}
.emoji-1f6af {
    background-position: 60.000% 60.000%;
}
.emoji-1f6b0 {
    background-position: 60.000% 61.667%;
}
.emoji-1f6b1 {
    background-position: 60.000% 63.333%;
}
.emoji-1f6b2 {
    background-position: 60.000% 65.000%;
}
.emoji-1f6b3 {
    background-position: 60.000% 66.667%;
}
.emoji-1f6b4-200d-2640 {
    background-position: 60.000% 68.333%;
}
.emoji-1f6b4-200d-2642 {
    background-position: 60.000% 78.333%;
}
.emoji-1f6b4 {
    background-position: 60.000% 88.333%;
}
.emoji-1f6b5-200d-2640 {
    background-position: 60.000% 98.333%;
}
.emoji-1f6b5-200d-2642 {
    background-position: 61.667% 6.667%;
}
.emoji-1f6b5 {
    background-position: 61.667% 16.667%;
}
.emoji-1f6b6-200d-2640 {
    background-position: 61.667% 26.667%;
}
.emoji-1f6b6-200d-2642 {
    background-position: 61.667% 36.667%;
}
.emoji-1f6b6 {
    background-position: 61.667% 46.667%;
}
.emoji-1f6b7 {
    background-position: 61.667% 56.667%;
}
.emoji-1f6b8 {
    background-position: 61.667% 58.333%;
}
.emoji-1f6b9 {
    background-position: 61.667% 60.000%;
}
.emoji-1f6ba {
    background-position: 61.667% 61.667%;
}
.emoji-1f6bb {
    background-position: 61.667% 63.333%;
}
.emoji-1f6bc {
    background-position: 61.667% 65.000%;
}
.emoji-1f6bd {
    background-position: 61.667% 66.667%;
}
.emoji-1f6be {
    background-position: 61.667% 68.333%;
}
.emoji-1f6bf {
    background-position: 61.667% 70.000%;
}
.emoji-1f6c0 {
    background-position: 61.667% 71.667%;
}
.emoji-1f6c1 {
    background-position: 61.667% 81.667%;
}
.emoji-1f6c2 {
    background-position: 61.667% 83.333%;
}
.emoji-1f6c3 {
    background-position: 61.667% 85.000%;
}
.emoji-1f6c4 {
    background-position: 61.667% 86.667%;
}
.emoji-1f6c5 {
    background-position: 61.667% 88.333%;
}
.emoji-1f6cb {
    background-position: 61.667% 90.000%;
}
.emoji-1f6cc {
    background-position: 61.667% 91.667%;
}
.emoji-1f6cd {
    background-position: 63.333% 0.000%;
}
.emoji-1f6ce {
    background-position: 63.333% 1.667%;
}
.emoji-1f6cf {
    background-position: 63.333% 3.333%;
}
.emoji-1f6d0 {
    background-position: 63.333% 5.000%;
}
.emoji-1f6d1 {
    background-position: 63.333% 6.667%;
}
.emoji-1f6d2 {
    background-position: 63.333% 8.333%;
}
.emoji-1f6d5 {
    background-position: 63.333% 10.000%;
}
.emoji-1f6d6 {
    background-position: 63.333% 11.667%;
}
.emoji-1f6d7 {
    background-position: 63.333% 13.333%;
}
.emoji-1f6dc {
    background-position: 63.333% 15.000%;
}
.emoji-1f6dd {
    background-position: 63.333% 16.667%;
}
.emoji-1f6de {
    background-position: 63.333% 18.333%;
}
.emoji-1f6df {
    background-position: 63.333% 20.000%;
}
.emoji-1f6e0 {
    background-position: 63.333% 21.667%;
}
.emoji-1f6e1 {
    background-position: 63.333% 23.333%;
}
.emoji-1f6e2 {
    background-position: 63.333% 25.000%;
}
.emoji-1f6e3 {
    background-position: 63.333% 26.667%;
}
.emoji-1f6e4 {
    background-position: 63.333% 28.333%;
}
.emoji-1f6e5 {
    background-position: 63.333% 30.000%;
}
.emoji-1f6e9 {
    background-position: 63.333% 31.667%;
}
.emoji-1f6eb {
    background-position: 63.333% 33.333%;
}
.emoji-1f6ec {
    background-position: 63.333% 35.000%;
}
.emoji-1f6f0 {
    background-position: 63.333% 36.667%;
}
.emoji-1f6f3 {
    background-position: 63.333% 38.333%;
}
.emoji-1f6f4 {
    background-position: 63.333% 40.000%;
}
.emoji-1f6f5 {
    background-position: 63.333% 41.667%;
}
.emoji-1f6f6 {
    background-position: 63.333% 43.333%;
}
.emoji-1f6f7 {
    background-position: 63.333% 45.000%;
}
.emoji-1f6f8 {
    background-position: 63.333% 46.667%;
}
.emoji-1f6f9 {
    background-position: 63.333% 48.333%;
}
.emoji-1f6fa {
    background-position: 63.333% 50.000%;
}
.emoji-1f6fb {
    background-position: 63.333% 51.667%;
}
.emoji-1f6fc {
    background-position: 63.333% 53.333%;
}
.emoji-1f7e0 {
    background-position: 63.333% 55.000%;
}
.emoji-1f7e1 {
    background-position: 63.333% 56.667%;
}
.emoji-1f7e2 {
    background-position: 63.333% 58.333%;
}
.emoji-1f7e3 {
    background-position: 63.333% 60.000%;
}
.emoji-1f7e4 {
    background-position: 63.333% 61.667%;
}
.emoji-1f7e5 {
    background-position: 63.333% 63.333%;
}
.emoji-1f7e6 {
    background-position: 63.333% 65.000%;
}
.emoji-1f7e7 {
    background-position: 63.333% 66.667%;
}
.emoji-1f7e8 {
    background-position: 63.333% 68.333%;
}
.emoji-1f7e9 {
    background-position: 63.333% 70.000%;
}
.emoji-1f7ea {
    background-position: 63.333% 71.667%;
}
.emoji-1f7eb {
    background-position: 63.333% 73.333%;
}
.emoji-1f7f0 {
    background-position: 63.333% 75.000%;
}
.emoji-1f90c {
    background-position: 63.333% 76.667%;
}
.emoji-1f90d {
    background-position: 63.333% 86.667%;
}
.emoji-1f90e {
    background-position: 63.333% 88.333%;
}
.emoji-1f90f {
    background-position: 63.333% 90.000%;
}
.emoji-1f910 {
    background-position: 63.333% 100.000%;
}
.emoji-1f911 {
    background-position: 65.000% 0.000%;
}
.emoji-1f912 {
    background-position: 65.000% 1.667%;
}
.emoji-1f913 {
    background-position: 65.000% 3.333%;
}
.emoji-1f914 {
    background-position: 65.000% 5.000%;
}
.emoji-1f915 {
    background-position: 65.000% 6.667%;
}
.emoji-1f916 {
    background-position: 65.000% 8.333%;
}
.emoji-1f917 {
    background-position: 65.000% 10.000%;
}
.emoji-1f918 {
    background-position: 65.000% 11.667%;
}
.emoji-1f919 {
    background-position: 65.000% 21.667%;
}
.emoji-1f91a {
    background-position: 65.000% 31.667%;
}
.emoji-1f91b {
    background-position: 65.000% 41.667%;
}
.emoji-1f91c {
    background-position: 65.000% 51.667%;
}
.emoji-1f91d {
    background-position: 65.000% 61.667%;
}
.emoji-1f91e {
    background-position: 66.667% 3.333%;
}
.emoji-1f91f {
    background-position: 66.667% 13.333%;
}
.emoji-1f920 {
    background-position: 66.667% 23.333%;
}
.emoji-1f921 {
    background-position: 66.667% 25.000%;
}
.emoji-1f922 {
    background-position: 66.667% 26.667%;
}
.emoji-1f923 {
    background-position: 66.667% 28.333%;
}
.emoji-1f924 {
    background-position: 66.667% 30.000%;
}
.emoji-1f925 {
    background-position: 66.667% 31.667%;
}
.emoji-1f926-200d-2640 {
    background-position: 66.667% 33.333%;
}
.emoji-1f926-200d-2642 {
    background-position: 66.667% 43.333%;
}
.emoji-1f926 {
    background-position: 66.667% 53.333%;
}
.emoji-1f927 {
    background-position: 66.667% 63.333%;
}
.emoji-1f928 {
    background-position: 66.667% 65.000%;
}
.emoji-1f929 {
    background-position: 66.667% 66.667%;
}
.emoji-1f92a {
    background-position: 66.667% 68.333%;
}
.emoji-1f92b {
    background-position: 66.667% 70.000%;
}
.emoji-1f92c {
    background-position: 66.667% 71.667%;
}
.emoji-1f92d {
    background-position: 66.667% 73.333%;
}
.emoji-1f92e {
    background-position: 66.667% 75.000%;
}
.emoji-1f92f {
    background-position: 66.667% 76.667%;
}
.emoji-1f930 {
    background-position: 66.667% 78.333%;
}
.emoji-1f931 {
    background-position: 66.667% 88.333%;
}
.emoji-1f932 {
    background-position: 66.667% 98.333%;
}
.emoji-1f933 {
    background-position: 68.333% 6.667%;
}
.emoji-1f934 {
    background-position: 68.333% 16.667%;
}
.emoji-1f935-200d-2640 {
    background-position: 68.333% 26.667%;
}
.emoji-1f935-200d-2642 {
    background-position: 68.333% 36.667%;
}
.emoji-1f935 {
    background-position: 68.333% 46.667%;
}
.emoji-1f936 {
    background-position: 68.333% 56.667%;
}
.emoji-1f937-200d-2640 {
    background-position: 68.333% 66.667%;
}
.emoji-1f937-200d-2642 {
    background-position: 68.333% 76.667%;
}
.emoji-1f937 {
    background-position: 68.333% 86.667%;
}
.emoji-1f938-200d-2640 {
    background-position: 68.333% 96.667%;
}
.emoji-1f938-200d-2642 {
    background-position: 70.000% 5.000%;
}
.emoji-1f938 {
    background-position: 70.000% 15.000%;
}
.emoji-1f939-200d-2640 {
    background-position: 70.000% 25.000%;
}
.emoji-1f939-200d-2642 {
    background-position: 70.000% 35.000%;
}
.emoji-1f939 {
    background-position: 70.000% 45.000%;
}
.emoji-1f93a {
    background-position: 70.000% 55.000%;
}
.emoji-1f93c-200d-2640 {
    background-position: 70.000% 56.667%;
}
.emoji-1f93c-200d-2642 {
    background-position: 70.000% 58.333%;
}
.emoji-1f93c {
    background-position: 70.000% 60.000%;
}
.emoji-1f93d-200d-2640 {
    background-position: 70.000% 61.667%;
}
.emoji-1f93d-200d-2642 {
    background-position: 70.000% 71.667%;
}
.emoji-1f93d {
    background-position: 70.000% 81.667%;
}
.emoji-1f93e-200d-2640 {
    background-position: 70.000% 91.667%;
}
.emoji-1f93e-200d-2642 {
    background-position: 71.667% 0.000%;
}
.emoji-1f93e {
    background-position: 71.667% 10.000%;
}
.emoji-1f93f {
    background-position: 71.667% 20.000%;
}
.emoji-1f940 {
    background-position: 71.667% 21.667%;
}
.emoji-1f941 {
    background-position: 71.667% 23.333%;
}
.emoji-1f942 {
    background-position: 71.667% 25.000%;
}
.emoji-1f943 {
    background-position: 71.667% 26.667%;
}
.emoji-1f944 {
    background-position: 71.667% 28.333%;
}
.emoji-1f945 {
    background-position: 71.667% 30.000%;
}
.emoji-1f947 {
    background-position: 71.667% 31.667%;
}
.emoji-1f948 {
    background-position: 71.667% 33.333%;
}
.emoji-1f949 {
    background-position: 71.667% 35.000%;
}
.emoji-1f94a {
    background-position: 71.667% 36.667%;
}
.emoji-1f94b {
    background-position: 71.667% 38.333%;
}
.emoji-1f94c {
    background-position: 71.667% 40.000%;
}
.emoji-1f94d {
    background-position: 71.667% 41.667%;
}
.emoji-1f94e {
    background-position: 71.667% 43.333%;
}
.emoji-1f94f {
    background-position: 71.667% 45.000%;
}
.emoji-1f950 {
    background-position: 71.667% 46.667%;
}
.emoji-1f951 {
    background-position: 71.667% 48.333%;
}
.emoji-1f952 {
    background-position: 71.667% 50.000%;
}
.emoji-1f953 {
    background-position: 71.667% 51.667%;
}
.emoji-1f954 {
    background-position: 71.667% 53.333%;
}
.emoji-1f955 {
    background-position: 71.667% 55.000%;
}
.emoji-1f956 {
    background-position: 71.667% 56.667%;
}
.emoji-1f957 {
    background-position: 71.667% 58.333%;
}
.emoji-1f958 {
    background-position: 71.667% 60.000%;
}
.emoji-1f959 {
    background-position: 71.667% 61.667%;
}
.emoji-1f95a {
    background-position: 71.667% 63.333%;
}
.emoji-1f95b {
    background-position: 71.667% 65.000%;
}
.emoji-1f95c {
    background-position: 71.667% 66.667%;
}
.emoji-1f95d {
    background-position: 71.667% 68.333%;
}
.emoji-1f95e {
    background-position: 71.667% 70.000%;
}
.emoji-1f95f {
    background-position: 71.667% 71.667%;
}
.emoji-1f960 {
    background-position: 71.667% 73.333%;
}
.emoji-1f961 {
    background-position: 71.667% 75.000%;
}
.emoji-1f962 {
    background-position: 71.667% 76.667%;
}
.emoji-1f963 {
    background-position: 71.667% 78.333%;
}
.emoji-1f964 {
    background-position: 71.667% 80.000%;
}
.emoji-1f965 {
    background-position: 71.667% 81.667%;
}
.emoji-1f966 {
    background-position: 71.667% 83.333%;
}
.emoji-1f967 {
    background-position: 71.667% 85.000%;
}
.emoji-1f968 {
    background-position: 71.667% 86.667%;
}
.emoji-1f969 {
    background-position: 71.667% 88.333%;
}
.emoji-1f96a {
    background-position: 71.667% 90.000%;
}
.emoji-1f96b {
    background-position: 71.667% 91.667%;
}
.emoji-1f96c {
    background-position: 71.667% 93.333%;
}
.emoji-1f96d {
    background-position: 71.667% 95.000%;
}
.emoji-1f96e {
    background-position: 71.667% 96.667%;
}
.emoji-1f96f {
    background-position: 71.667% 98.333%;
}
.emoji-1f970 {
    background-position: 71.667% 100.000%;
}
.emoji-1f971 {
    background-position: 73.333% 0.000%;
}
.emoji-1f972 {
    background-position: 73.333% 1.667%;
}
.emoji-1f973 {
    background-position: 73.333% 3.333%;
}
.emoji-1f974 {
    background-position: 73.333% 5.000%;
}
.emoji-1f975 {
    background-position: 73.333% 6.667%;
}
.emoji-1f976 {
    background-position: 73.333% 8.333%;
}
.emoji-1f977 {
    background-position: 73.333% 10.000%;
}
.emoji-1f978 {
    background-position: 73.333% 20.000%;
}
.emoji-1f979 {
    background-position: 73.333% 21.667%;
}
.emoji-1f97a {
    background-position: 73.333% 23.333%;
}
.emoji-1f97b {
    background-position: 73.333% 25.000%;
}
.emoji-1f97c {
    background-position: 73.333% 26.667%;
}
.emoji-1f97d {
    background-position: 73.333% 28.333%;
}
.emoji-1f97e {
    background-position: 73.333% 30.000%;
}
.emoji-1f97f {
    background-position: 73.333% 31.667%;
}
.emoji-1f980 {
    background-position: 73.333% 33.333%;
}
.emoji-1f981 {
    background-position: 73.333% 35.000%;
}
.emoji-1f982 {
    background-position: 73.333% 36.667%;
}
.emoji-1f983 {
    background-position: 73.333% 38.333%;
}
.emoji-1f984 {
    background-position: 73.333% 40.000%;
}
.emoji-1f985 {
    background-position: 73.333% 41.667%;
}
.emoji-1f986 {
    background-position: 73.333% 43.333%;
}
.emoji-1f987 {
    background-position: 73.333% 45.000%;
}
.emoji-1f988 {
    background-position: 73.333% 46.667%;
}
.emoji-1f989 {
    background-position: 73.333% 48.333%;
}
.emoji-1f98a {
    background-position: 73.333% 50.000%;
}
.emoji-1f98b {
    background-position: 73.333% 51.667%;
}
.emoji-1f98c {
    background-position: 73.333% 53.333%;
}
.emoji-1f98d {
    background-position: 73.333% 55.000%;
}
.emoji-1f98e {
    background-position: 73.333% 56.667%;
}
.emoji-1f98f {
    background-position: 73.333% 58.333%;
}
.emoji-1f990 {
    background-position: 73.333% 60.000%;
}
.emoji-1f991 {
    background-position: 73.333% 61.667%;
}
.emoji-1f992 {
    background-position: 73.333% 63.333%;
}
.emoji-1f993 {
    background-position: 73.333% 65.000%;
}
.emoji-1f994 {
    background-position: 73.333% 66.667%;
}
.emoji-1f995 {
    background-position: 73.333% 68.333%;
}
.emoji-1f996 {
    background-position: 73.333% 70.000%;
}
.emoji-1f997 {
    background-position: 73.333% 71.667%;
}
.emoji-1f998 {
    background-position: 73.333% 73.333%;
}
.emoji-1f999 {
    background-position: 73.333% 75.000%;
}
.emoji-1f99a {
    background-position: 73.333% 76.667%;
}
.emoji-1f99b {
    background-position: 73.333% 78.333%;
}
.emoji-1f99c {
    background-position: 73.333% 80.000%;
}
.emoji-1f99d {
    background-position: 73.333% 81.667%;
}
.emoji-1f99e {
    background-position: 73.333% 83.333%;
}
.emoji-1f99f {
    background-position: 73.333% 85.000%;
}
.emoji-1f9a0 {
    background-position: 73.333% 86.667%;
}
.emoji-1f9a1 {
    background-position: 73.333% 88.333%;
}
.emoji-1f9a2 {
    background-position: 73.333% 90.000%;
}
.emoji-1f9a3 {
    background-position: 73.333% 91.667%;
}
.emoji-1f9a4 {
    background-position: 73.333% 93.333%;
}
.emoji-1f9a5 {
    background-position: 73.333% 95.000%;
}
.emoji-1f9a6 {
    background-position: 73.333% 96.667%;
}
.emoji-1f9a7 {
    background-position: 73.333% 98.333%;
}
.emoji-1f9a8 {
    background-position: 73.333% 100.000%;
}
.emoji-1f9a9 {
    background-position: 75.000% 0.000%;
}
.emoji-1f9aa {
    background-position: 75.000% 1.667%;
}
.emoji-1f9ab {
    background-position: 75.000% 3.333%;
}
.emoji-1f9ac {
    background-position: 75.000% 5.000%;
}
.emoji-1f9ad {
    background-position: 75.000% 6.667%;
}
.emoji-1f9ae {
    background-position: 75.000% 8.333%;
}
.emoji-1f9af {
    background-position: 75.000% 10.000%;
}
.emoji-1f9b4 {
    background-position: 75.000% 11.667%;
}
.emoji-1f9b5 {
    background-position: 75.000% 13.333%;
}
.emoji-1f9b6 {
    background-position: 75.000% 23.333%;
}
.emoji-1f9b7 {
    background-position: 75.000% 33.333%;
}
.emoji-1f9b8-200d-2640 {
    background-position: 75.000% 35.000%;
}
.emoji-1f9b8-200d-2642 {
    background-position: 75.000% 45.000%;
}
.emoji-1f9b8 {
    background-position: 75.000% 55.000%;
}
.emoji-1f9b9-200d-2640 {
    background-position: 75.000% 65.000%;
}
.emoji-1f9b9-200d-2642 {
    background-position: 75.000% 75.000%;
}
.emoji-1f9b9 {
    background-position: 75.000% 85.000%;
}
.emoji-1f9ba {
    background-position: 75.000% 95.000%;
}
.emoji-1f9bb {
    background-position: 75.000% 96.667%;
}
.emoji-1f9bc {
    background-position: 76.667% 5.000%;
}
.emoji-1f9bd {
    background-position: 76.667% 6.667%;
}
.emoji-1f9be {
    background-position: 76.667% 8.333%;
}
.emoji-1f9bf {
    background-position: 76.667% 10.000%;
}
.emoji-1f9c0 {
    background-position: 76.667% 11.667%;
}
.emoji-1f9c1 {
    background-position: 76.667% 13.333%;
}
.emoji-1f9c2 {
    background-position: 76.667% 15.000%;
}
.emoji-1f9c3 {
    background-position: 76.667% 16.667%;
}
.emoji-1f9c4 {
    background-position: 76.667% 18.333%;
}
.emoji-1f9c5 {
    background-position: 76.667% 20.000%;
}
.emoji-1f9c6 {
    background-position: 76.667% 21.667%;
}
.emoji-1f9c7 {
    background-position: 76.667% 23.333%;
}
.emoji-1f9c8 {
    background-position: 76.667% 25.000%;
}
.emoji-1f9c9 {
    background-position: 76.667% 26.667%;
}
.emoji-1f9ca {
    background-position: 76.667% 28.333%;
}
.emoji-1f9cb {
    background-position: 76.667% 30.000%;
}
.emoji-1f9cc {
    background-position: 76.667% 31.667%;
}
.emoji-1f9cd-200d-2640 {
    background-position: 76.667% 33.333%;
}
.emoji-1f9cd-200d-2642 {
    background-position: 76.667% 43.333%;
}
.emoji-1f9cd {
    background-position: 76.667% 53.333%;
}
.emoji-1f9ce-200d-2640 {
    background-position: 76.667% 63.333%;
}
.emoji-1f9ce-200d-2642 {
    background-position: 76.667% 73.333%;
}
.emoji-1f9ce {
    background-position: 76.667% 83.333%;
}
.emoji-1f9cf-200d-2640 {
    background-position: 76.667% 93.333%;
}
.emoji-1f9cf-200d-2642 {
    background-position: 78.333% 1.667%;
}
.emoji-1f9cf {
    background-position: 78.333% 11.667%;
}
.emoji-1f9d0 {
    background-position: 78.333% 21.667%;
}
.emoji-1f9d1-200d-1f33e {
    background-position: 78.333% 23.333%;
}
.emoji-1f9d1-200d-1f373 {
    background-position: 78.333% 33.333%;
}
.emoji-1f9d1-200d-1f37c {
    background-position: 78.333% 43.333%;
}
.emoji-1f9d1-200d-1f384 {
    background-position: 78.333% 53.333%;
}
.emoji-1f9d1-200d-1f393 {
    background-position: 78.333% 63.333%;
}
.emoji-1f9d1-200d-1f3a4 {
    background-position: 78.333% 73.333%;
}
.emoji-1f9d1-200d-1f3a8 {
    background-position: 78.333% 83.333%;
}
.emoji-1f9d1-200d-1f3eb {
    background-position: 78.333% 93.333%;
}
.emoji-1f9d1-200d-1f3ed {
    background-position: 80.000% 1.667%;
}
.emoji-1f9d1-200d-1f4bb {
    background-position: 80.000% 11.667%;
}
.emoji-1f9d1-200d-1f4bc {
    background-position: 80.000% 21.667%;
}
.emoji-1f9d1-200d-1f527 {
    background-position: 80.000% 31.667%;
}
.emoji-1f9d1-200d-1f52c {
    background-position: 80.000% 41.667%;
}
.emoji-1f9d1-200d-1f680 {
    background-position: 80.000% 51.667%;
}
.emoji-1f9d1-200d-1f692 {
    background-position: 80.000% 61.667%;
}
.emoji-1f9d1-200d-1f91d-200d-1f9d1 {
    background-position: 80.000% 71.667%;
}
.emoji-1f9d1-200d-1f9af {
    background-position: 81.667% 13.333%;
}
.emoji-1f9d1-200d-1f9b0 {
    background-position: 81.667% 23.333%;
}
.emoji-1f9d1-200d-1f9b1 {
    background-position: 81.667% 33.333%;
}
.emoji-1f9d1-200d-1f9b2 {
    background-position: 81.667% 43.333%;
}
.emoji-1f9d1-200d-1f9b3 {
    background-position: 81.667% 53.333%;
}
.emoji-1f9d1-200d-1f9bc {
    background-position: 81.667% 63.333%;
}
.emoji-1f9d1-200d-1f9bd {
    background-position: 81.667% 73.333%;
}
.emoji-1f9d1-200d-2695 {
    background-position: 81.667% 83.333%;
}
.emoji-1f9d1-200d-2696 {
    background-position: 81.667% 93.333%;
}
.emoji-1f9d1-200d-2708 {
    background-position: 83.333% 1.667%;
}
.emoji-1f9d1 {
    background-position: 83.333% 11.667%;
}
.emoji-1f9d2 {
    background-position: 83.333% 21.667%;
}
.emoji-1f9d3 {
    background-position: 83.333% 31.667%;
}
.emoji-1f9d4-200d-2640 {
    background-position: 83.333% 41.667%;
}
.emoji-1f9d4-200d-2642 {
    background-position: 83.333% 51.667%;
}
.emoji-1f9d4 {
    background-position: 83.333% 61.667%;
}
.emoji-1f9d5 {
    background-position: 83.333% 71.667%;
}
.emoji-1f9d6-200d-2640 {
    background-position: 83.333% 81.667%;
}
.emoji-1f9d6-200d-2642 {
    background-position: 83.333% 91.667%;
}
.emoji-1f9d6 {
    background-position: 85.000% 0.000%;
}
.emoji-1f9d7-200d-2640 {
    background-position: 85.000% 10.000%;
}
.emoji-1f9d7-200d-2642 {
    background-position: 85.000% 20.000%;
}
.emoji-1f9d7 {
    background-position: 85.000% 30.000%;
}
.emoji-1f9d8-200d-2640 {
    background-position: 85.000% 40.000%;
}
.emoji-1f9d8-200d-2642 {
    background-position: 85.000% 50.000%;
}
.emoji-1f9d8 {
    background-position: 85.000% 60.000%;
}
.emoji-1f9d9-200d-2640 {
    background-position: 85.000% 70.000%;
}
.emoji-1f9d9-200d-2642 {
    background-position: 85.000% 80.000%;
}
.emoji-1f9d9 {
    background-position: 85.000% 90.000%;
}
.emoji-1f9da-200d-2640 {
    background-position: 85.000% 100.000%;
}
.emoji-1f9da-200d-2642 {
    background-position: 86.667% 8.333%;
}
.emoji-1f9da {
    background-position: 86.667% 18.333%;
}
.emoji-1f9db-200d-2640 {
    background-position: 86.667% 28.333%;
}
.emoji-1f9db-200d-2642 {
    background-position: 86.667% 38.333%;
}
.emoji-1f9db {
    background-position: 86.667% 48.333%;
}
.emoji-1f9dc-200d-2640 {
    background-position: 86.667% 58.333%;
}
.emoji-1f9dc-200d-2642 {
    background-position: 86.667% 68.333%;
}
.emoji-1f9dc {
    background-position: 86.667% 78.333%;
}
.emoji-1f9dd-200d-2640 {
    background-position: 86.667% 88.333%;
}
.emoji-1f9dd-200d-2642 {
    background-position: 86.667% 98.333%;
}
.emoji-1f9dd {
    background-position: 88.333% 6.667%;
}
.emoji-1f9de-200d-2640 {
    background-position: 88.333% 16.667%;
}
.emoji-1f9de-200d-2642 {
    background-position: 88.333% 18.333%;
}
.emoji-1f9de {
    background-position: 88.333% 20.000%;
}
.emoji-1f9df-200d-2640 {
    background-position: 88.333% 21.667%;
}
.emoji-1f9df-200d-2642 {
    background-position: 88.333% 23.333%;
}
.emoji-1f9df {
    background-position: 88.333% 25.000%;
}
.emoji-1f9e0 {
    background-position: 88.333% 26.667%;
}
.emoji-1f9e1 {
    background-position: 88.333% 28.333%;
}
.emoji-1f9e2 {
    background-position: 88.333% 30.000%;
}
.emoji-1f9e3 {
    background-position: 88.333% 31.667%;
}
.emoji-1f9e4 {
    background-position: 88.333% 33.333%;
}
.emoji-1f9e5 {
    background-position: 88.333% 35.000%;
}
.emoji-1f9e6 {
    background-position: 88.333% 36.667%;
}
.emoji-1f9e7 {
    background-position: 88.333% 38.333%;
}
.emoji-1f9e8 {
    background-position: 88.333% 40.000%;
}
.emoji-1f9e9 {
    background-position: 88.333% 41.667%;
}
.emoji-1f9ea {
    background-position: 88.333% 43.333%;
}
.emoji-1f9eb {
    background-position: 88.333% 45.000%;
}
.emoji-1f9ec {
    background-position: 88.333% 46.667%;
}
.emoji-1f9ed {
    background-position: 88.333% 48.333%;
}
.emoji-1f9ee {
    background-position: 88.333% 50.000%;
}
.emoji-1f9ef {
    background-position: 88.333% 51.667%;
}
.emoji-1f9f0 {
    background-position: 88.333% 53.333%;
}
.emoji-1f9f1 {
    background-position: 88.333% 55.000%;
}
.emoji-1f9f2 {
    background-position: 88.333% 56.667%;
}
.emoji-1f9f3 {
    background-position: 88.333% 58.333%;
}
.emoji-1f9f4 {
    background-position: 88.333% 60.000%;
}
.emoji-1f9f5 {
    background-position: 88.333% 61.667%;
}
.emoji-1f9f6 {
    background-position: 88.333% 63.333%;
}
.emoji-1f9f7 {
    background-position: 88.333% 65.000%;
}
.emoji-1f9f8 {
    background-position: 88.333% 66.667%;
}
.emoji-1f9f9 {
    background-position: 88.333% 68.333%;
}
.emoji-1f9fa {
    background-position: 88.333% 70.000%;
}
.emoji-1f9fb {
    background-position: 88.333% 71.667%;
}
.emoji-1f9fc {
    background-position: 88.333% 73.333%;
}
.emoji-1f9fd {
    background-position: 88.333% 75.000%;
}
.emoji-1f9fe {
    background-position: 88.333% 76.667%;
}
.emoji-1f9ff {
    background-position: 88.333% 78.333%;
}
.emoji-1fa70 {
    background-position: 88.333% 80.000%;
}
.emoji-1fa71 {
    background-position: 88.333% 81.667%;
}
.emoji-1fa72 {
    background-position: 88.333% 83.333%;
}
.emoji-1fa73 {
    background-position: 88.333% 85.000%;
}
.emoji-1fa74 {
    background-position: 88.333% 86.667%;
}
.emoji-1fa75 {
    background-position: 88.333% 88.333%;
}
.emoji-1fa76 {
    background-position: 88.333% 90.000%;
}
.emoji-1fa77 {
    background-position: 88.333% 91.667%;
}
.emoji-1fa78 {
    background-position: 88.333% 93.333%;
}
.emoji-1fa79 {
    background-position: 88.333% 95.000%;
}
.emoji-1fa7a {
    background-position: 88.333% 96.667%;
}
.emoji-1fa7b {
    background-position: 88.333% 98.333%;
}
.emoji-1fa7c {
    background-position: 88.333% 100.000%;
}
.emoji-1fa80 {
    background-position: 90.000% 0.000%;
}
.emoji-1fa81 {
    background-position: 90.000% 1.667%;
}
.emoji-1fa82 {
    background-position: 90.000% 3.333%;
}
.emoji-1fa83 {
    background-position: 90.000% 5.000%;
}
.emoji-1fa84 {
    background-position: 90.000% 6.667%;
}
.emoji-1fa85 {
    background-position: 90.000% 8.333%;
}
.emoji-1fa86 {
    background-position: 90.000% 10.000%;
}
.emoji-1fa87 {
    background-position: 90.000% 11.667%;
}
.emoji-1fa88 {
    background-position: 90.000% 13.333%;
}
.emoji-1fa90 {
    background-position: 90.000% 15.000%;
}
.emoji-1fa91 {
    background-position: 90.000% 16.667%;
}
.emoji-1fa92 {
    background-position: 90.000% 18.333%;
}
.emoji-1fa93 {
    background-position: 90.000% 20.000%;
}
.emoji-1fa94 {
    background-position: 90.000% 21.667%;
}
.emoji-1fa95 {
    background-position: 90.000% 23.333%;
}
.emoji-1fa96 {
    background-position: 90.000% 25.000%;
}
.emoji-1fa97 {
    background-position: 90.000% 26.667%;
}
.emoji-1fa98 {
    background-position: 90.000% 28.333%;
}
.emoji-1fa99 {
    background-position: 90.000% 30.000%;
}
.emoji-1fa9a {
    background-position: 90.000% 31.667%;
}
.emoji-1fa9b {
    background-position: 90.000% 33.333%;
}
.emoji-1fa9c {
    background-position: 90.000% 35.000%;
}
.emoji-1fa9d {
    background-position: 90.000% 36.667%;
}
.emoji-1fa9e {
    background-position: 90.000% 38.333%;
}
.emoji-1fa9f {
    background-position: 90.000% 40.000%;
}
.emoji-1faa0 {
    background-position: 90.000% 41.667%;
}
.emoji-1faa1 {
    background-position: 90.000% 43.333%;
}
.emoji-1faa2 {
    background-position: 90.000% 45.000%;
}
.emoji-1faa3 {
    background-position: 90.000% 46.667%;
}
.emoji-1faa4 {
    background-position: 90.000% 48.333%;
}
.emoji-1faa5 {
    background-position: 90.000% 50.000%;
}
.emoji-1faa6 {
    background-position: 90.000% 51.667%;
}
.emoji-1faa7 {
    background-position: 90.000% 53.333%;
}
.emoji-1faa8 {
    background-position: 90.000% 55.000%;
}
.emoji-1faa9 {
    background-position: 90.000% 56.667%;
}
.emoji-1faaa {
    background-position: 90.000% 58.333%;
}
.emoji-1faab {
    background-position: 90.000% 60.000%;
}
.emoji-1faac {
    background-position: 90.000% 61.667%;
}
.emoji-1faad {
    background-position: 90.000% 63.333%;
}
.emoji-1faae {
    background-position: 90.000% 65.000%;
}
.emoji-1faaf {
    background-position: 90.000% 66.667%;
}
.emoji-1fab0 {
    background-position: 90.000% 68.333%;
}
.emoji-1fab1 {
    background-position: 90.000% 70.000%;
}
.emoji-1fab2 {
    background-position: 90.000% 71.667%;
}
.emoji-1fab3 {
    background-position: 90.000% 73.333%;
}
.emoji-1fab4 {
    background-position: 90.000% 75.000%;
}
.emoji-1fab5 {
    background-position: 90.000% 76.667%;
}
.emoji-1fab6 {
    background-position: 90.000% 78.333%;
}
.emoji-1fab7 {
    background-position: 90.000% 80.000%;
}
.emoji-1fab8 {
    background-position: 90.000% 81.667%;
}
.emoji-1fab9 {
    background-position: 90.000% 83.333%;
}
.emoji-1faba {
    background-position: 90.000% 85.000%;
}
.emoji-1fabb {
    background-position: 90.000% 86.667%;
}
.emoji-1fabc {
    background-position: 90.000% 88.333%;
}
.emoji-1fabd {
    background-position: 90.000% 90.000%;
}
.emoji-1fabf {
    background-position: 90.000% 91.667%;
}
.emoji-1fac0 {
    background-position: 90.000% 93.333%;
}
.emoji-1fac1 {
    background-position: 90.000% 95.000%;
}
.emoji-1fac2 {
    background-position: 90.000% 96.667%;
}
.emoji-1fac3 {
    background-position: 90.000% 98.333%;
}
.emoji-1fac4 {
    background-position: 91.667% 6.667%;
}
.emoji-1fac5 {
    background-position: 91.667% 16.667%;
}
.emoji-1face {
    background-position: 91.667% 26.667%;
}
.emoji-1facf {
    background-position: 91.667% 28.333%;
}
.emoji-1fad0 {
    background-position: 91.667% 30.000%;
}
.emoji-1fad1 {
    background-position: 91.667% 31.667%;
}
.emoji-1fad2 {
    background-position: 91.667% 33.333%;
}
.emoji-1fad3 {
    background-position: 91.667% 35.000%;
}
.emoji-1fad4 {
    background-position: 91.667% 36.667%;
}
.emoji-1fad5 {
    background-position: 91.667% 38.333%;
}
.emoji-1fad6 {
    background-position: 91.667% 40.000%;
}
.emoji-1fad7 {
    background-position: 91.667% 41.667%;
}
.emoji-1fad8 {
    background-position: 91.667% 43.333%;
}
.emoji-1fad9 {
    background-position: 91.667% 45.000%;
}
.emoji-1fada {
    background-position: 91.667% 46.667%;
}
.emoji-1fadb {
    background-position: 91.667% 48.333%;
}
.emoji-1fae0 {
    background-position: 91.667% 50.000%;
}
.emoji-1fae1 {
    background-position: 91.667% 51.667%;
}
.emoji-1fae2 {
    background-position: 91.667% 53.333%;
}
.emoji-1fae3 {
    background-position: 91.667% 55.000%;
}
.emoji-1fae4 {
    background-position: 91.667% 56.667%;
}
.emoji-1fae5 {
    background-position: 91.667% 58.333%;
}
.emoji-1fae6 {
    background-position: 91.667% 60.000%;
}
.emoji-1fae7 {
    background-position: 91.667% 61.667%;
}
.emoji-1fae8 {
    background-position: 91.667% 63.333%;
}
.emoji-1faf0 {
    background-position: 91.667% 65.000%;
}
.emoji-1faf1 {
    background-position: 91.667% 75.000%;
}
.emoji-1faf2 {
    background-position: 91.667% 85.000%;
}
.emoji-1faf3 {
    background-position: 91.667% 95.000%;
}
.emoji-1faf4 {
    background-position: 93.333% 3.333%;
}
.emoji-1faf5 {
    background-position: 93.333% 13.333%;
}
.emoji-1faf6 {
    background-position: 93.333% 23.333%;
}
.emoji-1faf7 {
    background-position: 93.333% 33.333%;
}
.emoji-1faf8 {
    background-position: 93.333% 43.333%;
}
.emoji-203c {
    background-position: 93.333% 53.333%;
}
.emoji-2049 {
    background-position: 93.333% 55.000%;
}
.emoji-2122 {
    background-position: 93.333% 56.667%;
}
.emoji-2139 {
    background-position: 93.333% 58.333%;
}
.emoji-2194 {
    background-position: 93.333% 60.000%;
}
.emoji-2195 {
    background-position: 93.333% 61.667%;
}
.emoji-2196 {
    background-position: 93.333% 63.333%;
}
.emoji-2197 {
    background-position: 93.333% 65.000%;
}
.emoji-2198 {
    background-position: 93.333% 66.667%;
}
.emoji-2199 {
    background-position: 93.333% 68.333%;
}
.emoji-21a9 {
    background-position: 93.333% 70.000%;
}
.emoji-21aa {
    background-position: 93.333% 71.667%;
}
.emoji-231a {
    background-position: 93.333% 73.333%;
}
.emoji-231b {
    background-position: 93.333% 75.000%;
}
.emoji-2328 {
    background-position: 93.333% 76.667%;
}
.emoji-23cf {
    background-position: 93.333% 78.333%;
}
.emoji-23e9 {
    background-position: 93.333% 80.000%;
}
.emoji-23ea {
    background-position: 93.333% 81.667%;
}
.emoji-23eb {
    background-position: 93.333% 83.333%;
}
.emoji-23ec {
    background-position: 93.333% 85.000%;
}
.emoji-23ed {
    background-position: 93.333% 86.667%;
}
.emoji-23ee {
    background-position: 93.333% 88.333%;
}
.emoji-23ef {
    background-position: 93.333% 90.000%;
}
.emoji-23f0 {
    background-position: 93.333% 91.667%;
}
.emoji-23f1 {
    background-position: 93.333% 93.333%;
}
.emoji-23f2 {
    background-position: 93.333% 95.000%;
}
.emoji-23f3 {
    background-position: 93.333% 96.667%;
}
.emoji-23f8 {
    background-position: 93.333% 98.333%;
}
.emoji-23f9 {
    background-position: 93.333% 100.000%;
}
.emoji-23fa {
    background-position: 95.000% 0.000%;
}
.emoji-24c2 {
    background-position: 95.000% 1.667%;
}
.emoji-25aa {
    background-position: 95.000% 3.333%;
}
.emoji-25ab {
    background-position: 95.000% 5.000%;
}
.emoji-25b6 {
    background-position: 95.000% 6.667%;
}
.emoji-25c0 {
    background-position: 95.000% 8.333%;
}
.emoji-25fb {
    background-position: 95.000% 10.000%;
}
.emoji-25fc {
    background-position: 95.000% 11.667%;
}
.emoji-25fd {
    background-position: 95.000% 13.333%;
}
.emoji-25fe {
    background-position: 95.000% 15.000%;
}
.emoji-2600 {
    background-position: 95.000% 16.667%;
}
.emoji-2601 {
    background-position: 95.000% 18.333%;
}
.emoji-2602 {
    background-position: 95.000% 20.000%;
}
.emoji-2603 {
    background-position: 95.000% 21.667%;
}
.emoji-2604 {
    background-position: 95.000% 23.333%;
}
.emoji-260e {
    background-position: 95.000% 25.000%;
}
.emoji-2611 {
    background-position: 95.000% 26.667%;
}
.emoji-2614 {
    background-position: 95.000% 28.333%;
}
.emoji-2615 {
    background-position: 95.000% 30.000%;
}
.emoji-2618 {
    background-position: 95.000% 31.667%;
}
.emoji-261d {
    background-position: 95.000% 33.333%;
}
.emoji-2620 {
    background-position: 95.000% 43.333%;
}
.emoji-2622 {
    background-position: 95.000% 45.000%;
}
.emoji-2623 {
    background-position: 95.000% 46.667%;
}
.emoji-2626 {
    background-position: 95.000% 48.333%;
}
.emoji-262a {
    background-position: 95.000% 50.000%;
}
.emoji-262e {
    background-position: 95.000% 51.667%;
}
.emoji-262f {
    background-position: 95.000% 53.333%;
}
.emoji-2638 {
    background-position: 95.000% 55.000%;
}
.emoji-2639 {
    background-position: 95.000% 56.667%;
}
.emoji-263a {
    background-position: 95.000% 58.333%;
}
.emoji-2640 {
    background-position: 95.000% 60.000%;
}
.emoji-2642 {
    background-position: 95.000% 61.667%;
}
.emoji-2648 {
    background-position: 95.000% 63.333%;
}
.emoji-2649 {
    background-position: 95.000% 65.000%;
}
.emoji-264a {
    background-position: 95.000% 66.667%;
}
.emoji-264b {
    background-position: 95.000% 68.333%;
}
.emoji-264c {
    background-position: 95.000% 70.000%;
}
.emoji-264d {
    background-position: 95.000% 71.667%;
}
.emoji-264e {
    background-position: 95.000% 73.333%;
}
.emoji-264f {
    background-position: 95.000% 75.000%;
}
.emoji-2650 {
    background-position: 95.000% 76.667%;
}
.emoji-2651 {
    background-position: 95.000% 78.333%;
}
.emoji-2652 {
    background-position: 95.000% 80.000%;
}
.emoji-2653 {
    background-position: 95.000% 81.667%;
}
.emoji-265f {
    background-position: 95.000% 83.333%;
}
.emoji-2660 {
    background-position: 95.000% 85.000%;
}
.emoji-2663 {
    background-position: 95.000% 86.667%;
}
.emoji-2665 {
    background-position: 95.000% 88.333%;
}
.emoji-2666 {
    background-position: 95.000% 90.000%;
}
.emoji-2668 {
    background-position: 95.000% 91.667%;
}
.emoji-267b {
    background-position: 95.000% 93.333%;
}
.emoji-267e {
    background-position: 95.000% 95.000%;
}
.emoji-267f {
    background-position: 95.000% 96.667%;
}
.emoji-2692 {
    background-position: 95.000% 98.333%;
}
.emoji-2693 {
    background-position: 95.000% 100.000%;
}
.emoji-2694 {
    background-position: 96.667% 0.000%;
}
.emoji-2695 {
    background-position: 96.667% 1.667%;
}
.emoji-2696 {
    background-position: 96.667% 3.333%;
}
.emoji-2697 {
    background-position: 96.667% 5.000%;
}
.emoji-2699 {
    background-position: 96.667% 6.667%;
}
.emoji-269b {
    background-position: 96.667% 8.333%;
}
.emoji-269c {
    background-position: 96.667% 10.000%;
}
.emoji-26a0 {
    background-position: 96.667% 11.667%;
}
.emoji-26a1 {
    background-position: 96.667% 13.333%;
}
.emoji-26a7 {
    background-position: 96.667% 15.000%;
}
.emoji-26aa {
    background-position: 96.667% 16.667%;
}
.emoji-26ab {
    background-position: 96.667% 18.333%;
}
.emoji-26b0 {
    background-position: 96.667% 20.000%;
}
.emoji-26b1 {
    background-position: 96.667% 21.667%;
}
.emoji-26bd {
    background-position: 96.667% 23.333%;
}
.emoji-26be {
    background-position: 96.667% 25.000%;
}
.emoji-26c4 {
    background-position: 96.667% 26.667%;
}
.emoji-26c5 {
    background-position: 96.667% 28.333%;
}
.emoji-26c8 {
    background-position: 96.667% 30.000%;
}
.emoji-26ce {
    background-position: 96.667% 31.667%;
}
.emoji-26cf {
    background-position: 96.667% 33.333%;
}
.emoji-26d1 {
    background-position: 96.667% 35.000%;
}
.emoji-26d3 {
    background-position: 96.667% 36.667%;
}
.emoji-26d4 {
    background-position: 96.667% 38.333%;
}
.emoji-26e9 {
    background-position: 96.667% 40.000%;
}
.emoji-26ea {
    background-position: 96.667% 41.667%;
}
.emoji-26f0 {
    background-position: 96.667% 43.333%;
}
.emoji-26f1 {
    background-position: 96.667% 45.000%;
}
.emoji-26f2 {
    background-position: 96.667% 46.667%;
}
.emoji-26f3 {
    background-position: 96.667% 48.333%;
}
.emoji-26f4 {
    background-position: 96.667% 50.000%;
}
.emoji-26f5 {
    background-position: 96.667% 51.667%;
}
.emoji-26f7 {
    background-position: 96.667% 53.333%;
}
.emoji-26f8 {
    background-position: 96.667% 55.000%;
}
.emoji-26f9-200d-2640 {
    background-position: 96.667% 56.667%;
}
.emoji-26f9-200d-2642 {
    background-position: 96.667% 66.667%;
}
.emoji-26f9 {
    background-position: 96.667% 76.667%;
}
.emoji-26fa {
    background-position: 96.667% 86.667%;
}
.emoji-26fd {
    background-position: 96.667% 88.333%;
}
.emoji-2702 {
    background-position: 96.667% 90.000%;
}
.emoji-2705 {
    background-position: 96.667% 91.667%;
}
.emoji-2708 {
    background-position: 96.667% 93.333%;
}
.emoji-2709 {
    background-position: 96.667% 95.000%;
}
.emoji-270a {
    background-position: 96.667% 96.667%;
}
.emoji-270b {
    background-position: 98.333% 5.000%;
}
.emoji-270c {
    background-position: 98.333% 15.000%;
}
.emoji-270d {
    background-position: 98.333% 25.000%;
}
.emoji-270f {
    background-position: 98.333% 35.000%;
}
.emoji-2712 {
    background-position: 98.333% 36.667%;
}
.emoji-2714 {
    background-position: 98.333% 38.333%;
}
.emoji-2716 {
    background-position: 98.333% 40.000%;
}
.emoji-271d {
    background-position: 98.333% 41.667%;
}
.emoji-2721 {
    background-position: 98.333% 43.333%;
}
.emoji-2728 {
    background-position: 98.333% 45.000%;
}
.emoji-2733 {
    background-position: 98.333% 46.667%;
}
.emoji-2734 {
    background-position: 98.333% 48.333%;
}
.emoji-2744 {
    background-position: 98.333% 50.000%;
}
.emoji-2747 {
    background-position: 98.333% 51.667%;
}
.emoji-274c {
    background-position: 98.333% 53.333%;
}
.emoji-274e {
    background-position: 98.333% 55.000%;
}
.emoji-2753 {
    background-position: 98.333% 56.667%;
}
.emoji-2754 {
    background-position: 98.333% 58.333%;
}
.emoji-2755 {
    background-position: 98.333% 60.000%;
}
.emoji-2757 {
    background-position: 98.333% 61.667%;
}
.emoji-2763 {
    background-position: 98.333% 63.333%;
}
.emoji-2764-200d-1f525 {
    background-position: 98.333% 65.000%;
}
.emoji-2764-200d-1fa79 {
    background-position: 98.333% 66.667%;
}
.emoji-2764 {
    background-position: 98.333% 68.333%;
}
.emoji-2795 {
    background-position: 98.333% 70.000%;
}
.emoji-2796 {
    background-position: 98.333% 71.667%;
}
.emoji-2797 {
    background-position: 98.333% 73.333%;
}
.emoji-27a1 {
    background-position: 98.333% 75.000%;
}
.emoji-27b0 {
    background-position: 98.333% 76.667%;
}
.emoji-27bf {
    background-position: 98.333% 78.333%;
}
.emoji-2934 {
    background-position: 98.333% 80.000%;
}
.emoji-2935 {
    background-position: 98.333% 81.667%;
}
.emoji-2b05 {
    background-position: 98.333% 83.333%;
}
.emoji-2b06 {
    background-position: 98.333% 85.000%;
}
.emoji-2b07 {
    background-position: 98.333% 86.667%;
}
.emoji-2b1b {
    background-position: 98.333% 88.333%;
}
.emoji-2b1c {
    background-position: 98.333% 90.000%;
}
.emoji-2b50 {
    background-position: 98.333% 91.667%;
}
.emoji-2b55 {
    background-position: 98.333% 93.333%;
}
.emoji-3030 {
    background-position: 98.333% 95.000%;
}
.emoji-303d {
    background-position: 98.333% 96.667%;
}
.emoji-3297 {
    background-position: 98.333% 98.333%;
}
.emoji-3299 {
    background-position: 98.333% 100.000%;
}

`, "",{"version":3,"sources":["webpack://./generated/emoji-styles/google-sprite.css"],"names":[],"mappings":"AAAA;;;IAGI,qBAAqB;IACrB,yDAA4E;IAC5E,0BAA0B;IAC1B,4BAA4B;;IAE5B,mBAAmB;IACnB,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,oEAA4F;IAC5F,qCAAqC;IACrC,mCAAmC;AACvC;;AAEA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,kCAAkC;AACtC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,mCAAmC;AACvC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,qCAAqC;AACzC","sourcesContent":["div.emoji,\nspan.emoji\n{\n    display: inline-block;\n    background-image: url(~emoji-datasource-google/img/google/sheets-256/64.png);\n    background-size: 6100.000%;\n    background-repeat: no-repeat;\n\n    /* Hide the text. */\n    text-indent: 100%;\n    white-space: nowrap;\n    overflow: hidden;\n}\n\n.emoji-1f419\n{\n    background-image: url(../../../static/generated/emoji/images-google-64/1f419.png) !important;\n    background-position: 0% 0% !important;\n    background-size: contain !important;\n}\n\n.emoji-0023-20e3 {\n    background-position: 0.000% 0.000%;\n}\n.emoji-002a-20e3 {\n    background-position: 0.000% 1.667%;\n}\n.emoji-0030-20e3 {\n    background-position: 0.000% 3.333%;\n}\n.emoji-0031-20e3 {\n    background-position: 0.000% 5.000%;\n}\n.emoji-0032-20e3 {\n    background-position: 0.000% 6.667%;\n}\n.emoji-0033-20e3 {\n    background-position: 0.000% 8.333%;\n}\n.emoji-0034-20e3 {\n    background-position: 0.000% 10.000%;\n}\n.emoji-0035-20e3 {\n    background-position: 0.000% 11.667%;\n}\n.emoji-0036-20e3 {\n    background-position: 0.000% 13.333%;\n}\n.emoji-0037-20e3 {\n    background-position: 0.000% 15.000%;\n}\n.emoji-0038-20e3 {\n    background-position: 0.000% 16.667%;\n}\n.emoji-0039-20e3 {\n    background-position: 0.000% 18.333%;\n}\n.emoji-00a9 {\n    background-position: 0.000% 20.000%;\n}\n.emoji-00ae {\n    background-position: 0.000% 21.667%;\n}\n.emoji-1f004 {\n    background-position: 0.000% 23.333%;\n}\n.emoji-1f0cf {\n    background-position: 0.000% 25.000%;\n}\n.emoji-1f170 {\n    background-position: 0.000% 26.667%;\n}\n.emoji-1f171 {\n    background-position: 0.000% 28.333%;\n}\n.emoji-1f17e {\n    background-position: 0.000% 30.000%;\n}\n.emoji-1f17f {\n    background-position: 0.000% 31.667%;\n}\n.emoji-1f18e {\n    background-position: 0.000% 33.333%;\n}\n.emoji-1f191 {\n    background-position: 0.000% 35.000%;\n}\n.emoji-1f192 {\n    background-position: 0.000% 36.667%;\n}\n.emoji-1f193 {\n    background-position: 0.000% 38.333%;\n}\n.emoji-1f194 {\n    background-position: 0.000% 40.000%;\n}\n.emoji-1f195 {\n    background-position: 0.000% 41.667%;\n}\n.emoji-1f196 {\n    background-position: 0.000% 43.333%;\n}\n.emoji-1f197 {\n    background-position: 0.000% 45.000%;\n}\n.emoji-1f198 {\n    background-position: 0.000% 46.667%;\n}\n.emoji-1f199 {\n    background-position: 0.000% 48.333%;\n}\n.emoji-1f19a {\n    background-position: 0.000% 50.000%;\n}\n.emoji-1f1e6-1f1e8 {\n    background-position: 0.000% 51.667%;\n}\n.emoji-1f1e6-1f1e9 {\n    background-position: 0.000% 53.333%;\n}\n.emoji-1f1e6-1f1ea {\n    background-position: 0.000% 55.000%;\n}\n.emoji-1f1e6-1f1eb {\n    background-position: 0.000% 56.667%;\n}\n.emoji-1f1e6-1f1ec {\n    background-position: 0.000% 58.333%;\n}\n.emoji-1f1e6-1f1ee {\n    background-position: 0.000% 60.000%;\n}\n.emoji-1f1e6-1f1f1 {\n    background-position: 0.000% 61.667%;\n}\n.emoji-1f1e6-1f1f2 {\n    background-position: 0.000% 63.333%;\n}\n.emoji-1f1e6-1f1f4 {\n    background-position: 0.000% 65.000%;\n}\n.emoji-1f1e6-1f1f6 {\n    background-position: 0.000% 66.667%;\n}\n.emoji-1f1e6-1f1f7 {\n    background-position: 0.000% 68.333%;\n}\n.emoji-1f1e6-1f1f8 {\n    background-position: 0.000% 70.000%;\n}\n.emoji-1f1e6-1f1f9 {\n    background-position: 0.000% 71.667%;\n}\n.emoji-1f1e6-1f1fa {\n    background-position: 0.000% 73.333%;\n}\n.emoji-1f1e6-1f1fc {\n    background-position: 0.000% 75.000%;\n}\n.emoji-1f1e6-1f1fd {\n    background-position: 0.000% 76.667%;\n}\n.emoji-1f1e6-1f1ff {\n    background-position: 0.000% 78.333%;\n}\n.emoji-1f1e7-1f1e6 {\n    background-position: 0.000% 80.000%;\n}\n.emoji-1f1e7-1f1e7 {\n    background-position: 0.000% 81.667%;\n}\n.emoji-1f1e7-1f1e9 {\n    background-position: 0.000% 83.333%;\n}\n.emoji-1f1e7-1f1ea {\n    background-position: 0.000% 85.000%;\n}\n.emoji-1f1e7-1f1eb {\n    background-position: 0.000% 86.667%;\n}\n.emoji-1f1e7-1f1ec {\n    background-position: 0.000% 88.333%;\n}\n.emoji-1f1e7-1f1ed {\n    background-position: 0.000% 90.000%;\n}\n.emoji-1f1e7-1f1ee {\n    background-position: 0.000% 91.667%;\n}\n.emoji-1f1e7-1f1ef {\n    background-position: 0.000% 93.333%;\n}\n.emoji-1f1e7-1f1f1 {\n    background-position: 0.000% 95.000%;\n}\n.emoji-1f1e7-1f1f2 {\n    background-position: 0.000% 96.667%;\n}\n.emoji-1f1e7-1f1f3 {\n    background-position: 0.000% 98.333%;\n}\n.emoji-1f1e7-1f1f4 {\n    background-position: 0.000% 100.000%;\n}\n.emoji-1f1e7-1f1f6 {\n    background-position: 1.667% 0.000%;\n}\n.emoji-1f1e7-1f1f7 {\n    background-position: 1.667% 1.667%;\n}\n.emoji-1f1e7-1f1f8 {\n    background-position: 1.667% 3.333%;\n}\n.emoji-1f1e7-1f1f9 {\n    background-position: 1.667% 5.000%;\n}\n.emoji-1f1e7-1f1fb {\n    background-position: 1.667% 6.667%;\n}\n.emoji-1f1e7-1f1fc {\n    background-position: 1.667% 8.333%;\n}\n.emoji-1f1e7-1f1fe {\n    background-position: 1.667% 10.000%;\n}\n.emoji-1f1e7-1f1ff {\n    background-position: 1.667% 11.667%;\n}\n.emoji-1f1e8-1f1e6 {\n    background-position: 1.667% 13.333%;\n}\n.emoji-1f1e8-1f1e8 {\n    background-position: 1.667% 15.000%;\n}\n.emoji-1f1e8-1f1e9 {\n    background-position: 1.667% 16.667%;\n}\n.emoji-1f1e8-1f1eb {\n    background-position: 1.667% 18.333%;\n}\n.emoji-1f1e8-1f1ec {\n    background-position: 1.667% 20.000%;\n}\n.emoji-1f1e8-1f1ed {\n    background-position: 1.667% 21.667%;\n}\n.emoji-1f1e8-1f1ee {\n    background-position: 1.667% 23.333%;\n}\n.emoji-1f1e8-1f1f0 {\n    background-position: 1.667% 25.000%;\n}\n.emoji-1f1e8-1f1f1 {\n    background-position: 1.667% 26.667%;\n}\n.emoji-1f1e8-1f1f2 {\n    background-position: 1.667% 28.333%;\n}\n.emoji-1f1e8-1f1f3 {\n    background-position: 1.667% 30.000%;\n}\n.emoji-1f1e8-1f1f4 {\n    background-position: 1.667% 31.667%;\n}\n.emoji-1f1e8-1f1f5 {\n    background-position: 1.667% 33.333%;\n}\n.emoji-1f1e8-1f1f7 {\n    background-position: 1.667% 35.000%;\n}\n.emoji-1f1e8-1f1fa {\n    background-position: 1.667% 36.667%;\n}\n.emoji-1f1e8-1f1fb {\n    background-position: 1.667% 38.333%;\n}\n.emoji-1f1e8-1f1fc {\n    background-position: 1.667% 40.000%;\n}\n.emoji-1f1e8-1f1fd {\n    background-position: 1.667% 41.667%;\n}\n.emoji-1f1e8-1f1fe {\n    background-position: 1.667% 43.333%;\n}\n.emoji-1f1e8-1f1ff {\n    background-position: 1.667% 45.000%;\n}\n.emoji-1f1e9-1f1ea {\n    background-position: 1.667% 46.667%;\n}\n.emoji-1f1e9-1f1ec {\n    background-position: 1.667% 48.333%;\n}\n.emoji-1f1e9-1f1ef {\n    background-position: 1.667% 50.000%;\n}\n.emoji-1f1e9-1f1f0 {\n    background-position: 1.667% 51.667%;\n}\n.emoji-1f1e9-1f1f2 {\n    background-position: 1.667% 53.333%;\n}\n.emoji-1f1e9-1f1f4 {\n    background-position: 1.667% 55.000%;\n}\n.emoji-1f1e9-1f1ff {\n    background-position: 1.667% 56.667%;\n}\n.emoji-1f1ea-1f1e6 {\n    background-position: 1.667% 58.333%;\n}\n.emoji-1f1ea-1f1e8 {\n    background-position: 1.667% 60.000%;\n}\n.emoji-1f1ea-1f1ea {\n    background-position: 1.667% 61.667%;\n}\n.emoji-1f1ea-1f1ec {\n    background-position: 1.667% 63.333%;\n}\n.emoji-1f1ea-1f1ed {\n    background-position: 1.667% 65.000%;\n}\n.emoji-1f1ea-1f1f7 {\n    background-position: 1.667% 66.667%;\n}\n.emoji-1f1ea-1f1f8 {\n    background-position: 1.667% 68.333%;\n}\n.emoji-1f1ea-1f1f9 {\n    background-position: 1.667% 70.000%;\n}\n.emoji-1f1ea-1f1fa {\n    background-position: 1.667% 71.667%;\n}\n.emoji-1f1eb-1f1ee {\n    background-position: 1.667% 73.333%;\n}\n.emoji-1f1eb-1f1ef {\n    background-position: 1.667% 75.000%;\n}\n.emoji-1f1eb-1f1f0 {\n    background-position: 1.667% 76.667%;\n}\n.emoji-1f1eb-1f1f2 {\n    background-position: 1.667% 78.333%;\n}\n.emoji-1f1eb-1f1f4 {\n    background-position: 1.667% 80.000%;\n}\n.emoji-1f1eb-1f1f7 {\n    background-position: 1.667% 81.667%;\n}\n.emoji-1f1ec-1f1e6 {\n    background-position: 1.667% 83.333%;\n}\n.emoji-1f1ec-1f1e7 {\n    background-position: 1.667% 85.000%;\n}\n.emoji-1f1ec-1f1e9 {\n    background-position: 1.667% 86.667%;\n}\n.emoji-1f1ec-1f1ea {\n    background-position: 1.667% 88.333%;\n}\n.emoji-1f1ec-1f1eb {\n    background-position: 1.667% 90.000%;\n}\n.emoji-1f1ec-1f1ec {\n    background-position: 1.667% 91.667%;\n}\n.emoji-1f1ec-1f1ed {\n    background-position: 1.667% 93.333%;\n}\n.emoji-1f1ec-1f1ee {\n    background-position: 1.667% 95.000%;\n}\n.emoji-1f1ec-1f1f1 {\n    background-position: 1.667% 96.667%;\n}\n.emoji-1f1ec-1f1f2 {\n    background-position: 1.667% 98.333%;\n}\n.emoji-1f1ec-1f1f3 {\n    background-position: 1.667% 100.000%;\n}\n.emoji-1f1ec-1f1f5 {\n    background-position: 3.333% 0.000%;\n}\n.emoji-1f1ec-1f1f6 {\n    background-position: 3.333% 1.667%;\n}\n.emoji-1f1ec-1f1f7 {\n    background-position: 3.333% 3.333%;\n}\n.emoji-1f1ec-1f1f8 {\n    background-position: 3.333% 5.000%;\n}\n.emoji-1f1ec-1f1f9 {\n    background-position: 3.333% 6.667%;\n}\n.emoji-1f1ec-1f1fa {\n    background-position: 3.333% 8.333%;\n}\n.emoji-1f1ec-1f1fc {\n    background-position: 3.333% 10.000%;\n}\n.emoji-1f1ec-1f1fe {\n    background-position: 3.333% 11.667%;\n}\n.emoji-1f1ed-1f1f0 {\n    background-position: 3.333% 13.333%;\n}\n.emoji-1f1ed-1f1f2 {\n    background-position: 3.333% 15.000%;\n}\n.emoji-1f1ed-1f1f3 {\n    background-position: 3.333% 16.667%;\n}\n.emoji-1f1ed-1f1f7 {\n    background-position: 3.333% 18.333%;\n}\n.emoji-1f1ed-1f1f9 {\n    background-position: 3.333% 20.000%;\n}\n.emoji-1f1ed-1f1fa {\n    background-position: 3.333% 21.667%;\n}\n.emoji-1f1ee-1f1e8 {\n    background-position: 3.333% 23.333%;\n}\n.emoji-1f1ee-1f1e9 {\n    background-position: 3.333% 25.000%;\n}\n.emoji-1f1ee-1f1ea {\n    background-position: 3.333% 26.667%;\n}\n.emoji-1f1ee-1f1f1 {\n    background-position: 3.333% 28.333%;\n}\n.emoji-1f1ee-1f1f2 {\n    background-position: 3.333% 30.000%;\n}\n.emoji-1f1ee-1f1f3 {\n    background-position: 3.333% 31.667%;\n}\n.emoji-1f1ee-1f1f4 {\n    background-position: 3.333% 33.333%;\n}\n.emoji-1f1ee-1f1f6 {\n    background-position: 3.333% 35.000%;\n}\n.emoji-1f1ee-1f1f7 {\n    background-position: 3.333% 36.667%;\n}\n.emoji-1f1ee-1f1f8 {\n    background-position: 3.333% 38.333%;\n}\n.emoji-1f1ee-1f1f9 {\n    background-position: 3.333% 40.000%;\n}\n.emoji-1f1ef-1f1ea {\n    background-position: 3.333% 41.667%;\n}\n.emoji-1f1ef-1f1f2 {\n    background-position: 3.333% 43.333%;\n}\n.emoji-1f1ef-1f1f4 {\n    background-position: 3.333% 45.000%;\n}\n.emoji-1f1ef-1f1f5 {\n    background-position: 3.333% 46.667%;\n}\n.emoji-1f1f0-1f1ea {\n    background-position: 3.333% 48.333%;\n}\n.emoji-1f1f0-1f1ec {\n    background-position: 3.333% 50.000%;\n}\n.emoji-1f1f0-1f1ed {\n    background-position: 3.333% 51.667%;\n}\n.emoji-1f1f0-1f1ee {\n    background-position: 3.333% 53.333%;\n}\n.emoji-1f1f0-1f1f2 {\n    background-position: 3.333% 55.000%;\n}\n.emoji-1f1f0-1f1f3 {\n    background-position: 3.333% 56.667%;\n}\n.emoji-1f1f0-1f1f5 {\n    background-position: 3.333% 58.333%;\n}\n.emoji-1f1f0-1f1f7 {\n    background-position: 3.333% 60.000%;\n}\n.emoji-1f1f0-1f1fc {\n    background-position: 3.333% 61.667%;\n}\n.emoji-1f1f0-1f1fe {\n    background-position: 3.333% 63.333%;\n}\n.emoji-1f1f0-1f1ff {\n    background-position: 3.333% 65.000%;\n}\n.emoji-1f1f1-1f1e6 {\n    background-position: 3.333% 66.667%;\n}\n.emoji-1f1f1-1f1e7 {\n    background-position: 3.333% 68.333%;\n}\n.emoji-1f1f1-1f1e8 {\n    background-position: 3.333% 70.000%;\n}\n.emoji-1f1f1-1f1ee {\n    background-position: 3.333% 71.667%;\n}\n.emoji-1f1f1-1f1f0 {\n    background-position: 3.333% 73.333%;\n}\n.emoji-1f1f1-1f1f7 {\n    background-position: 3.333% 75.000%;\n}\n.emoji-1f1f1-1f1f8 {\n    background-position: 3.333% 76.667%;\n}\n.emoji-1f1f1-1f1f9 {\n    background-position: 3.333% 78.333%;\n}\n.emoji-1f1f1-1f1fa {\n    background-position: 3.333% 80.000%;\n}\n.emoji-1f1f1-1f1fb {\n    background-position: 3.333% 81.667%;\n}\n.emoji-1f1f1-1f1fe {\n    background-position: 3.333% 83.333%;\n}\n.emoji-1f1f2-1f1e6 {\n    background-position: 3.333% 85.000%;\n}\n.emoji-1f1f2-1f1e8 {\n    background-position: 3.333% 86.667%;\n}\n.emoji-1f1f2-1f1e9 {\n    background-position: 3.333% 88.333%;\n}\n.emoji-1f1f2-1f1ea {\n    background-position: 3.333% 90.000%;\n}\n.emoji-1f1f2-1f1eb {\n    background-position: 3.333% 91.667%;\n}\n.emoji-1f1f2-1f1ec {\n    background-position: 3.333% 93.333%;\n}\n.emoji-1f1f2-1f1ed {\n    background-position: 3.333% 95.000%;\n}\n.emoji-1f1f2-1f1f0 {\n    background-position: 3.333% 96.667%;\n}\n.emoji-1f1f2-1f1f1 {\n    background-position: 3.333% 98.333%;\n}\n.emoji-1f1f2-1f1f2 {\n    background-position: 3.333% 100.000%;\n}\n.emoji-1f1f2-1f1f3 {\n    background-position: 5.000% 0.000%;\n}\n.emoji-1f1f2-1f1f4 {\n    background-position: 5.000% 1.667%;\n}\n.emoji-1f1f2-1f1f5 {\n    background-position: 5.000% 3.333%;\n}\n.emoji-1f1f2-1f1f6 {\n    background-position: 5.000% 5.000%;\n}\n.emoji-1f1f2-1f1f7 {\n    background-position: 5.000% 6.667%;\n}\n.emoji-1f1f2-1f1f8 {\n    background-position: 5.000% 8.333%;\n}\n.emoji-1f1f2-1f1f9 {\n    background-position: 5.000% 10.000%;\n}\n.emoji-1f1f2-1f1fa {\n    background-position: 5.000% 11.667%;\n}\n.emoji-1f1f2-1f1fb {\n    background-position: 5.000% 13.333%;\n}\n.emoji-1f1f2-1f1fc {\n    background-position: 5.000% 15.000%;\n}\n.emoji-1f1f2-1f1fd {\n    background-position: 5.000% 16.667%;\n}\n.emoji-1f1f2-1f1fe {\n    background-position: 5.000% 18.333%;\n}\n.emoji-1f1f2-1f1ff {\n    background-position: 5.000% 20.000%;\n}\n.emoji-1f1f3-1f1e6 {\n    background-position: 5.000% 21.667%;\n}\n.emoji-1f1f3-1f1e8 {\n    background-position: 5.000% 23.333%;\n}\n.emoji-1f1f3-1f1ea {\n    background-position: 5.000% 25.000%;\n}\n.emoji-1f1f3-1f1eb {\n    background-position: 5.000% 26.667%;\n}\n.emoji-1f1f3-1f1ec {\n    background-position: 5.000% 28.333%;\n}\n.emoji-1f1f3-1f1ee {\n    background-position: 5.000% 30.000%;\n}\n.emoji-1f1f3-1f1f1 {\n    background-position: 5.000% 31.667%;\n}\n.emoji-1f1f3-1f1f4 {\n    background-position: 5.000% 33.333%;\n}\n.emoji-1f1f3-1f1f5 {\n    background-position: 5.000% 35.000%;\n}\n.emoji-1f1f3-1f1f7 {\n    background-position: 5.000% 36.667%;\n}\n.emoji-1f1f3-1f1fa {\n    background-position: 5.000% 38.333%;\n}\n.emoji-1f1f3-1f1ff {\n    background-position: 5.000% 40.000%;\n}\n.emoji-1f1f4-1f1f2 {\n    background-position: 5.000% 41.667%;\n}\n.emoji-1f1f5-1f1e6 {\n    background-position: 5.000% 43.333%;\n}\n.emoji-1f1f5-1f1ea {\n    background-position: 5.000% 45.000%;\n}\n.emoji-1f1f5-1f1eb {\n    background-position: 5.000% 46.667%;\n}\n.emoji-1f1f5-1f1ec {\n    background-position: 5.000% 48.333%;\n}\n.emoji-1f1f5-1f1ed {\n    background-position: 5.000% 50.000%;\n}\n.emoji-1f1f5-1f1f0 {\n    background-position: 5.000% 51.667%;\n}\n.emoji-1f1f5-1f1f1 {\n    background-position: 5.000% 53.333%;\n}\n.emoji-1f1f5-1f1f2 {\n    background-position: 5.000% 55.000%;\n}\n.emoji-1f1f5-1f1f3 {\n    background-position: 5.000% 56.667%;\n}\n.emoji-1f1f5-1f1f7 {\n    background-position: 5.000% 58.333%;\n}\n.emoji-1f1f5-1f1f8 {\n    background-position: 5.000% 60.000%;\n}\n.emoji-1f1f5-1f1f9 {\n    background-position: 5.000% 61.667%;\n}\n.emoji-1f1f5-1f1fc {\n    background-position: 5.000% 63.333%;\n}\n.emoji-1f1f5-1f1fe {\n    background-position: 5.000% 65.000%;\n}\n.emoji-1f1f6-1f1e6 {\n    background-position: 5.000% 66.667%;\n}\n.emoji-1f1f7-1f1ea {\n    background-position: 5.000% 68.333%;\n}\n.emoji-1f1f7-1f1f4 {\n    background-position: 5.000% 70.000%;\n}\n.emoji-1f1f7-1f1f8 {\n    background-position: 5.000% 71.667%;\n}\n.emoji-1f1f7-1f1fa {\n    background-position: 5.000% 73.333%;\n}\n.emoji-1f1f7-1f1fc {\n    background-position: 5.000% 75.000%;\n}\n.emoji-1f1f8-1f1e6 {\n    background-position: 5.000% 76.667%;\n}\n.emoji-1f1f8-1f1e7 {\n    background-position: 5.000% 78.333%;\n}\n.emoji-1f1f8-1f1e8 {\n    background-position: 5.000% 80.000%;\n}\n.emoji-1f1f8-1f1e9 {\n    background-position: 5.000% 81.667%;\n}\n.emoji-1f1f8-1f1ea {\n    background-position: 5.000% 83.333%;\n}\n.emoji-1f1f8-1f1ec {\n    background-position: 5.000% 85.000%;\n}\n.emoji-1f1f8-1f1ed {\n    background-position: 5.000% 86.667%;\n}\n.emoji-1f1f8-1f1ee {\n    background-position: 5.000% 88.333%;\n}\n.emoji-1f1f8-1f1ef {\n    background-position: 5.000% 90.000%;\n}\n.emoji-1f1f8-1f1f0 {\n    background-position: 5.000% 91.667%;\n}\n.emoji-1f1f8-1f1f1 {\n    background-position: 5.000% 93.333%;\n}\n.emoji-1f1f8-1f1f2 {\n    background-position: 5.000% 95.000%;\n}\n.emoji-1f1f8-1f1f3 {\n    background-position: 5.000% 96.667%;\n}\n.emoji-1f1f8-1f1f4 {\n    background-position: 5.000% 98.333%;\n}\n.emoji-1f1f8-1f1f7 {\n    background-position: 5.000% 100.000%;\n}\n.emoji-1f1f8-1f1f8 {\n    background-position: 6.667% 0.000%;\n}\n.emoji-1f1f8-1f1f9 {\n    background-position: 6.667% 1.667%;\n}\n.emoji-1f1f8-1f1fb {\n    background-position: 6.667% 3.333%;\n}\n.emoji-1f1f8-1f1fd {\n    background-position: 6.667% 5.000%;\n}\n.emoji-1f1f8-1f1fe {\n    background-position: 6.667% 6.667%;\n}\n.emoji-1f1f8-1f1ff {\n    background-position: 6.667% 8.333%;\n}\n.emoji-1f1f9-1f1e6 {\n    background-position: 6.667% 10.000%;\n}\n.emoji-1f1f9-1f1e8 {\n    background-position: 6.667% 11.667%;\n}\n.emoji-1f1f9-1f1e9 {\n    background-position: 6.667% 13.333%;\n}\n.emoji-1f1f9-1f1eb {\n    background-position: 6.667% 15.000%;\n}\n.emoji-1f1f9-1f1ec {\n    background-position: 6.667% 16.667%;\n}\n.emoji-1f1f9-1f1ed {\n    background-position: 6.667% 18.333%;\n}\n.emoji-1f1f9-1f1ef {\n    background-position: 6.667% 20.000%;\n}\n.emoji-1f1f9-1f1f0 {\n    background-position: 6.667% 21.667%;\n}\n.emoji-1f1f9-1f1f1 {\n    background-position: 6.667% 23.333%;\n}\n.emoji-1f1f9-1f1f2 {\n    background-position: 6.667% 25.000%;\n}\n.emoji-1f1f9-1f1f3 {\n    background-position: 6.667% 26.667%;\n}\n.emoji-1f1f9-1f1f4 {\n    background-position: 6.667% 28.333%;\n}\n.emoji-1f1f9-1f1f7 {\n    background-position: 6.667% 30.000%;\n}\n.emoji-1f1f9-1f1f9 {\n    background-position: 6.667% 31.667%;\n}\n.emoji-1f1f9-1f1fb {\n    background-position: 6.667% 33.333%;\n}\n.emoji-1f1f9-1f1fc {\n    background-position: 6.667% 35.000%;\n}\n.emoji-1f1f9-1f1ff {\n    background-position: 6.667% 36.667%;\n}\n.emoji-1f1fa-1f1e6 {\n    background-position: 6.667% 38.333%;\n}\n.emoji-1f1fa-1f1ec {\n    background-position: 6.667% 40.000%;\n}\n.emoji-1f1fa-1f1f2 {\n    background-position: 6.667% 41.667%;\n}\n.emoji-1f1fa-1f1f3 {\n    background-position: 6.667% 43.333%;\n}\n.emoji-1f1fa-1f1f8 {\n    background-position: 6.667% 45.000%;\n}\n.emoji-1f1fa-1f1fe {\n    background-position: 6.667% 46.667%;\n}\n.emoji-1f1fa-1f1ff {\n    background-position: 6.667% 48.333%;\n}\n.emoji-1f1fb-1f1e6 {\n    background-position: 6.667% 50.000%;\n}\n.emoji-1f1fb-1f1e8 {\n    background-position: 6.667% 51.667%;\n}\n.emoji-1f1fb-1f1ea {\n    background-position: 6.667% 53.333%;\n}\n.emoji-1f1fb-1f1ec {\n    background-position: 6.667% 55.000%;\n}\n.emoji-1f1fb-1f1ee {\n    background-position: 6.667% 56.667%;\n}\n.emoji-1f1fb-1f1f3 {\n    background-position: 6.667% 58.333%;\n}\n.emoji-1f1fb-1f1fa {\n    background-position: 6.667% 60.000%;\n}\n.emoji-1f1fc-1f1eb {\n    background-position: 6.667% 61.667%;\n}\n.emoji-1f1fc-1f1f8 {\n    background-position: 6.667% 63.333%;\n}\n.emoji-1f1fd-1f1f0 {\n    background-position: 6.667% 65.000%;\n}\n.emoji-1f1fe-1f1ea {\n    background-position: 6.667% 66.667%;\n}\n.emoji-1f1fe-1f1f9 {\n    background-position: 6.667% 68.333%;\n}\n.emoji-1f1ff-1f1e6 {\n    background-position: 6.667% 70.000%;\n}\n.emoji-1f1ff-1f1f2 {\n    background-position: 6.667% 71.667%;\n}\n.emoji-1f1ff-1f1fc {\n    background-position: 6.667% 73.333%;\n}\n.emoji-1f201 {\n    background-position: 6.667% 75.000%;\n}\n.emoji-1f202 {\n    background-position: 6.667% 76.667%;\n}\n.emoji-1f21a {\n    background-position: 6.667% 78.333%;\n}\n.emoji-1f22f {\n    background-position: 6.667% 80.000%;\n}\n.emoji-1f232 {\n    background-position: 6.667% 81.667%;\n}\n.emoji-1f233 {\n    background-position: 6.667% 83.333%;\n}\n.emoji-1f234 {\n    background-position: 6.667% 85.000%;\n}\n.emoji-1f235 {\n    background-position: 6.667% 86.667%;\n}\n.emoji-1f236 {\n    background-position: 6.667% 88.333%;\n}\n.emoji-1f237 {\n    background-position: 6.667% 90.000%;\n}\n.emoji-1f238 {\n    background-position: 6.667% 91.667%;\n}\n.emoji-1f239 {\n    background-position: 6.667% 93.333%;\n}\n.emoji-1f23a {\n    background-position: 6.667% 95.000%;\n}\n.emoji-1f250 {\n    background-position: 6.667% 96.667%;\n}\n.emoji-1f251 {\n    background-position: 6.667% 98.333%;\n}\n.emoji-1f300 {\n    background-position: 6.667% 100.000%;\n}\n.emoji-1f301 {\n    background-position: 8.333% 0.000%;\n}\n.emoji-1f302 {\n    background-position: 8.333% 1.667%;\n}\n.emoji-1f303 {\n    background-position: 8.333% 3.333%;\n}\n.emoji-1f304 {\n    background-position: 8.333% 5.000%;\n}\n.emoji-1f305 {\n    background-position: 8.333% 6.667%;\n}\n.emoji-1f306 {\n    background-position: 8.333% 8.333%;\n}\n.emoji-1f307 {\n    background-position: 8.333% 10.000%;\n}\n.emoji-1f308 {\n    background-position: 8.333% 11.667%;\n}\n.emoji-1f309 {\n    background-position: 8.333% 13.333%;\n}\n.emoji-1f30a {\n    background-position: 8.333% 15.000%;\n}\n.emoji-1f30b {\n    background-position: 8.333% 16.667%;\n}\n.emoji-1f30c {\n    background-position: 8.333% 18.333%;\n}\n.emoji-1f30d {\n    background-position: 8.333% 20.000%;\n}\n.emoji-1f30e {\n    background-position: 8.333% 21.667%;\n}\n.emoji-1f30f {\n    background-position: 8.333% 23.333%;\n}\n.emoji-1f310 {\n    background-position: 8.333% 25.000%;\n}\n.emoji-1f311 {\n    background-position: 8.333% 26.667%;\n}\n.emoji-1f312 {\n    background-position: 8.333% 28.333%;\n}\n.emoji-1f313 {\n    background-position: 8.333% 30.000%;\n}\n.emoji-1f314 {\n    background-position: 8.333% 31.667%;\n}\n.emoji-1f315 {\n    background-position: 8.333% 33.333%;\n}\n.emoji-1f316 {\n    background-position: 8.333% 35.000%;\n}\n.emoji-1f317 {\n    background-position: 8.333% 36.667%;\n}\n.emoji-1f318 {\n    background-position: 8.333% 38.333%;\n}\n.emoji-1f319 {\n    background-position: 8.333% 40.000%;\n}\n.emoji-1f31a {\n    background-position: 8.333% 41.667%;\n}\n.emoji-1f31b {\n    background-position: 8.333% 43.333%;\n}\n.emoji-1f31c {\n    background-position: 8.333% 45.000%;\n}\n.emoji-1f31d {\n    background-position: 8.333% 46.667%;\n}\n.emoji-1f31e {\n    background-position: 8.333% 48.333%;\n}\n.emoji-1f31f {\n    background-position: 8.333% 50.000%;\n}\n.emoji-1f320 {\n    background-position: 8.333% 51.667%;\n}\n.emoji-1f321 {\n    background-position: 8.333% 53.333%;\n}\n.emoji-1f324 {\n    background-position: 8.333% 55.000%;\n}\n.emoji-1f325 {\n    background-position: 8.333% 56.667%;\n}\n.emoji-1f326 {\n    background-position: 8.333% 58.333%;\n}\n.emoji-1f327 {\n    background-position: 8.333% 60.000%;\n}\n.emoji-1f328 {\n    background-position: 8.333% 61.667%;\n}\n.emoji-1f329 {\n    background-position: 8.333% 63.333%;\n}\n.emoji-1f32a {\n    background-position: 8.333% 65.000%;\n}\n.emoji-1f32b {\n    background-position: 8.333% 66.667%;\n}\n.emoji-1f32c {\n    background-position: 8.333% 68.333%;\n}\n.emoji-1f32d {\n    background-position: 8.333% 70.000%;\n}\n.emoji-1f32e {\n    background-position: 8.333% 71.667%;\n}\n.emoji-1f32f {\n    background-position: 8.333% 73.333%;\n}\n.emoji-1f330 {\n    background-position: 8.333% 75.000%;\n}\n.emoji-1f331 {\n    background-position: 8.333% 76.667%;\n}\n.emoji-1f332 {\n    background-position: 8.333% 78.333%;\n}\n.emoji-1f333 {\n    background-position: 8.333% 80.000%;\n}\n.emoji-1f334 {\n    background-position: 8.333% 81.667%;\n}\n.emoji-1f335 {\n    background-position: 8.333% 83.333%;\n}\n.emoji-1f336 {\n    background-position: 8.333% 85.000%;\n}\n.emoji-1f337 {\n    background-position: 8.333% 86.667%;\n}\n.emoji-1f338 {\n    background-position: 8.333% 88.333%;\n}\n.emoji-1f339 {\n    background-position: 8.333% 90.000%;\n}\n.emoji-1f33a {\n    background-position: 8.333% 91.667%;\n}\n.emoji-1f33b {\n    background-position: 8.333% 93.333%;\n}\n.emoji-1f33c {\n    background-position: 8.333% 95.000%;\n}\n.emoji-1f33d {\n    background-position: 8.333% 96.667%;\n}\n.emoji-1f33e {\n    background-position: 8.333% 98.333%;\n}\n.emoji-1f33f {\n    background-position: 8.333% 100.000%;\n}\n.emoji-1f340 {\n    background-position: 10.000% 0.000%;\n}\n.emoji-1f341 {\n    background-position: 10.000% 1.667%;\n}\n.emoji-1f342 {\n    background-position: 10.000% 3.333%;\n}\n.emoji-1f343 {\n    background-position: 10.000% 5.000%;\n}\n.emoji-1f344 {\n    background-position: 10.000% 6.667%;\n}\n.emoji-1f345 {\n    background-position: 10.000% 8.333%;\n}\n.emoji-1f346 {\n    background-position: 10.000% 10.000%;\n}\n.emoji-1f347 {\n    background-position: 10.000% 11.667%;\n}\n.emoji-1f348 {\n    background-position: 10.000% 13.333%;\n}\n.emoji-1f349 {\n    background-position: 10.000% 15.000%;\n}\n.emoji-1f34a {\n    background-position: 10.000% 16.667%;\n}\n.emoji-1f34b {\n    background-position: 10.000% 18.333%;\n}\n.emoji-1f34c {\n    background-position: 10.000% 20.000%;\n}\n.emoji-1f34d {\n    background-position: 10.000% 21.667%;\n}\n.emoji-1f34e {\n    background-position: 10.000% 23.333%;\n}\n.emoji-1f34f {\n    background-position: 10.000% 25.000%;\n}\n.emoji-1f350 {\n    background-position: 10.000% 26.667%;\n}\n.emoji-1f351 {\n    background-position: 10.000% 28.333%;\n}\n.emoji-1f352 {\n    background-position: 10.000% 30.000%;\n}\n.emoji-1f353 {\n    background-position: 10.000% 31.667%;\n}\n.emoji-1f354 {\n    background-position: 10.000% 33.333%;\n}\n.emoji-1f355 {\n    background-position: 10.000% 35.000%;\n}\n.emoji-1f356 {\n    background-position: 10.000% 36.667%;\n}\n.emoji-1f357 {\n    background-position: 10.000% 38.333%;\n}\n.emoji-1f358 {\n    background-position: 10.000% 40.000%;\n}\n.emoji-1f359 {\n    background-position: 10.000% 41.667%;\n}\n.emoji-1f35a {\n    background-position: 10.000% 43.333%;\n}\n.emoji-1f35b {\n    background-position: 10.000% 45.000%;\n}\n.emoji-1f35c {\n    background-position: 10.000% 46.667%;\n}\n.emoji-1f35d {\n    background-position: 10.000% 48.333%;\n}\n.emoji-1f35e {\n    background-position: 10.000% 50.000%;\n}\n.emoji-1f35f {\n    background-position: 10.000% 51.667%;\n}\n.emoji-1f360 {\n    background-position: 10.000% 53.333%;\n}\n.emoji-1f361 {\n    background-position: 10.000% 55.000%;\n}\n.emoji-1f362 {\n    background-position: 10.000% 56.667%;\n}\n.emoji-1f363 {\n    background-position: 10.000% 58.333%;\n}\n.emoji-1f364 {\n    background-position: 10.000% 60.000%;\n}\n.emoji-1f365 {\n    background-position: 10.000% 61.667%;\n}\n.emoji-1f366 {\n    background-position: 10.000% 63.333%;\n}\n.emoji-1f367 {\n    background-position: 10.000% 65.000%;\n}\n.emoji-1f368 {\n    background-position: 10.000% 66.667%;\n}\n.emoji-1f369 {\n    background-position: 10.000% 68.333%;\n}\n.emoji-1f36a {\n    background-position: 10.000% 70.000%;\n}\n.emoji-1f36b {\n    background-position: 10.000% 71.667%;\n}\n.emoji-1f36c {\n    background-position: 10.000% 73.333%;\n}\n.emoji-1f36d {\n    background-position: 10.000% 75.000%;\n}\n.emoji-1f36e {\n    background-position: 10.000% 76.667%;\n}\n.emoji-1f36f {\n    background-position: 10.000% 78.333%;\n}\n.emoji-1f370 {\n    background-position: 10.000% 80.000%;\n}\n.emoji-1f371 {\n    background-position: 10.000% 81.667%;\n}\n.emoji-1f372 {\n    background-position: 10.000% 83.333%;\n}\n.emoji-1f373 {\n    background-position: 10.000% 85.000%;\n}\n.emoji-1f374 {\n    background-position: 10.000% 86.667%;\n}\n.emoji-1f375 {\n    background-position: 10.000% 88.333%;\n}\n.emoji-1f376 {\n    background-position: 10.000% 90.000%;\n}\n.emoji-1f377 {\n    background-position: 10.000% 91.667%;\n}\n.emoji-1f378 {\n    background-position: 10.000% 93.333%;\n}\n.emoji-1f379 {\n    background-position: 10.000% 95.000%;\n}\n.emoji-1f37a {\n    background-position: 10.000% 96.667%;\n}\n.emoji-1f37b {\n    background-position: 10.000% 98.333%;\n}\n.emoji-1f37c {\n    background-position: 10.000% 100.000%;\n}\n.emoji-1f37d {\n    background-position: 11.667% 0.000%;\n}\n.emoji-1f37e {\n    background-position: 11.667% 1.667%;\n}\n.emoji-1f37f {\n    background-position: 11.667% 3.333%;\n}\n.emoji-1f380 {\n    background-position: 11.667% 5.000%;\n}\n.emoji-1f381 {\n    background-position: 11.667% 6.667%;\n}\n.emoji-1f382 {\n    background-position: 11.667% 8.333%;\n}\n.emoji-1f383 {\n    background-position: 11.667% 10.000%;\n}\n.emoji-1f384 {\n    background-position: 11.667% 11.667%;\n}\n.emoji-1f385 {\n    background-position: 11.667% 13.333%;\n}\n.emoji-1f386 {\n    background-position: 11.667% 23.333%;\n}\n.emoji-1f387 {\n    background-position: 11.667% 25.000%;\n}\n.emoji-1f388 {\n    background-position: 11.667% 26.667%;\n}\n.emoji-1f389 {\n    background-position: 11.667% 28.333%;\n}\n.emoji-1f38a {\n    background-position: 11.667% 30.000%;\n}\n.emoji-1f38b {\n    background-position: 11.667% 31.667%;\n}\n.emoji-1f38c {\n    background-position: 11.667% 33.333%;\n}\n.emoji-1f38d {\n    background-position: 11.667% 35.000%;\n}\n.emoji-1f38e {\n    background-position: 11.667% 36.667%;\n}\n.emoji-1f38f {\n    background-position: 11.667% 38.333%;\n}\n.emoji-1f390 {\n    background-position: 11.667% 40.000%;\n}\n.emoji-1f391 {\n    background-position: 11.667% 41.667%;\n}\n.emoji-1f392 {\n    background-position: 11.667% 43.333%;\n}\n.emoji-1f393 {\n    background-position: 11.667% 45.000%;\n}\n.emoji-1f396 {\n    background-position: 11.667% 46.667%;\n}\n.emoji-1f397 {\n    background-position: 11.667% 48.333%;\n}\n.emoji-1f399 {\n    background-position: 11.667% 50.000%;\n}\n.emoji-1f39a {\n    background-position: 11.667% 51.667%;\n}\n.emoji-1f39b {\n    background-position: 11.667% 53.333%;\n}\n.emoji-1f39e {\n    background-position: 11.667% 55.000%;\n}\n.emoji-1f39f {\n    background-position: 11.667% 56.667%;\n}\n.emoji-1f3a0 {\n    background-position: 11.667% 58.333%;\n}\n.emoji-1f3a1 {\n    background-position: 11.667% 60.000%;\n}\n.emoji-1f3a2 {\n    background-position: 11.667% 61.667%;\n}\n.emoji-1f3a3 {\n    background-position: 11.667% 63.333%;\n}\n.emoji-1f3a4 {\n    background-position: 11.667% 65.000%;\n}\n.emoji-1f3a5 {\n    background-position: 11.667% 66.667%;\n}\n.emoji-1f3a6 {\n    background-position: 11.667% 68.333%;\n}\n.emoji-1f3a7 {\n    background-position: 11.667% 70.000%;\n}\n.emoji-1f3a8 {\n    background-position: 11.667% 71.667%;\n}\n.emoji-1f3a9 {\n    background-position: 11.667% 73.333%;\n}\n.emoji-1f3aa {\n    background-position: 11.667% 75.000%;\n}\n.emoji-1f3ab {\n    background-position: 11.667% 76.667%;\n}\n.emoji-1f3ac {\n    background-position: 11.667% 78.333%;\n}\n.emoji-1f3ad {\n    background-position: 11.667% 80.000%;\n}\n.emoji-1f3ae {\n    background-position: 11.667% 81.667%;\n}\n.emoji-1f3af {\n    background-position: 11.667% 83.333%;\n}\n.emoji-1f3b0 {\n    background-position: 11.667% 85.000%;\n}\n.emoji-1f3b1 {\n    background-position: 11.667% 86.667%;\n}\n.emoji-1f3b2 {\n    background-position: 11.667% 88.333%;\n}\n.emoji-1f3b3 {\n    background-position: 11.667% 90.000%;\n}\n.emoji-1f3b4 {\n    background-position: 11.667% 91.667%;\n}\n.emoji-1f3b5 {\n    background-position: 11.667% 93.333%;\n}\n.emoji-1f3b6 {\n    background-position: 11.667% 95.000%;\n}\n.emoji-1f3b7 {\n    background-position: 11.667% 96.667%;\n}\n.emoji-1f3b8 {\n    background-position: 11.667% 98.333%;\n}\n.emoji-1f3b9 {\n    background-position: 11.667% 100.000%;\n}\n.emoji-1f3ba {\n    background-position: 13.333% 0.000%;\n}\n.emoji-1f3bb {\n    background-position: 13.333% 1.667%;\n}\n.emoji-1f3bc {\n    background-position: 13.333% 3.333%;\n}\n.emoji-1f3bd {\n    background-position: 13.333% 5.000%;\n}\n.emoji-1f3be {\n    background-position: 13.333% 6.667%;\n}\n.emoji-1f3bf {\n    background-position: 13.333% 8.333%;\n}\n.emoji-1f3c0 {\n    background-position: 13.333% 10.000%;\n}\n.emoji-1f3c1 {\n    background-position: 13.333% 11.667%;\n}\n.emoji-1f3c2 {\n    background-position: 13.333% 13.333%;\n}\n.emoji-1f3c3-200d-2640 {\n    background-position: 13.333% 23.333%;\n}\n.emoji-1f3c3-200d-2642 {\n    background-position: 13.333% 33.333%;\n}\n.emoji-1f3c3 {\n    background-position: 13.333% 43.333%;\n}\n.emoji-1f3c4-200d-2640 {\n    background-position: 13.333% 53.333%;\n}\n.emoji-1f3c4-200d-2642 {\n    background-position: 13.333% 63.333%;\n}\n.emoji-1f3c4 {\n    background-position: 13.333% 73.333%;\n}\n.emoji-1f3c5 {\n    background-position: 13.333% 83.333%;\n}\n.emoji-1f3c6 {\n    background-position: 13.333% 85.000%;\n}\n.emoji-1f3c7 {\n    background-position: 13.333% 86.667%;\n}\n.emoji-1f3c8 {\n    background-position: 13.333% 96.667%;\n}\n.emoji-1f3c9 {\n    background-position: 13.333% 98.333%;\n}\n.emoji-1f3ca-200d-2640 {\n    background-position: 13.333% 100.000%;\n}\n.emoji-1f3ca-200d-2642 {\n    background-position: 15.000% 8.333%;\n}\n.emoji-1f3ca {\n    background-position: 15.000% 18.333%;\n}\n.emoji-1f3cb-200d-2640 {\n    background-position: 15.000% 28.333%;\n}\n.emoji-1f3cb-200d-2642 {\n    background-position: 15.000% 38.333%;\n}\n.emoji-1f3cb {\n    background-position: 15.000% 48.333%;\n}\n.emoji-1f3cc-200d-2640 {\n    background-position: 15.000% 58.333%;\n}\n.emoji-1f3cc-200d-2642 {\n    background-position: 15.000% 68.333%;\n}\n.emoji-1f3cc {\n    background-position: 15.000% 78.333%;\n}\n.emoji-1f3cd {\n    background-position: 15.000% 88.333%;\n}\n.emoji-1f3ce {\n    background-position: 15.000% 90.000%;\n}\n.emoji-1f3cf {\n    background-position: 15.000% 91.667%;\n}\n.emoji-1f3d0 {\n    background-position: 15.000% 93.333%;\n}\n.emoji-1f3d1 {\n    background-position: 15.000% 95.000%;\n}\n.emoji-1f3d2 {\n    background-position: 15.000% 96.667%;\n}\n.emoji-1f3d3 {\n    background-position: 15.000% 98.333%;\n}\n.emoji-1f3d4 {\n    background-position: 15.000% 100.000%;\n}\n.emoji-1f3d5 {\n    background-position: 16.667% 0.000%;\n}\n.emoji-1f3d6 {\n    background-position: 16.667% 1.667%;\n}\n.emoji-1f3d7 {\n    background-position: 16.667% 3.333%;\n}\n.emoji-1f3d8 {\n    background-position: 16.667% 5.000%;\n}\n.emoji-1f3d9 {\n    background-position: 16.667% 6.667%;\n}\n.emoji-1f3da {\n    background-position: 16.667% 8.333%;\n}\n.emoji-1f3db {\n    background-position: 16.667% 10.000%;\n}\n.emoji-1f3dc {\n    background-position: 16.667% 11.667%;\n}\n.emoji-1f3dd {\n    background-position: 16.667% 13.333%;\n}\n.emoji-1f3de {\n    background-position: 16.667% 15.000%;\n}\n.emoji-1f3df {\n    background-position: 16.667% 16.667%;\n}\n.emoji-1f3e0 {\n    background-position: 16.667% 18.333%;\n}\n.emoji-1f3e1 {\n    background-position: 16.667% 20.000%;\n}\n.emoji-1f3e2 {\n    background-position: 16.667% 21.667%;\n}\n.emoji-1f3e3 {\n    background-position: 16.667% 23.333%;\n}\n.emoji-1f3e4 {\n    background-position: 16.667% 25.000%;\n}\n.emoji-1f3e5 {\n    background-position: 16.667% 26.667%;\n}\n.emoji-1f3e6 {\n    background-position: 16.667% 28.333%;\n}\n.emoji-1f3e7 {\n    background-position: 16.667% 30.000%;\n}\n.emoji-1f3e8 {\n    background-position: 16.667% 31.667%;\n}\n.emoji-1f3e9 {\n    background-position: 16.667% 33.333%;\n}\n.emoji-1f3ea {\n    background-position: 16.667% 35.000%;\n}\n.emoji-1f3eb {\n    background-position: 16.667% 36.667%;\n}\n.emoji-1f3ec {\n    background-position: 16.667% 38.333%;\n}\n.emoji-1f3ed {\n    background-position: 16.667% 40.000%;\n}\n.emoji-1f3ee {\n    background-position: 16.667% 41.667%;\n}\n.emoji-1f3ef {\n    background-position: 16.667% 43.333%;\n}\n.emoji-1f3f0 {\n    background-position: 16.667% 45.000%;\n}\n.emoji-1f3f3-200d-1f308 {\n    background-position: 16.667% 46.667%;\n}\n.emoji-1f3f3-200d-26a7 {\n    background-position: 16.667% 48.333%;\n}\n.emoji-1f3f3 {\n    background-position: 16.667% 50.000%;\n}\n.emoji-1f3f4-200d-2620 {\n    background-position: 16.667% 51.667%;\n}\n.emoji-1f3f4-e0067-e0062-e0065-e006e-e0067-e007f {\n    background-position: 16.667% 53.333%;\n}\n.emoji-1f3f4-e0067-e0062-e0073-e0063-e0074-e007f {\n    background-position: 16.667% 55.000%;\n}\n.emoji-1f3f4-e0067-e0062-e0077-e006c-e0073-e007f {\n    background-position: 16.667% 56.667%;\n}\n.emoji-1f3f4 {\n    background-position: 16.667% 58.333%;\n}\n.emoji-1f3f5 {\n    background-position: 16.667% 60.000%;\n}\n.emoji-1f3f7 {\n    background-position: 16.667% 61.667%;\n}\n.emoji-1f3f8 {\n    background-position: 16.667% 63.333%;\n}\n.emoji-1f3f9 {\n    background-position: 16.667% 65.000%;\n}\n.emoji-1f3fa {\n    background-position: 16.667% 66.667%;\n}\n.emoji-1f3fb {\n    background-position: 16.667% 68.333%;\n}\n.emoji-1f3fc {\n    background-position: 16.667% 70.000%;\n}\n.emoji-1f3fd {\n    background-position: 16.667% 71.667%;\n}\n.emoji-1f3fe {\n    background-position: 16.667% 73.333%;\n}\n.emoji-1f3ff {\n    background-position: 16.667% 75.000%;\n}\n.emoji-1f400 {\n    background-position: 16.667% 76.667%;\n}\n.emoji-1f401 {\n    background-position: 16.667% 78.333%;\n}\n.emoji-1f402 {\n    background-position: 16.667% 80.000%;\n}\n.emoji-1f403 {\n    background-position: 16.667% 81.667%;\n}\n.emoji-1f404 {\n    background-position: 16.667% 83.333%;\n}\n.emoji-1f405 {\n    background-position: 16.667% 85.000%;\n}\n.emoji-1f406 {\n    background-position: 16.667% 86.667%;\n}\n.emoji-1f407 {\n    background-position: 16.667% 88.333%;\n}\n.emoji-1f408-200d-2b1b {\n    background-position: 16.667% 90.000%;\n}\n.emoji-1f408 {\n    background-position: 16.667% 91.667%;\n}\n.emoji-1f409 {\n    background-position: 16.667% 93.333%;\n}\n.emoji-1f40a {\n    background-position: 16.667% 95.000%;\n}\n.emoji-1f40b {\n    background-position: 16.667% 96.667%;\n}\n.emoji-1f40c {\n    background-position: 16.667% 98.333%;\n}\n.emoji-1f40d {\n    background-position: 16.667% 100.000%;\n}\n.emoji-1f40e {\n    background-position: 18.333% 0.000%;\n}\n.emoji-1f40f {\n    background-position: 18.333% 1.667%;\n}\n.emoji-1f410 {\n    background-position: 18.333% 3.333%;\n}\n.emoji-1f411 {\n    background-position: 18.333% 5.000%;\n}\n.emoji-1f412 {\n    background-position: 18.333% 6.667%;\n}\n.emoji-1f413 {\n    background-position: 18.333% 8.333%;\n}\n.emoji-1f414 {\n    background-position: 18.333% 10.000%;\n}\n.emoji-1f415-200d-1f9ba {\n    background-position: 18.333% 11.667%;\n}\n.emoji-1f415 {\n    background-position: 18.333% 13.333%;\n}\n.emoji-1f416 {\n    background-position: 18.333% 15.000%;\n}\n.emoji-1f417 {\n    background-position: 18.333% 16.667%;\n}\n.emoji-1f418 {\n    background-position: 18.333% 18.333%;\n}\n.emoji-1f419 {\n    background-position: 18.333% 20.000%;\n}\n.emoji-1f41a {\n    background-position: 18.333% 21.667%;\n}\n.emoji-1f41b {\n    background-position: 18.333% 23.333%;\n}\n.emoji-1f41c {\n    background-position: 18.333% 25.000%;\n}\n.emoji-1f41d {\n    background-position: 18.333% 26.667%;\n}\n.emoji-1f41e {\n    background-position: 18.333% 28.333%;\n}\n.emoji-1f41f {\n    background-position: 18.333% 30.000%;\n}\n.emoji-1f420 {\n    background-position: 18.333% 31.667%;\n}\n.emoji-1f421 {\n    background-position: 18.333% 33.333%;\n}\n.emoji-1f422 {\n    background-position: 18.333% 35.000%;\n}\n.emoji-1f423 {\n    background-position: 18.333% 36.667%;\n}\n.emoji-1f424 {\n    background-position: 18.333% 38.333%;\n}\n.emoji-1f425 {\n    background-position: 18.333% 40.000%;\n}\n.emoji-1f426-200d-2b1b {\n    background-position: 18.333% 41.667%;\n}\n.emoji-1f426 {\n    background-position: 18.333% 43.333%;\n}\n.emoji-1f427 {\n    background-position: 18.333% 45.000%;\n}\n.emoji-1f428 {\n    background-position: 18.333% 46.667%;\n}\n.emoji-1f429 {\n    background-position: 18.333% 48.333%;\n}\n.emoji-1f42a {\n    background-position: 18.333% 50.000%;\n}\n.emoji-1f42b {\n    background-position: 18.333% 51.667%;\n}\n.emoji-1f42c {\n    background-position: 18.333% 53.333%;\n}\n.emoji-1f42d {\n    background-position: 18.333% 55.000%;\n}\n.emoji-1f42e {\n    background-position: 18.333% 56.667%;\n}\n.emoji-1f42f {\n    background-position: 18.333% 58.333%;\n}\n.emoji-1f430 {\n    background-position: 18.333% 60.000%;\n}\n.emoji-1f431 {\n    background-position: 18.333% 61.667%;\n}\n.emoji-1f432 {\n    background-position: 18.333% 63.333%;\n}\n.emoji-1f433 {\n    background-position: 18.333% 65.000%;\n}\n.emoji-1f434 {\n    background-position: 18.333% 66.667%;\n}\n.emoji-1f435 {\n    background-position: 18.333% 68.333%;\n}\n.emoji-1f436 {\n    background-position: 18.333% 70.000%;\n}\n.emoji-1f437 {\n    background-position: 18.333% 71.667%;\n}\n.emoji-1f438 {\n    background-position: 18.333% 73.333%;\n}\n.emoji-1f439 {\n    background-position: 18.333% 75.000%;\n}\n.emoji-1f43a {\n    background-position: 18.333% 76.667%;\n}\n.emoji-1f43b-200d-2744 {\n    background-position: 18.333% 78.333%;\n}\n.emoji-1f43b {\n    background-position: 18.333% 80.000%;\n}\n.emoji-1f43c {\n    background-position: 18.333% 81.667%;\n}\n.emoji-1f43d {\n    background-position: 18.333% 83.333%;\n}\n.emoji-1f43e {\n    background-position: 18.333% 85.000%;\n}\n.emoji-1f43f {\n    background-position: 18.333% 86.667%;\n}\n.emoji-1f440 {\n    background-position: 18.333% 88.333%;\n}\n.emoji-1f441-200d-1f5e8 {\n    background-position: 18.333% 90.000%;\n}\n.emoji-1f441 {\n    background-position: 18.333% 91.667%;\n}\n.emoji-1f442 {\n    background-position: 18.333% 93.333%;\n}\n.emoji-1f443 {\n    background-position: 20.000% 1.667%;\n}\n.emoji-1f444 {\n    background-position: 20.000% 11.667%;\n}\n.emoji-1f445 {\n    background-position: 20.000% 13.333%;\n}\n.emoji-1f446 {\n    background-position: 20.000% 15.000%;\n}\n.emoji-1f447 {\n    background-position: 20.000% 25.000%;\n}\n.emoji-1f448 {\n    background-position: 20.000% 35.000%;\n}\n.emoji-1f449 {\n    background-position: 20.000% 45.000%;\n}\n.emoji-1f44a {\n    background-position: 20.000% 55.000%;\n}\n.emoji-1f44b {\n    background-position: 20.000% 65.000%;\n}\n.emoji-1f44c {\n    background-position: 20.000% 75.000%;\n}\n.emoji-1f44d {\n    background-position: 20.000% 85.000%;\n}\n.emoji-1f44e {\n    background-position: 20.000% 95.000%;\n}\n.emoji-1f44f {\n    background-position: 21.667% 3.333%;\n}\n.emoji-1f450 {\n    background-position: 21.667% 13.333%;\n}\n.emoji-1f451 {\n    background-position: 21.667% 23.333%;\n}\n.emoji-1f452 {\n    background-position: 21.667% 25.000%;\n}\n.emoji-1f453 {\n    background-position: 21.667% 26.667%;\n}\n.emoji-1f454 {\n    background-position: 21.667% 28.333%;\n}\n.emoji-1f455 {\n    background-position: 21.667% 30.000%;\n}\n.emoji-1f456 {\n    background-position: 21.667% 31.667%;\n}\n.emoji-1f457 {\n    background-position: 21.667% 33.333%;\n}\n.emoji-1f458 {\n    background-position: 21.667% 35.000%;\n}\n.emoji-1f459 {\n    background-position: 21.667% 36.667%;\n}\n.emoji-1f45a {\n    background-position: 21.667% 38.333%;\n}\n.emoji-1f45b {\n    background-position: 21.667% 40.000%;\n}\n.emoji-1f45c {\n    background-position: 21.667% 41.667%;\n}\n.emoji-1f45d {\n    background-position: 21.667% 43.333%;\n}\n.emoji-1f45e {\n    background-position: 21.667% 45.000%;\n}\n.emoji-1f45f {\n    background-position: 21.667% 46.667%;\n}\n.emoji-1f460 {\n    background-position: 21.667% 48.333%;\n}\n.emoji-1f461 {\n    background-position: 21.667% 50.000%;\n}\n.emoji-1f462 {\n    background-position: 21.667% 51.667%;\n}\n.emoji-1f463 {\n    background-position: 21.667% 53.333%;\n}\n.emoji-1f464 {\n    background-position: 21.667% 55.000%;\n}\n.emoji-1f465 {\n    background-position: 21.667% 56.667%;\n}\n.emoji-1f466 {\n    background-position: 21.667% 58.333%;\n}\n.emoji-1f467 {\n    background-position: 21.667% 68.333%;\n}\n.emoji-1f468-200d-1f33e {\n    background-position: 21.667% 78.333%;\n}\n.emoji-1f468-200d-1f373 {\n    background-position: 21.667% 88.333%;\n}\n.emoji-1f468-200d-1f37c {\n    background-position: 21.667% 98.333%;\n}\n.emoji-1f468-200d-1f393 {\n    background-position: 23.333% 6.667%;\n}\n.emoji-1f468-200d-1f3a4 {\n    background-position: 23.333% 16.667%;\n}\n.emoji-1f468-200d-1f3a8 {\n    background-position: 23.333% 26.667%;\n}\n.emoji-1f468-200d-1f3eb {\n    background-position: 23.333% 36.667%;\n}\n.emoji-1f468-200d-1f3ed {\n    background-position: 23.333% 46.667%;\n}\n.emoji-1f468-200d-1f466-200d-1f466 {\n    background-position: 23.333% 56.667%;\n}\n.emoji-1f468-200d-1f466 {\n    background-position: 23.333% 58.333%;\n}\n.emoji-1f468-200d-1f467-200d-1f466 {\n    background-position: 23.333% 60.000%;\n}\n.emoji-1f468-200d-1f467-200d-1f467 {\n    background-position: 23.333% 61.667%;\n}\n.emoji-1f468-200d-1f467 {\n    background-position: 23.333% 63.333%;\n}\n.emoji-1f468-200d-1f468-200d-1f466 {\n    background-position: 23.333% 65.000%;\n}\n.emoji-1f468-200d-1f468-200d-1f466-200d-1f466 {\n    background-position: 23.333% 66.667%;\n}\n.emoji-1f468-200d-1f468-200d-1f467 {\n    background-position: 23.333% 68.333%;\n}\n.emoji-1f468-200d-1f468-200d-1f467-200d-1f466 {\n    background-position: 23.333% 70.000%;\n}\n.emoji-1f468-200d-1f468-200d-1f467-200d-1f467 {\n    background-position: 23.333% 71.667%;\n}\n.emoji-1f468-200d-1f469-200d-1f466 {\n    background-position: 23.333% 73.333%;\n}\n.emoji-1f468-200d-1f469-200d-1f466-200d-1f466 {\n    background-position: 23.333% 75.000%;\n}\n.emoji-1f468-200d-1f469-200d-1f467 {\n    background-position: 23.333% 76.667%;\n}\n.emoji-1f468-200d-1f469-200d-1f467-200d-1f466 {\n    background-position: 23.333% 78.333%;\n}\n.emoji-1f468-200d-1f469-200d-1f467-200d-1f467 {\n    background-position: 23.333% 80.000%;\n}\n.emoji-1f468-200d-1f4bb {\n    background-position: 23.333% 81.667%;\n}\n.emoji-1f468-200d-1f4bc {\n    background-position: 23.333% 91.667%;\n}\n.emoji-1f468-200d-1f527 {\n    background-position: 25.000% 0.000%;\n}\n.emoji-1f468-200d-1f52c {\n    background-position: 25.000% 10.000%;\n}\n.emoji-1f468-200d-1f680 {\n    background-position: 25.000% 20.000%;\n}\n.emoji-1f468-200d-1f692 {\n    background-position: 25.000% 30.000%;\n}\n.emoji-1f468-200d-1f9af {\n    background-position: 25.000% 40.000%;\n}\n.emoji-1f468-200d-1f9b0 {\n    background-position: 25.000% 50.000%;\n}\n.emoji-1f468-200d-1f9b1 {\n    background-position: 25.000% 60.000%;\n}\n.emoji-1f468-200d-1f9b2 {\n    background-position: 25.000% 70.000%;\n}\n.emoji-1f468-200d-1f9b3 {\n    background-position: 25.000% 80.000%;\n}\n.emoji-1f468-200d-1f9bc {\n    background-position: 25.000% 90.000%;\n}\n.emoji-1f468-200d-1f9bd {\n    background-position: 25.000% 100.000%;\n}\n.emoji-1f468-200d-2695 {\n    background-position: 26.667% 8.333%;\n}\n.emoji-1f468-200d-2696 {\n    background-position: 26.667% 18.333%;\n}\n.emoji-1f468-200d-2708 {\n    background-position: 26.667% 28.333%;\n}\n.emoji-1f468-200d-2764-200d-1f468 {\n    background-position: 26.667% 38.333%;\n}\n.emoji-1f468-200d-2764-200d-1f48b-200d-1f468 {\n    background-position: 26.667% 81.667%;\n}\n.emoji-1f468 {\n    background-position: 28.333% 23.333%;\n}\n.emoji-1f469-200d-1f33e {\n    background-position: 28.333% 33.333%;\n}\n.emoji-1f469-200d-1f373 {\n    background-position: 28.333% 43.333%;\n}\n.emoji-1f469-200d-1f37c {\n    background-position: 28.333% 53.333%;\n}\n.emoji-1f469-200d-1f393 {\n    background-position: 28.333% 63.333%;\n}\n.emoji-1f469-200d-1f3a4 {\n    background-position: 28.333% 73.333%;\n}\n.emoji-1f469-200d-1f3a8 {\n    background-position: 28.333% 83.333%;\n}\n.emoji-1f469-200d-1f3eb {\n    background-position: 28.333% 93.333%;\n}\n.emoji-1f469-200d-1f3ed {\n    background-position: 30.000% 1.667%;\n}\n.emoji-1f469-200d-1f466-200d-1f466 {\n    background-position: 30.000% 11.667%;\n}\n.emoji-1f469-200d-1f466 {\n    background-position: 30.000% 13.333%;\n}\n.emoji-1f469-200d-1f467-200d-1f466 {\n    background-position: 30.000% 15.000%;\n}\n.emoji-1f469-200d-1f467-200d-1f467 {\n    background-position: 30.000% 16.667%;\n}\n.emoji-1f469-200d-1f467 {\n    background-position: 30.000% 18.333%;\n}\n.emoji-1f469-200d-1f469-200d-1f466 {\n    background-position: 30.000% 20.000%;\n}\n.emoji-1f469-200d-1f469-200d-1f466-200d-1f466 {\n    background-position: 30.000% 21.667%;\n}\n.emoji-1f469-200d-1f469-200d-1f467 {\n    background-position: 30.000% 23.333%;\n}\n.emoji-1f469-200d-1f469-200d-1f467-200d-1f466 {\n    background-position: 30.000% 25.000%;\n}\n.emoji-1f469-200d-1f469-200d-1f467-200d-1f467 {\n    background-position: 30.000% 26.667%;\n}\n.emoji-1f469-200d-1f4bb {\n    background-position: 30.000% 28.333%;\n}\n.emoji-1f469-200d-1f4bc {\n    background-position: 30.000% 38.333%;\n}\n.emoji-1f469-200d-1f527 {\n    background-position: 30.000% 48.333%;\n}\n.emoji-1f469-200d-1f52c {\n    background-position: 30.000% 58.333%;\n}\n.emoji-1f469-200d-1f680 {\n    background-position: 30.000% 68.333%;\n}\n.emoji-1f469-200d-1f692 {\n    background-position: 30.000% 78.333%;\n}\n.emoji-1f469-200d-1f9af {\n    background-position: 30.000% 88.333%;\n}\n.emoji-1f469-200d-1f9b0 {\n    background-position: 30.000% 98.333%;\n}\n.emoji-1f469-200d-1f9b1 {\n    background-position: 31.667% 6.667%;\n}\n.emoji-1f469-200d-1f9b2 {\n    background-position: 31.667% 16.667%;\n}\n.emoji-1f469-200d-1f9b3 {\n    background-position: 31.667% 26.667%;\n}\n.emoji-1f469-200d-1f9bc {\n    background-position: 31.667% 36.667%;\n}\n.emoji-1f469-200d-1f9bd {\n    background-position: 31.667% 46.667%;\n}\n.emoji-1f469-200d-2695 {\n    background-position: 31.667% 56.667%;\n}\n.emoji-1f469-200d-2696 {\n    background-position: 31.667% 66.667%;\n}\n.emoji-1f469-200d-2708 {\n    background-position: 31.667% 76.667%;\n}\n.emoji-1f469-200d-2764-200d-1f468 {\n    background-position: 31.667% 86.667%;\n}\n.emoji-1f469-200d-2764-200d-1f469 {\n    background-position: 33.333% 28.333%;\n}\n.emoji-1f469-200d-2764-200d-1f48b-200d-1f468 {\n    background-position: 33.333% 71.667%;\n}\n.emoji-1f469-200d-2764-200d-1f48b-200d-1f469 {\n    background-position: 35.000% 13.333%;\n}\n.emoji-1f469 {\n    background-position: 35.000% 56.667%;\n}\n.emoji-1f46a {\n    background-position: 35.000% 66.667%;\n}\n.emoji-1f46b {\n    background-position: 35.000% 68.333%;\n}\n.emoji-1f46c {\n    background-position: 36.667% 10.000%;\n}\n.emoji-1f46d {\n    background-position: 36.667% 53.333%;\n}\n.emoji-1f46e-200d-2640 {\n    background-position: 36.667% 96.667%;\n}\n.emoji-1f46e-200d-2642 {\n    background-position: 38.333% 5.000%;\n}\n.emoji-1f46e {\n    background-position: 38.333% 15.000%;\n}\n.emoji-1f46f-200d-2640 {\n    background-position: 38.333% 25.000%;\n}\n.emoji-1f46f-200d-2642 {\n    background-position: 38.333% 26.667%;\n}\n.emoji-1f46f {\n    background-position: 38.333% 28.333%;\n}\n.emoji-1f470-200d-2640 {\n    background-position: 38.333% 30.000%;\n}\n.emoji-1f470-200d-2642 {\n    background-position: 38.333% 40.000%;\n}\n.emoji-1f470 {\n    background-position: 38.333% 50.000%;\n}\n.emoji-1f471-200d-2640 {\n    background-position: 38.333% 60.000%;\n}\n.emoji-1f471-200d-2642 {\n    background-position: 38.333% 70.000%;\n}\n.emoji-1f471 {\n    background-position: 38.333% 80.000%;\n}\n.emoji-1f472 {\n    background-position: 38.333% 90.000%;\n}\n.emoji-1f473-200d-2640 {\n    background-position: 38.333% 100.000%;\n}\n.emoji-1f473-200d-2642 {\n    background-position: 40.000% 8.333%;\n}\n.emoji-1f473 {\n    background-position: 40.000% 18.333%;\n}\n.emoji-1f474 {\n    background-position: 40.000% 28.333%;\n}\n.emoji-1f475 {\n    background-position: 40.000% 38.333%;\n}\n.emoji-1f476 {\n    background-position: 40.000% 48.333%;\n}\n.emoji-1f477-200d-2640 {\n    background-position: 40.000% 58.333%;\n}\n.emoji-1f477-200d-2642 {\n    background-position: 40.000% 68.333%;\n}\n.emoji-1f477 {\n    background-position: 40.000% 78.333%;\n}\n.emoji-1f478 {\n    background-position: 40.000% 88.333%;\n}\n.emoji-1f479 {\n    background-position: 40.000% 98.333%;\n}\n.emoji-1f47a {\n    background-position: 40.000% 100.000%;\n}\n.emoji-1f47b {\n    background-position: 41.667% 0.000%;\n}\n.emoji-1f47c {\n    background-position: 41.667% 1.667%;\n}\n.emoji-1f47d {\n    background-position: 41.667% 11.667%;\n}\n.emoji-1f47e {\n    background-position: 41.667% 13.333%;\n}\n.emoji-1f47f {\n    background-position: 41.667% 15.000%;\n}\n.emoji-1f480 {\n    background-position: 41.667% 16.667%;\n}\n.emoji-1f481-200d-2640 {\n    background-position: 41.667% 18.333%;\n}\n.emoji-1f481-200d-2642 {\n    background-position: 41.667% 28.333%;\n}\n.emoji-1f481 {\n    background-position: 41.667% 38.333%;\n}\n.emoji-1f482-200d-2640 {\n    background-position: 41.667% 48.333%;\n}\n.emoji-1f482-200d-2642 {\n    background-position: 41.667% 58.333%;\n}\n.emoji-1f482 {\n    background-position: 41.667% 68.333%;\n}\n.emoji-1f483 {\n    background-position: 41.667% 78.333%;\n}\n.emoji-1f484 {\n    background-position: 41.667% 88.333%;\n}\n.emoji-1f485 {\n    background-position: 41.667% 90.000%;\n}\n.emoji-1f486-200d-2640 {\n    background-position: 41.667% 100.000%;\n}\n.emoji-1f486-200d-2642 {\n    background-position: 43.333% 8.333%;\n}\n.emoji-1f486 {\n    background-position: 43.333% 18.333%;\n}\n.emoji-1f487-200d-2640 {\n    background-position: 43.333% 28.333%;\n}\n.emoji-1f487-200d-2642 {\n    background-position: 43.333% 38.333%;\n}\n.emoji-1f487 {\n    background-position: 43.333% 48.333%;\n}\n.emoji-1f488 {\n    background-position: 43.333% 58.333%;\n}\n.emoji-1f489 {\n    background-position: 43.333% 60.000%;\n}\n.emoji-1f48a {\n    background-position: 43.333% 61.667%;\n}\n.emoji-1f48b {\n    background-position: 43.333% 63.333%;\n}\n.emoji-1f48c {\n    background-position: 43.333% 65.000%;\n}\n.emoji-1f48d {\n    background-position: 43.333% 66.667%;\n}\n.emoji-1f48e {\n    background-position: 43.333% 68.333%;\n}\n.emoji-1f48f {\n    background-position: 43.333% 70.000%;\n}\n.emoji-1f490 {\n    background-position: 45.000% 11.667%;\n}\n.emoji-1f491 {\n    background-position: 45.000% 13.333%;\n}\n.emoji-1f492 {\n    background-position: 45.000% 56.667%;\n}\n.emoji-1f493 {\n    background-position: 45.000% 58.333%;\n}\n.emoji-1f494 {\n    background-position: 45.000% 60.000%;\n}\n.emoji-1f495 {\n    background-position: 45.000% 61.667%;\n}\n.emoji-1f496 {\n    background-position: 45.000% 63.333%;\n}\n.emoji-1f497 {\n    background-position: 45.000% 65.000%;\n}\n.emoji-1f498 {\n    background-position: 45.000% 66.667%;\n}\n.emoji-1f499 {\n    background-position: 45.000% 68.333%;\n}\n.emoji-1f49a {\n    background-position: 45.000% 70.000%;\n}\n.emoji-1f49b {\n    background-position: 45.000% 71.667%;\n}\n.emoji-1f49c {\n    background-position: 45.000% 73.333%;\n}\n.emoji-1f49d {\n    background-position: 45.000% 75.000%;\n}\n.emoji-1f49e {\n    background-position: 45.000% 76.667%;\n}\n.emoji-1f49f {\n    background-position: 45.000% 78.333%;\n}\n.emoji-1f4a0 {\n    background-position: 45.000% 80.000%;\n}\n.emoji-1f4a1 {\n    background-position: 45.000% 81.667%;\n}\n.emoji-1f4a2 {\n    background-position: 45.000% 83.333%;\n}\n.emoji-1f4a3 {\n    background-position: 45.000% 85.000%;\n}\n.emoji-1f4a4 {\n    background-position: 45.000% 86.667%;\n}\n.emoji-1f4a5 {\n    background-position: 45.000% 88.333%;\n}\n.emoji-1f4a6 {\n    background-position: 45.000% 90.000%;\n}\n.emoji-1f4a7 {\n    background-position: 45.000% 91.667%;\n}\n.emoji-1f4a8 {\n    background-position: 45.000% 93.333%;\n}\n.emoji-1f4a9 {\n    background-position: 45.000% 95.000%;\n}\n.emoji-1f4aa {\n    background-position: 45.000% 96.667%;\n}\n.emoji-1f4ab {\n    background-position: 46.667% 5.000%;\n}\n.emoji-1f4ac {\n    background-position: 46.667% 6.667%;\n}\n.emoji-1f4ad {\n    background-position: 46.667% 8.333%;\n}\n.emoji-1f4ae {\n    background-position: 46.667% 10.000%;\n}\n.emoji-1f4af {\n    background-position: 46.667% 11.667%;\n}\n.emoji-1f4b0 {\n    background-position: 46.667% 13.333%;\n}\n.emoji-1f4b1 {\n    background-position: 46.667% 15.000%;\n}\n.emoji-1f4b2 {\n    background-position: 46.667% 16.667%;\n}\n.emoji-1f4b3 {\n    background-position: 46.667% 18.333%;\n}\n.emoji-1f4b4 {\n    background-position: 46.667% 20.000%;\n}\n.emoji-1f4b5 {\n    background-position: 46.667% 21.667%;\n}\n.emoji-1f4b6 {\n    background-position: 46.667% 23.333%;\n}\n.emoji-1f4b7 {\n    background-position: 46.667% 25.000%;\n}\n.emoji-1f4b8 {\n    background-position: 46.667% 26.667%;\n}\n.emoji-1f4b9 {\n    background-position: 46.667% 28.333%;\n}\n.emoji-1f4ba {\n    background-position: 46.667% 30.000%;\n}\n.emoji-1f4bb {\n    background-position: 46.667% 31.667%;\n}\n.emoji-1f4bc {\n    background-position: 46.667% 33.333%;\n}\n.emoji-1f4bd {\n    background-position: 46.667% 35.000%;\n}\n.emoji-1f4be {\n    background-position: 46.667% 36.667%;\n}\n.emoji-1f4bf {\n    background-position: 46.667% 38.333%;\n}\n.emoji-1f4c0 {\n    background-position: 46.667% 40.000%;\n}\n.emoji-1f4c1 {\n    background-position: 46.667% 41.667%;\n}\n.emoji-1f4c2 {\n    background-position: 46.667% 43.333%;\n}\n.emoji-1f4c3 {\n    background-position: 46.667% 45.000%;\n}\n.emoji-1f4c4 {\n    background-position: 46.667% 46.667%;\n}\n.emoji-1f4c5 {\n    background-position: 46.667% 48.333%;\n}\n.emoji-1f4c6 {\n    background-position: 46.667% 50.000%;\n}\n.emoji-1f4c7 {\n    background-position: 46.667% 51.667%;\n}\n.emoji-1f4c8 {\n    background-position: 46.667% 53.333%;\n}\n.emoji-1f4c9 {\n    background-position: 46.667% 55.000%;\n}\n.emoji-1f4ca {\n    background-position: 46.667% 56.667%;\n}\n.emoji-1f4cb {\n    background-position: 46.667% 58.333%;\n}\n.emoji-1f4cc {\n    background-position: 46.667% 60.000%;\n}\n.emoji-1f4cd {\n    background-position: 46.667% 61.667%;\n}\n.emoji-1f4ce {\n    background-position: 46.667% 63.333%;\n}\n.emoji-1f4cf {\n    background-position: 46.667% 65.000%;\n}\n.emoji-1f4d0 {\n    background-position: 46.667% 66.667%;\n}\n.emoji-1f4d1 {\n    background-position: 46.667% 68.333%;\n}\n.emoji-1f4d2 {\n    background-position: 46.667% 70.000%;\n}\n.emoji-1f4d3 {\n    background-position: 46.667% 71.667%;\n}\n.emoji-1f4d4 {\n    background-position: 46.667% 73.333%;\n}\n.emoji-1f4d5 {\n    background-position: 46.667% 75.000%;\n}\n.emoji-1f4d6 {\n    background-position: 46.667% 76.667%;\n}\n.emoji-1f4d7 {\n    background-position: 46.667% 78.333%;\n}\n.emoji-1f4d8 {\n    background-position: 46.667% 80.000%;\n}\n.emoji-1f4d9 {\n    background-position: 46.667% 81.667%;\n}\n.emoji-1f4da {\n    background-position: 46.667% 83.333%;\n}\n.emoji-1f4db {\n    background-position: 46.667% 85.000%;\n}\n.emoji-1f4dc {\n    background-position: 46.667% 86.667%;\n}\n.emoji-1f4dd {\n    background-position: 46.667% 88.333%;\n}\n.emoji-1f4de {\n    background-position: 46.667% 90.000%;\n}\n.emoji-1f4df {\n    background-position: 46.667% 91.667%;\n}\n.emoji-1f4e0 {\n    background-position: 46.667% 93.333%;\n}\n.emoji-1f4e1 {\n    background-position: 46.667% 95.000%;\n}\n.emoji-1f4e2 {\n    background-position: 46.667% 96.667%;\n}\n.emoji-1f4e3 {\n    background-position: 46.667% 98.333%;\n}\n.emoji-1f4e4 {\n    background-position: 46.667% 100.000%;\n}\n.emoji-1f4e5 {\n    background-position: 48.333% 0.000%;\n}\n.emoji-1f4e6 {\n    background-position: 48.333% 1.667%;\n}\n.emoji-1f4e7 {\n    background-position: 48.333% 3.333%;\n}\n.emoji-1f4e8 {\n    background-position: 48.333% 5.000%;\n}\n.emoji-1f4e9 {\n    background-position: 48.333% 6.667%;\n}\n.emoji-1f4ea {\n    background-position: 48.333% 8.333%;\n}\n.emoji-1f4eb {\n    background-position: 48.333% 10.000%;\n}\n.emoji-1f4ec {\n    background-position: 48.333% 11.667%;\n}\n.emoji-1f4ed {\n    background-position: 48.333% 13.333%;\n}\n.emoji-1f4ee {\n    background-position: 48.333% 15.000%;\n}\n.emoji-1f4ef {\n    background-position: 48.333% 16.667%;\n}\n.emoji-1f4f0 {\n    background-position: 48.333% 18.333%;\n}\n.emoji-1f4f1 {\n    background-position: 48.333% 20.000%;\n}\n.emoji-1f4f2 {\n    background-position: 48.333% 21.667%;\n}\n.emoji-1f4f3 {\n    background-position: 48.333% 23.333%;\n}\n.emoji-1f4f4 {\n    background-position: 48.333% 25.000%;\n}\n.emoji-1f4f5 {\n    background-position: 48.333% 26.667%;\n}\n.emoji-1f4f6 {\n    background-position: 48.333% 28.333%;\n}\n.emoji-1f4f7 {\n    background-position: 48.333% 30.000%;\n}\n.emoji-1f4f8 {\n    background-position: 48.333% 31.667%;\n}\n.emoji-1f4f9 {\n    background-position: 48.333% 33.333%;\n}\n.emoji-1f4fa {\n    background-position: 48.333% 35.000%;\n}\n.emoji-1f4fb {\n    background-position: 48.333% 36.667%;\n}\n.emoji-1f4fc {\n    background-position: 48.333% 38.333%;\n}\n.emoji-1f4fd {\n    background-position: 48.333% 40.000%;\n}\n.emoji-1f4ff {\n    background-position: 48.333% 41.667%;\n}\n.emoji-1f500 {\n    background-position: 48.333% 43.333%;\n}\n.emoji-1f501 {\n    background-position: 48.333% 45.000%;\n}\n.emoji-1f502 {\n    background-position: 48.333% 46.667%;\n}\n.emoji-1f503 {\n    background-position: 48.333% 48.333%;\n}\n.emoji-1f504 {\n    background-position: 48.333% 50.000%;\n}\n.emoji-1f505 {\n    background-position: 48.333% 51.667%;\n}\n.emoji-1f506 {\n    background-position: 48.333% 53.333%;\n}\n.emoji-1f507 {\n    background-position: 48.333% 55.000%;\n}\n.emoji-1f508 {\n    background-position: 48.333% 56.667%;\n}\n.emoji-1f509 {\n    background-position: 48.333% 58.333%;\n}\n.emoji-1f50a {\n    background-position: 48.333% 60.000%;\n}\n.emoji-1f50b {\n    background-position: 48.333% 61.667%;\n}\n.emoji-1f50c {\n    background-position: 48.333% 63.333%;\n}\n.emoji-1f50d {\n    background-position: 48.333% 65.000%;\n}\n.emoji-1f50e {\n    background-position: 48.333% 66.667%;\n}\n.emoji-1f50f {\n    background-position: 48.333% 68.333%;\n}\n.emoji-1f510 {\n    background-position: 48.333% 70.000%;\n}\n.emoji-1f511 {\n    background-position: 48.333% 71.667%;\n}\n.emoji-1f512 {\n    background-position: 48.333% 73.333%;\n}\n.emoji-1f513 {\n    background-position: 48.333% 75.000%;\n}\n.emoji-1f514 {\n    background-position: 48.333% 76.667%;\n}\n.emoji-1f515 {\n    background-position: 48.333% 78.333%;\n}\n.emoji-1f516 {\n    background-position: 48.333% 80.000%;\n}\n.emoji-1f517 {\n    background-position: 48.333% 81.667%;\n}\n.emoji-1f518 {\n    background-position: 48.333% 83.333%;\n}\n.emoji-1f519 {\n    background-position: 48.333% 85.000%;\n}\n.emoji-1f51a {\n    background-position: 48.333% 86.667%;\n}\n.emoji-1f51b {\n    background-position: 48.333% 88.333%;\n}\n.emoji-1f51c {\n    background-position: 48.333% 90.000%;\n}\n.emoji-1f51d {\n    background-position: 48.333% 91.667%;\n}\n.emoji-1f51e {\n    background-position: 48.333% 93.333%;\n}\n.emoji-1f51f {\n    background-position: 48.333% 95.000%;\n}\n.emoji-1f520 {\n    background-position: 48.333% 96.667%;\n}\n.emoji-1f521 {\n    background-position: 48.333% 98.333%;\n}\n.emoji-1f522 {\n    background-position: 48.333% 100.000%;\n}\n.emoji-1f523 {\n    background-position: 50.000% 0.000%;\n}\n.emoji-1f524 {\n    background-position: 50.000% 1.667%;\n}\n.emoji-1f525 {\n    background-position: 50.000% 3.333%;\n}\n.emoji-1f526 {\n    background-position: 50.000% 5.000%;\n}\n.emoji-1f527 {\n    background-position: 50.000% 6.667%;\n}\n.emoji-1f528 {\n    background-position: 50.000% 8.333%;\n}\n.emoji-1f529 {\n    background-position: 50.000% 10.000%;\n}\n.emoji-1f52a {\n    background-position: 50.000% 11.667%;\n}\n.emoji-1f52b {\n    background-position: 50.000% 13.333%;\n}\n.emoji-1f52c {\n    background-position: 50.000% 15.000%;\n}\n.emoji-1f52d {\n    background-position: 50.000% 16.667%;\n}\n.emoji-1f52e {\n    background-position: 50.000% 18.333%;\n}\n.emoji-1f52f {\n    background-position: 50.000% 20.000%;\n}\n.emoji-1f530 {\n    background-position: 50.000% 21.667%;\n}\n.emoji-1f531 {\n    background-position: 50.000% 23.333%;\n}\n.emoji-1f532 {\n    background-position: 50.000% 25.000%;\n}\n.emoji-1f533 {\n    background-position: 50.000% 26.667%;\n}\n.emoji-1f534 {\n    background-position: 50.000% 28.333%;\n}\n.emoji-1f535 {\n    background-position: 50.000% 30.000%;\n}\n.emoji-1f536 {\n    background-position: 50.000% 31.667%;\n}\n.emoji-1f537 {\n    background-position: 50.000% 33.333%;\n}\n.emoji-1f538 {\n    background-position: 50.000% 35.000%;\n}\n.emoji-1f539 {\n    background-position: 50.000% 36.667%;\n}\n.emoji-1f53a {\n    background-position: 50.000% 38.333%;\n}\n.emoji-1f53b {\n    background-position: 50.000% 40.000%;\n}\n.emoji-1f53c {\n    background-position: 50.000% 41.667%;\n}\n.emoji-1f53d {\n    background-position: 50.000% 43.333%;\n}\n.emoji-1f549 {\n    background-position: 50.000% 45.000%;\n}\n.emoji-1f54a {\n    background-position: 50.000% 46.667%;\n}\n.emoji-1f54b {\n    background-position: 50.000% 48.333%;\n}\n.emoji-1f54c {\n    background-position: 50.000% 50.000%;\n}\n.emoji-1f54d {\n    background-position: 50.000% 51.667%;\n}\n.emoji-1f54e {\n    background-position: 50.000% 53.333%;\n}\n.emoji-1f550 {\n    background-position: 50.000% 55.000%;\n}\n.emoji-1f551 {\n    background-position: 50.000% 56.667%;\n}\n.emoji-1f552 {\n    background-position: 50.000% 58.333%;\n}\n.emoji-1f553 {\n    background-position: 50.000% 60.000%;\n}\n.emoji-1f554 {\n    background-position: 50.000% 61.667%;\n}\n.emoji-1f555 {\n    background-position: 50.000% 63.333%;\n}\n.emoji-1f556 {\n    background-position: 50.000% 65.000%;\n}\n.emoji-1f557 {\n    background-position: 50.000% 66.667%;\n}\n.emoji-1f558 {\n    background-position: 50.000% 68.333%;\n}\n.emoji-1f559 {\n    background-position: 50.000% 70.000%;\n}\n.emoji-1f55a {\n    background-position: 50.000% 71.667%;\n}\n.emoji-1f55b {\n    background-position: 50.000% 73.333%;\n}\n.emoji-1f55c {\n    background-position: 50.000% 75.000%;\n}\n.emoji-1f55d {\n    background-position: 50.000% 76.667%;\n}\n.emoji-1f55e {\n    background-position: 50.000% 78.333%;\n}\n.emoji-1f55f {\n    background-position: 50.000% 80.000%;\n}\n.emoji-1f560 {\n    background-position: 50.000% 81.667%;\n}\n.emoji-1f561 {\n    background-position: 50.000% 83.333%;\n}\n.emoji-1f562 {\n    background-position: 50.000% 85.000%;\n}\n.emoji-1f563 {\n    background-position: 50.000% 86.667%;\n}\n.emoji-1f564 {\n    background-position: 50.000% 88.333%;\n}\n.emoji-1f565 {\n    background-position: 50.000% 90.000%;\n}\n.emoji-1f566 {\n    background-position: 50.000% 91.667%;\n}\n.emoji-1f567 {\n    background-position: 50.000% 93.333%;\n}\n.emoji-1f56f {\n    background-position: 50.000% 95.000%;\n}\n.emoji-1f570 {\n    background-position: 50.000% 96.667%;\n}\n.emoji-1f573 {\n    background-position: 50.000% 98.333%;\n}\n.emoji-1f574 {\n    background-position: 50.000% 100.000%;\n}\n.emoji-1f575-200d-2640 {\n    background-position: 51.667% 8.333%;\n}\n.emoji-1f575-200d-2642 {\n    background-position: 51.667% 18.333%;\n}\n.emoji-1f575 {\n    background-position: 51.667% 28.333%;\n}\n.emoji-1f576 {\n    background-position: 51.667% 38.333%;\n}\n.emoji-1f577 {\n    background-position: 51.667% 40.000%;\n}\n.emoji-1f578 {\n    background-position: 51.667% 41.667%;\n}\n.emoji-1f579 {\n    background-position: 51.667% 43.333%;\n}\n.emoji-1f57a {\n    background-position: 51.667% 45.000%;\n}\n.emoji-1f587 {\n    background-position: 51.667% 55.000%;\n}\n.emoji-1f58a {\n    background-position: 51.667% 56.667%;\n}\n.emoji-1f58b {\n    background-position: 51.667% 58.333%;\n}\n.emoji-1f58c {\n    background-position: 51.667% 60.000%;\n}\n.emoji-1f58d {\n    background-position: 51.667% 61.667%;\n}\n.emoji-1f590 {\n    background-position: 51.667% 63.333%;\n}\n.emoji-1f595 {\n    background-position: 51.667% 73.333%;\n}\n.emoji-1f596 {\n    background-position: 51.667% 83.333%;\n}\n.emoji-1f5a4 {\n    background-position: 51.667% 93.333%;\n}\n.emoji-1f5a5 {\n    background-position: 51.667% 95.000%;\n}\n.emoji-1f5a8 {\n    background-position: 51.667% 96.667%;\n}\n.emoji-1f5b1 {\n    background-position: 51.667% 98.333%;\n}\n.emoji-1f5b2 {\n    background-position: 51.667% 100.000%;\n}\n.emoji-1f5bc {\n    background-position: 53.333% 0.000%;\n}\n.emoji-1f5c2 {\n    background-position: 53.333% 1.667%;\n}\n.emoji-1f5c3 {\n    background-position: 53.333% 3.333%;\n}\n.emoji-1f5c4 {\n    background-position: 53.333% 5.000%;\n}\n.emoji-1f5d1 {\n    background-position: 53.333% 6.667%;\n}\n.emoji-1f5d2 {\n    background-position: 53.333% 8.333%;\n}\n.emoji-1f5d3 {\n    background-position: 53.333% 10.000%;\n}\n.emoji-1f5dc {\n    background-position: 53.333% 11.667%;\n}\n.emoji-1f5dd {\n    background-position: 53.333% 13.333%;\n}\n.emoji-1f5de {\n    background-position: 53.333% 15.000%;\n}\n.emoji-1f5e1 {\n    background-position: 53.333% 16.667%;\n}\n.emoji-1f5e3 {\n    background-position: 53.333% 18.333%;\n}\n.emoji-1f5e8 {\n    background-position: 53.333% 20.000%;\n}\n.emoji-1f5ef {\n    background-position: 53.333% 21.667%;\n}\n.emoji-1f5f3 {\n    background-position: 53.333% 23.333%;\n}\n.emoji-1f5fa {\n    background-position: 53.333% 25.000%;\n}\n.emoji-1f5fb {\n    background-position: 53.333% 26.667%;\n}\n.emoji-1f5fc {\n    background-position: 53.333% 28.333%;\n}\n.emoji-1f5fd {\n    background-position: 53.333% 30.000%;\n}\n.emoji-1f5fe {\n    background-position: 53.333% 31.667%;\n}\n.emoji-1f5ff {\n    background-position: 53.333% 33.333%;\n}\n.emoji-1f600 {\n    background-position: 53.333% 35.000%;\n}\n.emoji-1f601 {\n    background-position: 53.333% 36.667%;\n}\n.emoji-1f602 {\n    background-position: 53.333% 38.333%;\n}\n.emoji-1f603 {\n    background-position: 53.333% 40.000%;\n}\n.emoji-1f604 {\n    background-position: 53.333% 41.667%;\n}\n.emoji-1f605 {\n    background-position: 53.333% 43.333%;\n}\n.emoji-1f606 {\n    background-position: 53.333% 45.000%;\n}\n.emoji-1f607 {\n    background-position: 53.333% 46.667%;\n}\n.emoji-1f608 {\n    background-position: 53.333% 48.333%;\n}\n.emoji-1f609 {\n    background-position: 53.333% 50.000%;\n}\n.emoji-1f60a {\n    background-position: 53.333% 51.667%;\n}\n.emoji-1f60b {\n    background-position: 53.333% 53.333%;\n}\n.emoji-1f60c {\n    background-position: 53.333% 55.000%;\n}\n.emoji-1f60d {\n    background-position: 53.333% 56.667%;\n}\n.emoji-1f60e {\n    background-position: 53.333% 58.333%;\n}\n.emoji-1f60f {\n    background-position: 53.333% 60.000%;\n}\n.emoji-1f610 {\n    background-position: 53.333% 61.667%;\n}\n.emoji-1f611 {\n    background-position: 53.333% 63.333%;\n}\n.emoji-1f612 {\n    background-position: 53.333% 65.000%;\n}\n.emoji-1f613 {\n    background-position: 53.333% 66.667%;\n}\n.emoji-1f614 {\n    background-position: 53.333% 68.333%;\n}\n.emoji-1f615 {\n    background-position: 53.333% 70.000%;\n}\n.emoji-1f616 {\n    background-position: 53.333% 71.667%;\n}\n.emoji-1f617 {\n    background-position: 53.333% 73.333%;\n}\n.emoji-1f618 {\n    background-position: 53.333% 75.000%;\n}\n.emoji-1f619 {\n    background-position: 53.333% 76.667%;\n}\n.emoji-1f61a {\n    background-position: 53.333% 78.333%;\n}\n.emoji-1f61b {\n    background-position: 53.333% 80.000%;\n}\n.emoji-1f61c {\n    background-position: 53.333% 81.667%;\n}\n.emoji-1f61d {\n    background-position: 53.333% 83.333%;\n}\n.emoji-1f61e {\n    background-position: 53.333% 85.000%;\n}\n.emoji-1f61f {\n    background-position: 53.333% 86.667%;\n}\n.emoji-1f620 {\n    background-position: 53.333% 88.333%;\n}\n.emoji-1f621 {\n    background-position: 53.333% 90.000%;\n}\n.emoji-1f622 {\n    background-position: 53.333% 91.667%;\n}\n.emoji-1f623 {\n    background-position: 53.333% 93.333%;\n}\n.emoji-1f624 {\n    background-position: 53.333% 95.000%;\n}\n.emoji-1f625 {\n    background-position: 53.333% 96.667%;\n}\n.emoji-1f626 {\n    background-position: 53.333% 98.333%;\n}\n.emoji-1f627 {\n    background-position: 53.333% 100.000%;\n}\n.emoji-1f628 {\n    background-position: 55.000% 0.000%;\n}\n.emoji-1f629 {\n    background-position: 55.000% 1.667%;\n}\n.emoji-1f62a {\n    background-position: 55.000% 3.333%;\n}\n.emoji-1f62b {\n    background-position: 55.000% 5.000%;\n}\n.emoji-1f62c {\n    background-position: 55.000% 6.667%;\n}\n.emoji-1f62d {\n    background-position: 55.000% 8.333%;\n}\n.emoji-1f62e-200d-1f4a8 {\n    background-position: 55.000% 10.000%;\n}\n.emoji-1f62e {\n    background-position: 55.000% 11.667%;\n}\n.emoji-1f62f {\n    background-position: 55.000% 13.333%;\n}\n.emoji-1f630 {\n    background-position: 55.000% 15.000%;\n}\n.emoji-1f631 {\n    background-position: 55.000% 16.667%;\n}\n.emoji-1f632 {\n    background-position: 55.000% 18.333%;\n}\n.emoji-1f633 {\n    background-position: 55.000% 20.000%;\n}\n.emoji-1f634 {\n    background-position: 55.000% 21.667%;\n}\n.emoji-1f635-200d-1f4ab {\n    background-position: 55.000% 23.333%;\n}\n.emoji-1f635 {\n    background-position: 55.000% 25.000%;\n}\n.emoji-1f636-200d-1f32b {\n    background-position: 55.000% 26.667%;\n}\n.emoji-1f636 {\n    background-position: 55.000% 28.333%;\n}\n.emoji-1f637 {\n    background-position: 55.000% 30.000%;\n}\n.emoji-1f638 {\n    background-position: 55.000% 31.667%;\n}\n.emoji-1f639 {\n    background-position: 55.000% 33.333%;\n}\n.emoji-1f63a {\n    background-position: 55.000% 35.000%;\n}\n.emoji-1f63b {\n    background-position: 55.000% 36.667%;\n}\n.emoji-1f63c {\n    background-position: 55.000% 38.333%;\n}\n.emoji-1f63d {\n    background-position: 55.000% 40.000%;\n}\n.emoji-1f63e {\n    background-position: 55.000% 41.667%;\n}\n.emoji-1f63f {\n    background-position: 55.000% 43.333%;\n}\n.emoji-1f640 {\n    background-position: 55.000% 45.000%;\n}\n.emoji-1f641 {\n    background-position: 55.000% 46.667%;\n}\n.emoji-1f642 {\n    background-position: 55.000% 48.333%;\n}\n.emoji-1f643 {\n    background-position: 55.000% 50.000%;\n}\n.emoji-1f644 {\n    background-position: 55.000% 51.667%;\n}\n.emoji-1f645-200d-2640 {\n    background-position: 55.000% 53.333%;\n}\n.emoji-1f645-200d-2642 {\n    background-position: 55.000% 63.333%;\n}\n.emoji-1f645 {\n    background-position: 55.000% 73.333%;\n}\n.emoji-1f646-200d-2640 {\n    background-position: 55.000% 83.333%;\n}\n.emoji-1f646-200d-2642 {\n    background-position: 55.000% 93.333%;\n}\n.emoji-1f646 {\n    background-position: 56.667% 1.667%;\n}\n.emoji-1f647-200d-2640 {\n    background-position: 56.667% 11.667%;\n}\n.emoji-1f647-200d-2642 {\n    background-position: 56.667% 21.667%;\n}\n.emoji-1f647 {\n    background-position: 56.667% 31.667%;\n}\n.emoji-1f648 {\n    background-position: 56.667% 41.667%;\n}\n.emoji-1f649 {\n    background-position: 56.667% 43.333%;\n}\n.emoji-1f64a {\n    background-position: 56.667% 45.000%;\n}\n.emoji-1f64b-200d-2640 {\n    background-position: 56.667% 46.667%;\n}\n.emoji-1f64b-200d-2642 {\n    background-position: 56.667% 56.667%;\n}\n.emoji-1f64b {\n    background-position: 56.667% 66.667%;\n}\n.emoji-1f64c {\n    background-position: 56.667% 76.667%;\n}\n.emoji-1f64d-200d-2640 {\n    background-position: 56.667% 86.667%;\n}\n.emoji-1f64d-200d-2642 {\n    background-position: 56.667% 96.667%;\n}\n.emoji-1f64d {\n    background-position: 58.333% 5.000%;\n}\n.emoji-1f64e-200d-2640 {\n    background-position: 58.333% 15.000%;\n}\n.emoji-1f64e-200d-2642 {\n    background-position: 58.333% 25.000%;\n}\n.emoji-1f64e {\n    background-position: 58.333% 35.000%;\n}\n.emoji-1f64f {\n    background-position: 58.333% 45.000%;\n}\n.emoji-1f680 {\n    background-position: 58.333% 55.000%;\n}\n.emoji-1f681 {\n    background-position: 58.333% 56.667%;\n}\n.emoji-1f682 {\n    background-position: 58.333% 58.333%;\n}\n.emoji-1f683 {\n    background-position: 58.333% 60.000%;\n}\n.emoji-1f684 {\n    background-position: 58.333% 61.667%;\n}\n.emoji-1f685 {\n    background-position: 58.333% 63.333%;\n}\n.emoji-1f686 {\n    background-position: 58.333% 65.000%;\n}\n.emoji-1f687 {\n    background-position: 58.333% 66.667%;\n}\n.emoji-1f688 {\n    background-position: 58.333% 68.333%;\n}\n.emoji-1f689 {\n    background-position: 58.333% 70.000%;\n}\n.emoji-1f68a {\n    background-position: 58.333% 71.667%;\n}\n.emoji-1f68b {\n    background-position: 58.333% 73.333%;\n}\n.emoji-1f68c {\n    background-position: 58.333% 75.000%;\n}\n.emoji-1f68d {\n    background-position: 58.333% 76.667%;\n}\n.emoji-1f68e {\n    background-position: 58.333% 78.333%;\n}\n.emoji-1f68f {\n    background-position: 58.333% 80.000%;\n}\n.emoji-1f690 {\n    background-position: 58.333% 81.667%;\n}\n.emoji-1f691 {\n    background-position: 58.333% 83.333%;\n}\n.emoji-1f692 {\n    background-position: 58.333% 85.000%;\n}\n.emoji-1f693 {\n    background-position: 58.333% 86.667%;\n}\n.emoji-1f694 {\n    background-position: 58.333% 88.333%;\n}\n.emoji-1f695 {\n    background-position: 58.333% 90.000%;\n}\n.emoji-1f696 {\n    background-position: 58.333% 91.667%;\n}\n.emoji-1f697 {\n    background-position: 58.333% 93.333%;\n}\n.emoji-1f698 {\n    background-position: 58.333% 95.000%;\n}\n.emoji-1f699 {\n    background-position: 58.333% 96.667%;\n}\n.emoji-1f69a {\n    background-position: 58.333% 98.333%;\n}\n.emoji-1f69b {\n    background-position: 58.333% 100.000%;\n}\n.emoji-1f69c {\n    background-position: 60.000% 0.000%;\n}\n.emoji-1f69d {\n    background-position: 60.000% 1.667%;\n}\n.emoji-1f69e {\n    background-position: 60.000% 3.333%;\n}\n.emoji-1f69f {\n    background-position: 60.000% 5.000%;\n}\n.emoji-1f6a0 {\n    background-position: 60.000% 6.667%;\n}\n.emoji-1f6a1 {\n    background-position: 60.000% 8.333%;\n}\n.emoji-1f6a2 {\n    background-position: 60.000% 10.000%;\n}\n.emoji-1f6a3-200d-2640 {\n    background-position: 60.000% 11.667%;\n}\n.emoji-1f6a3-200d-2642 {\n    background-position: 60.000% 21.667%;\n}\n.emoji-1f6a3 {\n    background-position: 60.000% 31.667%;\n}\n.emoji-1f6a4 {\n    background-position: 60.000% 41.667%;\n}\n.emoji-1f6a5 {\n    background-position: 60.000% 43.333%;\n}\n.emoji-1f6a6 {\n    background-position: 60.000% 45.000%;\n}\n.emoji-1f6a7 {\n    background-position: 60.000% 46.667%;\n}\n.emoji-1f6a8 {\n    background-position: 60.000% 48.333%;\n}\n.emoji-1f6a9 {\n    background-position: 60.000% 50.000%;\n}\n.emoji-1f6aa {\n    background-position: 60.000% 51.667%;\n}\n.emoji-1f6ab {\n    background-position: 60.000% 53.333%;\n}\n.emoji-1f6ac {\n    background-position: 60.000% 55.000%;\n}\n.emoji-1f6ad {\n    background-position: 60.000% 56.667%;\n}\n.emoji-1f6ae {\n    background-position: 60.000% 58.333%;\n}\n.emoji-1f6af {\n    background-position: 60.000% 60.000%;\n}\n.emoji-1f6b0 {\n    background-position: 60.000% 61.667%;\n}\n.emoji-1f6b1 {\n    background-position: 60.000% 63.333%;\n}\n.emoji-1f6b2 {\n    background-position: 60.000% 65.000%;\n}\n.emoji-1f6b3 {\n    background-position: 60.000% 66.667%;\n}\n.emoji-1f6b4-200d-2640 {\n    background-position: 60.000% 68.333%;\n}\n.emoji-1f6b4-200d-2642 {\n    background-position: 60.000% 78.333%;\n}\n.emoji-1f6b4 {\n    background-position: 60.000% 88.333%;\n}\n.emoji-1f6b5-200d-2640 {\n    background-position: 60.000% 98.333%;\n}\n.emoji-1f6b5-200d-2642 {\n    background-position: 61.667% 6.667%;\n}\n.emoji-1f6b5 {\n    background-position: 61.667% 16.667%;\n}\n.emoji-1f6b6-200d-2640 {\n    background-position: 61.667% 26.667%;\n}\n.emoji-1f6b6-200d-2642 {\n    background-position: 61.667% 36.667%;\n}\n.emoji-1f6b6 {\n    background-position: 61.667% 46.667%;\n}\n.emoji-1f6b7 {\n    background-position: 61.667% 56.667%;\n}\n.emoji-1f6b8 {\n    background-position: 61.667% 58.333%;\n}\n.emoji-1f6b9 {\n    background-position: 61.667% 60.000%;\n}\n.emoji-1f6ba {\n    background-position: 61.667% 61.667%;\n}\n.emoji-1f6bb {\n    background-position: 61.667% 63.333%;\n}\n.emoji-1f6bc {\n    background-position: 61.667% 65.000%;\n}\n.emoji-1f6bd {\n    background-position: 61.667% 66.667%;\n}\n.emoji-1f6be {\n    background-position: 61.667% 68.333%;\n}\n.emoji-1f6bf {\n    background-position: 61.667% 70.000%;\n}\n.emoji-1f6c0 {\n    background-position: 61.667% 71.667%;\n}\n.emoji-1f6c1 {\n    background-position: 61.667% 81.667%;\n}\n.emoji-1f6c2 {\n    background-position: 61.667% 83.333%;\n}\n.emoji-1f6c3 {\n    background-position: 61.667% 85.000%;\n}\n.emoji-1f6c4 {\n    background-position: 61.667% 86.667%;\n}\n.emoji-1f6c5 {\n    background-position: 61.667% 88.333%;\n}\n.emoji-1f6cb {\n    background-position: 61.667% 90.000%;\n}\n.emoji-1f6cc {\n    background-position: 61.667% 91.667%;\n}\n.emoji-1f6cd {\n    background-position: 63.333% 0.000%;\n}\n.emoji-1f6ce {\n    background-position: 63.333% 1.667%;\n}\n.emoji-1f6cf {\n    background-position: 63.333% 3.333%;\n}\n.emoji-1f6d0 {\n    background-position: 63.333% 5.000%;\n}\n.emoji-1f6d1 {\n    background-position: 63.333% 6.667%;\n}\n.emoji-1f6d2 {\n    background-position: 63.333% 8.333%;\n}\n.emoji-1f6d5 {\n    background-position: 63.333% 10.000%;\n}\n.emoji-1f6d6 {\n    background-position: 63.333% 11.667%;\n}\n.emoji-1f6d7 {\n    background-position: 63.333% 13.333%;\n}\n.emoji-1f6dc {\n    background-position: 63.333% 15.000%;\n}\n.emoji-1f6dd {\n    background-position: 63.333% 16.667%;\n}\n.emoji-1f6de {\n    background-position: 63.333% 18.333%;\n}\n.emoji-1f6df {\n    background-position: 63.333% 20.000%;\n}\n.emoji-1f6e0 {\n    background-position: 63.333% 21.667%;\n}\n.emoji-1f6e1 {\n    background-position: 63.333% 23.333%;\n}\n.emoji-1f6e2 {\n    background-position: 63.333% 25.000%;\n}\n.emoji-1f6e3 {\n    background-position: 63.333% 26.667%;\n}\n.emoji-1f6e4 {\n    background-position: 63.333% 28.333%;\n}\n.emoji-1f6e5 {\n    background-position: 63.333% 30.000%;\n}\n.emoji-1f6e9 {\n    background-position: 63.333% 31.667%;\n}\n.emoji-1f6eb {\n    background-position: 63.333% 33.333%;\n}\n.emoji-1f6ec {\n    background-position: 63.333% 35.000%;\n}\n.emoji-1f6f0 {\n    background-position: 63.333% 36.667%;\n}\n.emoji-1f6f3 {\n    background-position: 63.333% 38.333%;\n}\n.emoji-1f6f4 {\n    background-position: 63.333% 40.000%;\n}\n.emoji-1f6f5 {\n    background-position: 63.333% 41.667%;\n}\n.emoji-1f6f6 {\n    background-position: 63.333% 43.333%;\n}\n.emoji-1f6f7 {\n    background-position: 63.333% 45.000%;\n}\n.emoji-1f6f8 {\n    background-position: 63.333% 46.667%;\n}\n.emoji-1f6f9 {\n    background-position: 63.333% 48.333%;\n}\n.emoji-1f6fa {\n    background-position: 63.333% 50.000%;\n}\n.emoji-1f6fb {\n    background-position: 63.333% 51.667%;\n}\n.emoji-1f6fc {\n    background-position: 63.333% 53.333%;\n}\n.emoji-1f7e0 {\n    background-position: 63.333% 55.000%;\n}\n.emoji-1f7e1 {\n    background-position: 63.333% 56.667%;\n}\n.emoji-1f7e2 {\n    background-position: 63.333% 58.333%;\n}\n.emoji-1f7e3 {\n    background-position: 63.333% 60.000%;\n}\n.emoji-1f7e4 {\n    background-position: 63.333% 61.667%;\n}\n.emoji-1f7e5 {\n    background-position: 63.333% 63.333%;\n}\n.emoji-1f7e6 {\n    background-position: 63.333% 65.000%;\n}\n.emoji-1f7e7 {\n    background-position: 63.333% 66.667%;\n}\n.emoji-1f7e8 {\n    background-position: 63.333% 68.333%;\n}\n.emoji-1f7e9 {\n    background-position: 63.333% 70.000%;\n}\n.emoji-1f7ea {\n    background-position: 63.333% 71.667%;\n}\n.emoji-1f7eb {\n    background-position: 63.333% 73.333%;\n}\n.emoji-1f7f0 {\n    background-position: 63.333% 75.000%;\n}\n.emoji-1f90c {\n    background-position: 63.333% 76.667%;\n}\n.emoji-1f90d {\n    background-position: 63.333% 86.667%;\n}\n.emoji-1f90e {\n    background-position: 63.333% 88.333%;\n}\n.emoji-1f90f {\n    background-position: 63.333% 90.000%;\n}\n.emoji-1f910 {\n    background-position: 63.333% 100.000%;\n}\n.emoji-1f911 {\n    background-position: 65.000% 0.000%;\n}\n.emoji-1f912 {\n    background-position: 65.000% 1.667%;\n}\n.emoji-1f913 {\n    background-position: 65.000% 3.333%;\n}\n.emoji-1f914 {\n    background-position: 65.000% 5.000%;\n}\n.emoji-1f915 {\n    background-position: 65.000% 6.667%;\n}\n.emoji-1f916 {\n    background-position: 65.000% 8.333%;\n}\n.emoji-1f917 {\n    background-position: 65.000% 10.000%;\n}\n.emoji-1f918 {\n    background-position: 65.000% 11.667%;\n}\n.emoji-1f919 {\n    background-position: 65.000% 21.667%;\n}\n.emoji-1f91a {\n    background-position: 65.000% 31.667%;\n}\n.emoji-1f91b {\n    background-position: 65.000% 41.667%;\n}\n.emoji-1f91c {\n    background-position: 65.000% 51.667%;\n}\n.emoji-1f91d {\n    background-position: 65.000% 61.667%;\n}\n.emoji-1f91e {\n    background-position: 66.667% 3.333%;\n}\n.emoji-1f91f {\n    background-position: 66.667% 13.333%;\n}\n.emoji-1f920 {\n    background-position: 66.667% 23.333%;\n}\n.emoji-1f921 {\n    background-position: 66.667% 25.000%;\n}\n.emoji-1f922 {\n    background-position: 66.667% 26.667%;\n}\n.emoji-1f923 {\n    background-position: 66.667% 28.333%;\n}\n.emoji-1f924 {\n    background-position: 66.667% 30.000%;\n}\n.emoji-1f925 {\n    background-position: 66.667% 31.667%;\n}\n.emoji-1f926-200d-2640 {\n    background-position: 66.667% 33.333%;\n}\n.emoji-1f926-200d-2642 {\n    background-position: 66.667% 43.333%;\n}\n.emoji-1f926 {\n    background-position: 66.667% 53.333%;\n}\n.emoji-1f927 {\n    background-position: 66.667% 63.333%;\n}\n.emoji-1f928 {\n    background-position: 66.667% 65.000%;\n}\n.emoji-1f929 {\n    background-position: 66.667% 66.667%;\n}\n.emoji-1f92a {\n    background-position: 66.667% 68.333%;\n}\n.emoji-1f92b {\n    background-position: 66.667% 70.000%;\n}\n.emoji-1f92c {\n    background-position: 66.667% 71.667%;\n}\n.emoji-1f92d {\n    background-position: 66.667% 73.333%;\n}\n.emoji-1f92e {\n    background-position: 66.667% 75.000%;\n}\n.emoji-1f92f {\n    background-position: 66.667% 76.667%;\n}\n.emoji-1f930 {\n    background-position: 66.667% 78.333%;\n}\n.emoji-1f931 {\n    background-position: 66.667% 88.333%;\n}\n.emoji-1f932 {\n    background-position: 66.667% 98.333%;\n}\n.emoji-1f933 {\n    background-position: 68.333% 6.667%;\n}\n.emoji-1f934 {\n    background-position: 68.333% 16.667%;\n}\n.emoji-1f935-200d-2640 {\n    background-position: 68.333% 26.667%;\n}\n.emoji-1f935-200d-2642 {\n    background-position: 68.333% 36.667%;\n}\n.emoji-1f935 {\n    background-position: 68.333% 46.667%;\n}\n.emoji-1f936 {\n    background-position: 68.333% 56.667%;\n}\n.emoji-1f937-200d-2640 {\n    background-position: 68.333% 66.667%;\n}\n.emoji-1f937-200d-2642 {\n    background-position: 68.333% 76.667%;\n}\n.emoji-1f937 {\n    background-position: 68.333% 86.667%;\n}\n.emoji-1f938-200d-2640 {\n    background-position: 68.333% 96.667%;\n}\n.emoji-1f938-200d-2642 {\n    background-position: 70.000% 5.000%;\n}\n.emoji-1f938 {\n    background-position: 70.000% 15.000%;\n}\n.emoji-1f939-200d-2640 {\n    background-position: 70.000% 25.000%;\n}\n.emoji-1f939-200d-2642 {\n    background-position: 70.000% 35.000%;\n}\n.emoji-1f939 {\n    background-position: 70.000% 45.000%;\n}\n.emoji-1f93a {\n    background-position: 70.000% 55.000%;\n}\n.emoji-1f93c-200d-2640 {\n    background-position: 70.000% 56.667%;\n}\n.emoji-1f93c-200d-2642 {\n    background-position: 70.000% 58.333%;\n}\n.emoji-1f93c {\n    background-position: 70.000% 60.000%;\n}\n.emoji-1f93d-200d-2640 {\n    background-position: 70.000% 61.667%;\n}\n.emoji-1f93d-200d-2642 {\n    background-position: 70.000% 71.667%;\n}\n.emoji-1f93d {\n    background-position: 70.000% 81.667%;\n}\n.emoji-1f93e-200d-2640 {\n    background-position: 70.000% 91.667%;\n}\n.emoji-1f93e-200d-2642 {\n    background-position: 71.667% 0.000%;\n}\n.emoji-1f93e {\n    background-position: 71.667% 10.000%;\n}\n.emoji-1f93f {\n    background-position: 71.667% 20.000%;\n}\n.emoji-1f940 {\n    background-position: 71.667% 21.667%;\n}\n.emoji-1f941 {\n    background-position: 71.667% 23.333%;\n}\n.emoji-1f942 {\n    background-position: 71.667% 25.000%;\n}\n.emoji-1f943 {\n    background-position: 71.667% 26.667%;\n}\n.emoji-1f944 {\n    background-position: 71.667% 28.333%;\n}\n.emoji-1f945 {\n    background-position: 71.667% 30.000%;\n}\n.emoji-1f947 {\n    background-position: 71.667% 31.667%;\n}\n.emoji-1f948 {\n    background-position: 71.667% 33.333%;\n}\n.emoji-1f949 {\n    background-position: 71.667% 35.000%;\n}\n.emoji-1f94a {\n    background-position: 71.667% 36.667%;\n}\n.emoji-1f94b {\n    background-position: 71.667% 38.333%;\n}\n.emoji-1f94c {\n    background-position: 71.667% 40.000%;\n}\n.emoji-1f94d {\n    background-position: 71.667% 41.667%;\n}\n.emoji-1f94e {\n    background-position: 71.667% 43.333%;\n}\n.emoji-1f94f {\n    background-position: 71.667% 45.000%;\n}\n.emoji-1f950 {\n    background-position: 71.667% 46.667%;\n}\n.emoji-1f951 {\n    background-position: 71.667% 48.333%;\n}\n.emoji-1f952 {\n    background-position: 71.667% 50.000%;\n}\n.emoji-1f953 {\n    background-position: 71.667% 51.667%;\n}\n.emoji-1f954 {\n    background-position: 71.667% 53.333%;\n}\n.emoji-1f955 {\n    background-position: 71.667% 55.000%;\n}\n.emoji-1f956 {\n    background-position: 71.667% 56.667%;\n}\n.emoji-1f957 {\n    background-position: 71.667% 58.333%;\n}\n.emoji-1f958 {\n    background-position: 71.667% 60.000%;\n}\n.emoji-1f959 {\n    background-position: 71.667% 61.667%;\n}\n.emoji-1f95a {\n    background-position: 71.667% 63.333%;\n}\n.emoji-1f95b {\n    background-position: 71.667% 65.000%;\n}\n.emoji-1f95c {\n    background-position: 71.667% 66.667%;\n}\n.emoji-1f95d {\n    background-position: 71.667% 68.333%;\n}\n.emoji-1f95e {\n    background-position: 71.667% 70.000%;\n}\n.emoji-1f95f {\n    background-position: 71.667% 71.667%;\n}\n.emoji-1f960 {\n    background-position: 71.667% 73.333%;\n}\n.emoji-1f961 {\n    background-position: 71.667% 75.000%;\n}\n.emoji-1f962 {\n    background-position: 71.667% 76.667%;\n}\n.emoji-1f963 {\n    background-position: 71.667% 78.333%;\n}\n.emoji-1f964 {\n    background-position: 71.667% 80.000%;\n}\n.emoji-1f965 {\n    background-position: 71.667% 81.667%;\n}\n.emoji-1f966 {\n    background-position: 71.667% 83.333%;\n}\n.emoji-1f967 {\n    background-position: 71.667% 85.000%;\n}\n.emoji-1f968 {\n    background-position: 71.667% 86.667%;\n}\n.emoji-1f969 {\n    background-position: 71.667% 88.333%;\n}\n.emoji-1f96a {\n    background-position: 71.667% 90.000%;\n}\n.emoji-1f96b {\n    background-position: 71.667% 91.667%;\n}\n.emoji-1f96c {\n    background-position: 71.667% 93.333%;\n}\n.emoji-1f96d {\n    background-position: 71.667% 95.000%;\n}\n.emoji-1f96e {\n    background-position: 71.667% 96.667%;\n}\n.emoji-1f96f {\n    background-position: 71.667% 98.333%;\n}\n.emoji-1f970 {\n    background-position: 71.667% 100.000%;\n}\n.emoji-1f971 {\n    background-position: 73.333% 0.000%;\n}\n.emoji-1f972 {\n    background-position: 73.333% 1.667%;\n}\n.emoji-1f973 {\n    background-position: 73.333% 3.333%;\n}\n.emoji-1f974 {\n    background-position: 73.333% 5.000%;\n}\n.emoji-1f975 {\n    background-position: 73.333% 6.667%;\n}\n.emoji-1f976 {\n    background-position: 73.333% 8.333%;\n}\n.emoji-1f977 {\n    background-position: 73.333% 10.000%;\n}\n.emoji-1f978 {\n    background-position: 73.333% 20.000%;\n}\n.emoji-1f979 {\n    background-position: 73.333% 21.667%;\n}\n.emoji-1f97a {\n    background-position: 73.333% 23.333%;\n}\n.emoji-1f97b {\n    background-position: 73.333% 25.000%;\n}\n.emoji-1f97c {\n    background-position: 73.333% 26.667%;\n}\n.emoji-1f97d {\n    background-position: 73.333% 28.333%;\n}\n.emoji-1f97e {\n    background-position: 73.333% 30.000%;\n}\n.emoji-1f97f {\n    background-position: 73.333% 31.667%;\n}\n.emoji-1f980 {\n    background-position: 73.333% 33.333%;\n}\n.emoji-1f981 {\n    background-position: 73.333% 35.000%;\n}\n.emoji-1f982 {\n    background-position: 73.333% 36.667%;\n}\n.emoji-1f983 {\n    background-position: 73.333% 38.333%;\n}\n.emoji-1f984 {\n    background-position: 73.333% 40.000%;\n}\n.emoji-1f985 {\n    background-position: 73.333% 41.667%;\n}\n.emoji-1f986 {\n    background-position: 73.333% 43.333%;\n}\n.emoji-1f987 {\n    background-position: 73.333% 45.000%;\n}\n.emoji-1f988 {\n    background-position: 73.333% 46.667%;\n}\n.emoji-1f989 {\n    background-position: 73.333% 48.333%;\n}\n.emoji-1f98a {\n    background-position: 73.333% 50.000%;\n}\n.emoji-1f98b {\n    background-position: 73.333% 51.667%;\n}\n.emoji-1f98c {\n    background-position: 73.333% 53.333%;\n}\n.emoji-1f98d {\n    background-position: 73.333% 55.000%;\n}\n.emoji-1f98e {\n    background-position: 73.333% 56.667%;\n}\n.emoji-1f98f {\n    background-position: 73.333% 58.333%;\n}\n.emoji-1f990 {\n    background-position: 73.333% 60.000%;\n}\n.emoji-1f991 {\n    background-position: 73.333% 61.667%;\n}\n.emoji-1f992 {\n    background-position: 73.333% 63.333%;\n}\n.emoji-1f993 {\n    background-position: 73.333% 65.000%;\n}\n.emoji-1f994 {\n    background-position: 73.333% 66.667%;\n}\n.emoji-1f995 {\n    background-position: 73.333% 68.333%;\n}\n.emoji-1f996 {\n    background-position: 73.333% 70.000%;\n}\n.emoji-1f997 {\n    background-position: 73.333% 71.667%;\n}\n.emoji-1f998 {\n    background-position: 73.333% 73.333%;\n}\n.emoji-1f999 {\n    background-position: 73.333% 75.000%;\n}\n.emoji-1f99a {\n    background-position: 73.333% 76.667%;\n}\n.emoji-1f99b {\n    background-position: 73.333% 78.333%;\n}\n.emoji-1f99c {\n    background-position: 73.333% 80.000%;\n}\n.emoji-1f99d {\n    background-position: 73.333% 81.667%;\n}\n.emoji-1f99e {\n    background-position: 73.333% 83.333%;\n}\n.emoji-1f99f {\n    background-position: 73.333% 85.000%;\n}\n.emoji-1f9a0 {\n    background-position: 73.333% 86.667%;\n}\n.emoji-1f9a1 {\n    background-position: 73.333% 88.333%;\n}\n.emoji-1f9a2 {\n    background-position: 73.333% 90.000%;\n}\n.emoji-1f9a3 {\n    background-position: 73.333% 91.667%;\n}\n.emoji-1f9a4 {\n    background-position: 73.333% 93.333%;\n}\n.emoji-1f9a5 {\n    background-position: 73.333% 95.000%;\n}\n.emoji-1f9a6 {\n    background-position: 73.333% 96.667%;\n}\n.emoji-1f9a7 {\n    background-position: 73.333% 98.333%;\n}\n.emoji-1f9a8 {\n    background-position: 73.333% 100.000%;\n}\n.emoji-1f9a9 {\n    background-position: 75.000% 0.000%;\n}\n.emoji-1f9aa {\n    background-position: 75.000% 1.667%;\n}\n.emoji-1f9ab {\n    background-position: 75.000% 3.333%;\n}\n.emoji-1f9ac {\n    background-position: 75.000% 5.000%;\n}\n.emoji-1f9ad {\n    background-position: 75.000% 6.667%;\n}\n.emoji-1f9ae {\n    background-position: 75.000% 8.333%;\n}\n.emoji-1f9af {\n    background-position: 75.000% 10.000%;\n}\n.emoji-1f9b4 {\n    background-position: 75.000% 11.667%;\n}\n.emoji-1f9b5 {\n    background-position: 75.000% 13.333%;\n}\n.emoji-1f9b6 {\n    background-position: 75.000% 23.333%;\n}\n.emoji-1f9b7 {\n    background-position: 75.000% 33.333%;\n}\n.emoji-1f9b8-200d-2640 {\n    background-position: 75.000% 35.000%;\n}\n.emoji-1f9b8-200d-2642 {\n    background-position: 75.000% 45.000%;\n}\n.emoji-1f9b8 {\n    background-position: 75.000% 55.000%;\n}\n.emoji-1f9b9-200d-2640 {\n    background-position: 75.000% 65.000%;\n}\n.emoji-1f9b9-200d-2642 {\n    background-position: 75.000% 75.000%;\n}\n.emoji-1f9b9 {\n    background-position: 75.000% 85.000%;\n}\n.emoji-1f9ba {\n    background-position: 75.000% 95.000%;\n}\n.emoji-1f9bb {\n    background-position: 75.000% 96.667%;\n}\n.emoji-1f9bc {\n    background-position: 76.667% 5.000%;\n}\n.emoji-1f9bd {\n    background-position: 76.667% 6.667%;\n}\n.emoji-1f9be {\n    background-position: 76.667% 8.333%;\n}\n.emoji-1f9bf {\n    background-position: 76.667% 10.000%;\n}\n.emoji-1f9c0 {\n    background-position: 76.667% 11.667%;\n}\n.emoji-1f9c1 {\n    background-position: 76.667% 13.333%;\n}\n.emoji-1f9c2 {\n    background-position: 76.667% 15.000%;\n}\n.emoji-1f9c3 {\n    background-position: 76.667% 16.667%;\n}\n.emoji-1f9c4 {\n    background-position: 76.667% 18.333%;\n}\n.emoji-1f9c5 {\n    background-position: 76.667% 20.000%;\n}\n.emoji-1f9c6 {\n    background-position: 76.667% 21.667%;\n}\n.emoji-1f9c7 {\n    background-position: 76.667% 23.333%;\n}\n.emoji-1f9c8 {\n    background-position: 76.667% 25.000%;\n}\n.emoji-1f9c9 {\n    background-position: 76.667% 26.667%;\n}\n.emoji-1f9ca {\n    background-position: 76.667% 28.333%;\n}\n.emoji-1f9cb {\n    background-position: 76.667% 30.000%;\n}\n.emoji-1f9cc {\n    background-position: 76.667% 31.667%;\n}\n.emoji-1f9cd-200d-2640 {\n    background-position: 76.667% 33.333%;\n}\n.emoji-1f9cd-200d-2642 {\n    background-position: 76.667% 43.333%;\n}\n.emoji-1f9cd {\n    background-position: 76.667% 53.333%;\n}\n.emoji-1f9ce-200d-2640 {\n    background-position: 76.667% 63.333%;\n}\n.emoji-1f9ce-200d-2642 {\n    background-position: 76.667% 73.333%;\n}\n.emoji-1f9ce {\n    background-position: 76.667% 83.333%;\n}\n.emoji-1f9cf-200d-2640 {\n    background-position: 76.667% 93.333%;\n}\n.emoji-1f9cf-200d-2642 {\n    background-position: 78.333% 1.667%;\n}\n.emoji-1f9cf {\n    background-position: 78.333% 11.667%;\n}\n.emoji-1f9d0 {\n    background-position: 78.333% 21.667%;\n}\n.emoji-1f9d1-200d-1f33e {\n    background-position: 78.333% 23.333%;\n}\n.emoji-1f9d1-200d-1f373 {\n    background-position: 78.333% 33.333%;\n}\n.emoji-1f9d1-200d-1f37c {\n    background-position: 78.333% 43.333%;\n}\n.emoji-1f9d1-200d-1f384 {\n    background-position: 78.333% 53.333%;\n}\n.emoji-1f9d1-200d-1f393 {\n    background-position: 78.333% 63.333%;\n}\n.emoji-1f9d1-200d-1f3a4 {\n    background-position: 78.333% 73.333%;\n}\n.emoji-1f9d1-200d-1f3a8 {\n    background-position: 78.333% 83.333%;\n}\n.emoji-1f9d1-200d-1f3eb {\n    background-position: 78.333% 93.333%;\n}\n.emoji-1f9d1-200d-1f3ed {\n    background-position: 80.000% 1.667%;\n}\n.emoji-1f9d1-200d-1f4bb {\n    background-position: 80.000% 11.667%;\n}\n.emoji-1f9d1-200d-1f4bc {\n    background-position: 80.000% 21.667%;\n}\n.emoji-1f9d1-200d-1f527 {\n    background-position: 80.000% 31.667%;\n}\n.emoji-1f9d1-200d-1f52c {\n    background-position: 80.000% 41.667%;\n}\n.emoji-1f9d1-200d-1f680 {\n    background-position: 80.000% 51.667%;\n}\n.emoji-1f9d1-200d-1f692 {\n    background-position: 80.000% 61.667%;\n}\n.emoji-1f9d1-200d-1f91d-200d-1f9d1 {\n    background-position: 80.000% 71.667%;\n}\n.emoji-1f9d1-200d-1f9af {\n    background-position: 81.667% 13.333%;\n}\n.emoji-1f9d1-200d-1f9b0 {\n    background-position: 81.667% 23.333%;\n}\n.emoji-1f9d1-200d-1f9b1 {\n    background-position: 81.667% 33.333%;\n}\n.emoji-1f9d1-200d-1f9b2 {\n    background-position: 81.667% 43.333%;\n}\n.emoji-1f9d1-200d-1f9b3 {\n    background-position: 81.667% 53.333%;\n}\n.emoji-1f9d1-200d-1f9bc {\n    background-position: 81.667% 63.333%;\n}\n.emoji-1f9d1-200d-1f9bd {\n    background-position: 81.667% 73.333%;\n}\n.emoji-1f9d1-200d-2695 {\n    background-position: 81.667% 83.333%;\n}\n.emoji-1f9d1-200d-2696 {\n    background-position: 81.667% 93.333%;\n}\n.emoji-1f9d1-200d-2708 {\n    background-position: 83.333% 1.667%;\n}\n.emoji-1f9d1 {\n    background-position: 83.333% 11.667%;\n}\n.emoji-1f9d2 {\n    background-position: 83.333% 21.667%;\n}\n.emoji-1f9d3 {\n    background-position: 83.333% 31.667%;\n}\n.emoji-1f9d4-200d-2640 {\n    background-position: 83.333% 41.667%;\n}\n.emoji-1f9d4-200d-2642 {\n    background-position: 83.333% 51.667%;\n}\n.emoji-1f9d4 {\n    background-position: 83.333% 61.667%;\n}\n.emoji-1f9d5 {\n    background-position: 83.333% 71.667%;\n}\n.emoji-1f9d6-200d-2640 {\n    background-position: 83.333% 81.667%;\n}\n.emoji-1f9d6-200d-2642 {\n    background-position: 83.333% 91.667%;\n}\n.emoji-1f9d6 {\n    background-position: 85.000% 0.000%;\n}\n.emoji-1f9d7-200d-2640 {\n    background-position: 85.000% 10.000%;\n}\n.emoji-1f9d7-200d-2642 {\n    background-position: 85.000% 20.000%;\n}\n.emoji-1f9d7 {\n    background-position: 85.000% 30.000%;\n}\n.emoji-1f9d8-200d-2640 {\n    background-position: 85.000% 40.000%;\n}\n.emoji-1f9d8-200d-2642 {\n    background-position: 85.000% 50.000%;\n}\n.emoji-1f9d8 {\n    background-position: 85.000% 60.000%;\n}\n.emoji-1f9d9-200d-2640 {\n    background-position: 85.000% 70.000%;\n}\n.emoji-1f9d9-200d-2642 {\n    background-position: 85.000% 80.000%;\n}\n.emoji-1f9d9 {\n    background-position: 85.000% 90.000%;\n}\n.emoji-1f9da-200d-2640 {\n    background-position: 85.000% 100.000%;\n}\n.emoji-1f9da-200d-2642 {\n    background-position: 86.667% 8.333%;\n}\n.emoji-1f9da {\n    background-position: 86.667% 18.333%;\n}\n.emoji-1f9db-200d-2640 {\n    background-position: 86.667% 28.333%;\n}\n.emoji-1f9db-200d-2642 {\n    background-position: 86.667% 38.333%;\n}\n.emoji-1f9db {\n    background-position: 86.667% 48.333%;\n}\n.emoji-1f9dc-200d-2640 {\n    background-position: 86.667% 58.333%;\n}\n.emoji-1f9dc-200d-2642 {\n    background-position: 86.667% 68.333%;\n}\n.emoji-1f9dc {\n    background-position: 86.667% 78.333%;\n}\n.emoji-1f9dd-200d-2640 {\n    background-position: 86.667% 88.333%;\n}\n.emoji-1f9dd-200d-2642 {\n    background-position: 86.667% 98.333%;\n}\n.emoji-1f9dd {\n    background-position: 88.333% 6.667%;\n}\n.emoji-1f9de-200d-2640 {\n    background-position: 88.333% 16.667%;\n}\n.emoji-1f9de-200d-2642 {\n    background-position: 88.333% 18.333%;\n}\n.emoji-1f9de {\n    background-position: 88.333% 20.000%;\n}\n.emoji-1f9df-200d-2640 {\n    background-position: 88.333% 21.667%;\n}\n.emoji-1f9df-200d-2642 {\n    background-position: 88.333% 23.333%;\n}\n.emoji-1f9df {\n    background-position: 88.333% 25.000%;\n}\n.emoji-1f9e0 {\n    background-position: 88.333% 26.667%;\n}\n.emoji-1f9e1 {\n    background-position: 88.333% 28.333%;\n}\n.emoji-1f9e2 {\n    background-position: 88.333% 30.000%;\n}\n.emoji-1f9e3 {\n    background-position: 88.333% 31.667%;\n}\n.emoji-1f9e4 {\n    background-position: 88.333% 33.333%;\n}\n.emoji-1f9e5 {\n    background-position: 88.333% 35.000%;\n}\n.emoji-1f9e6 {\n    background-position: 88.333% 36.667%;\n}\n.emoji-1f9e7 {\n    background-position: 88.333% 38.333%;\n}\n.emoji-1f9e8 {\n    background-position: 88.333% 40.000%;\n}\n.emoji-1f9e9 {\n    background-position: 88.333% 41.667%;\n}\n.emoji-1f9ea {\n    background-position: 88.333% 43.333%;\n}\n.emoji-1f9eb {\n    background-position: 88.333% 45.000%;\n}\n.emoji-1f9ec {\n    background-position: 88.333% 46.667%;\n}\n.emoji-1f9ed {\n    background-position: 88.333% 48.333%;\n}\n.emoji-1f9ee {\n    background-position: 88.333% 50.000%;\n}\n.emoji-1f9ef {\n    background-position: 88.333% 51.667%;\n}\n.emoji-1f9f0 {\n    background-position: 88.333% 53.333%;\n}\n.emoji-1f9f1 {\n    background-position: 88.333% 55.000%;\n}\n.emoji-1f9f2 {\n    background-position: 88.333% 56.667%;\n}\n.emoji-1f9f3 {\n    background-position: 88.333% 58.333%;\n}\n.emoji-1f9f4 {\n    background-position: 88.333% 60.000%;\n}\n.emoji-1f9f5 {\n    background-position: 88.333% 61.667%;\n}\n.emoji-1f9f6 {\n    background-position: 88.333% 63.333%;\n}\n.emoji-1f9f7 {\n    background-position: 88.333% 65.000%;\n}\n.emoji-1f9f8 {\n    background-position: 88.333% 66.667%;\n}\n.emoji-1f9f9 {\n    background-position: 88.333% 68.333%;\n}\n.emoji-1f9fa {\n    background-position: 88.333% 70.000%;\n}\n.emoji-1f9fb {\n    background-position: 88.333% 71.667%;\n}\n.emoji-1f9fc {\n    background-position: 88.333% 73.333%;\n}\n.emoji-1f9fd {\n    background-position: 88.333% 75.000%;\n}\n.emoji-1f9fe {\n    background-position: 88.333% 76.667%;\n}\n.emoji-1f9ff {\n    background-position: 88.333% 78.333%;\n}\n.emoji-1fa70 {\n    background-position: 88.333% 80.000%;\n}\n.emoji-1fa71 {\n    background-position: 88.333% 81.667%;\n}\n.emoji-1fa72 {\n    background-position: 88.333% 83.333%;\n}\n.emoji-1fa73 {\n    background-position: 88.333% 85.000%;\n}\n.emoji-1fa74 {\n    background-position: 88.333% 86.667%;\n}\n.emoji-1fa75 {\n    background-position: 88.333% 88.333%;\n}\n.emoji-1fa76 {\n    background-position: 88.333% 90.000%;\n}\n.emoji-1fa77 {\n    background-position: 88.333% 91.667%;\n}\n.emoji-1fa78 {\n    background-position: 88.333% 93.333%;\n}\n.emoji-1fa79 {\n    background-position: 88.333% 95.000%;\n}\n.emoji-1fa7a {\n    background-position: 88.333% 96.667%;\n}\n.emoji-1fa7b {\n    background-position: 88.333% 98.333%;\n}\n.emoji-1fa7c {\n    background-position: 88.333% 100.000%;\n}\n.emoji-1fa80 {\n    background-position: 90.000% 0.000%;\n}\n.emoji-1fa81 {\n    background-position: 90.000% 1.667%;\n}\n.emoji-1fa82 {\n    background-position: 90.000% 3.333%;\n}\n.emoji-1fa83 {\n    background-position: 90.000% 5.000%;\n}\n.emoji-1fa84 {\n    background-position: 90.000% 6.667%;\n}\n.emoji-1fa85 {\n    background-position: 90.000% 8.333%;\n}\n.emoji-1fa86 {\n    background-position: 90.000% 10.000%;\n}\n.emoji-1fa87 {\n    background-position: 90.000% 11.667%;\n}\n.emoji-1fa88 {\n    background-position: 90.000% 13.333%;\n}\n.emoji-1fa90 {\n    background-position: 90.000% 15.000%;\n}\n.emoji-1fa91 {\n    background-position: 90.000% 16.667%;\n}\n.emoji-1fa92 {\n    background-position: 90.000% 18.333%;\n}\n.emoji-1fa93 {\n    background-position: 90.000% 20.000%;\n}\n.emoji-1fa94 {\n    background-position: 90.000% 21.667%;\n}\n.emoji-1fa95 {\n    background-position: 90.000% 23.333%;\n}\n.emoji-1fa96 {\n    background-position: 90.000% 25.000%;\n}\n.emoji-1fa97 {\n    background-position: 90.000% 26.667%;\n}\n.emoji-1fa98 {\n    background-position: 90.000% 28.333%;\n}\n.emoji-1fa99 {\n    background-position: 90.000% 30.000%;\n}\n.emoji-1fa9a {\n    background-position: 90.000% 31.667%;\n}\n.emoji-1fa9b {\n    background-position: 90.000% 33.333%;\n}\n.emoji-1fa9c {\n    background-position: 90.000% 35.000%;\n}\n.emoji-1fa9d {\n    background-position: 90.000% 36.667%;\n}\n.emoji-1fa9e {\n    background-position: 90.000% 38.333%;\n}\n.emoji-1fa9f {\n    background-position: 90.000% 40.000%;\n}\n.emoji-1faa0 {\n    background-position: 90.000% 41.667%;\n}\n.emoji-1faa1 {\n    background-position: 90.000% 43.333%;\n}\n.emoji-1faa2 {\n    background-position: 90.000% 45.000%;\n}\n.emoji-1faa3 {\n    background-position: 90.000% 46.667%;\n}\n.emoji-1faa4 {\n    background-position: 90.000% 48.333%;\n}\n.emoji-1faa5 {\n    background-position: 90.000% 50.000%;\n}\n.emoji-1faa6 {\n    background-position: 90.000% 51.667%;\n}\n.emoji-1faa7 {\n    background-position: 90.000% 53.333%;\n}\n.emoji-1faa8 {\n    background-position: 90.000% 55.000%;\n}\n.emoji-1faa9 {\n    background-position: 90.000% 56.667%;\n}\n.emoji-1faaa {\n    background-position: 90.000% 58.333%;\n}\n.emoji-1faab {\n    background-position: 90.000% 60.000%;\n}\n.emoji-1faac {\n    background-position: 90.000% 61.667%;\n}\n.emoji-1faad {\n    background-position: 90.000% 63.333%;\n}\n.emoji-1faae {\n    background-position: 90.000% 65.000%;\n}\n.emoji-1faaf {\n    background-position: 90.000% 66.667%;\n}\n.emoji-1fab0 {\n    background-position: 90.000% 68.333%;\n}\n.emoji-1fab1 {\n    background-position: 90.000% 70.000%;\n}\n.emoji-1fab2 {\n    background-position: 90.000% 71.667%;\n}\n.emoji-1fab3 {\n    background-position: 90.000% 73.333%;\n}\n.emoji-1fab4 {\n    background-position: 90.000% 75.000%;\n}\n.emoji-1fab5 {\n    background-position: 90.000% 76.667%;\n}\n.emoji-1fab6 {\n    background-position: 90.000% 78.333%;\n}\n.emoji-1fab7 {\n    background-position: 90.000% 80.000%;\n}\n.emoji-1fab8 {\n    background-position: 90.000% 81.667%;\n}\n.emoji-1fab9 {\n    background-position: 90.000% 83.333%;\n}\n.emoji-1faba {\n    background-position: 90.000% 85.000%;\n}\n.emoji-1fabb {\n    background-position: 90.000% 86.667%;\n}\n.emoji-1fabc {\n    background-position: 90.000% 88.333%;\n}\n.emoji-1fabd {\n    background-position: 90.000% 90.000%;\n}\n.emoji-1fabf {\n    background-position: 90.000% 91.667%;\n}\n.emoji-1fac0 {\n    background-position: 90.000% 93.333%;\n}\n.emoji-1fac1 {\n    background-position: 90.000% 95.000%;\n}\n.emoji-1fac2 {\n    background-position: 90.000% 96.667%;\n}\n.emoji-1fac3 {\n    background-position: 90.000% 98.333%;\n}\n.emoji-1fac4 {\n    background-position: 91.667% 6.667%;\n}\n.emoji-1fac5 {\n    background-position: 91.667% 16.667%;\n}\n.emoji-1face {\n    background-position: 91.667% 26.667%;\n}\n.emoji-1facf {\n    background-position: 91.667% 28.333%;\n}\n.emoji-1fad0 {\n    background-position: 91.667% 30.000%;\n}\n.emoji-1fad1 {\n    background-position: 91.667% 31.667%;\n}\n.emoji-1fad2 {\n    background-position: 91.667% 33.333%;\n}\n.emoji-1fad3 {\n    background-position: 91.667% 35.000%;\n}\n.emoji-1fad4 {\n    background-position: 91.667% 36.667%;\n}\n.emoji-1fad5 {\n    background-position: 91.667% 38.333%;\n}\n.emoji-1fad6 {\n    background-position: 91.667% 40.000%;\n}\n.emoji-1fad7 {\n    background-position: 91.667% 41.667%;\n}\n.emoji-1fad8 {\n    background-position: 91.667% 43.333%;\n}\n.emoji-1fad9 {\n    background-position: 91.667% 45.000%;\n}\n.emoji-1fada {\n    background-position: 91.667% 46.667%;\n}\n.emoji-1fadb {\n    background-position: 91.667% 48.333%;\n}\n.emoji-1fae0 {\n    background-position: 91.667% 50.000%;\n}\n.emoji-1fae1 {\n    background-position: 91.667% 51.667%;\n}\n.emoji-1fae2 {\n    background-position: 91.667% 53.333%;\n}\n.emoji-1fae3 {\n    background-position: 91.667% 55.000%;\n}\n.emoji-1fae4 {\n    background-position: 91.667% 56.667%;\n}\n.emoji-1fae5 {\n    background-position: 91.667% 58.333%;\n}\n.emoji-1fae6 {\n    background-position: 91.667% 60.000%;\n}\n.emoji-1fae7 {\n    background-position: 91.667% 61.667%;\n}\n.emoji-1fae8 {\n    background-position: 91.667% 63.333%;\n}\n.emoji-1faf0 {\n    background-position: 91.667% 65.000%;\n}\n.emoji-1faf1 {\n    background-position: 91.667% 75.000%;\n}\n.emoji-1faf2 {\n    background-position: 91.667% 85.000%;\n}\n.emoji-1faf3 {\n    background-position: 91.667% 95.000%;\n}\n.emoji-1faf4 {\n    background-position: 93.333% 3.333%;\n}\n.emoji-1faf5 {\n    background-position: 93.333% 13.333%;\n}\n.emoji-1faf6 {\n    background-position: 93.333% 23.333%;\n}\n.emoji-1faf7 {\n    background-position: 93.333% 33.333%;\n}\n.emoji-1faf8 {\n    background-position: 93.333% 43.333%;\n}\n.emoji-203c {\n    background-position: 93.333% 53.333%;\n}\n.emoji-2049 {\n    background-position: 93.333% 55.000%;\n}\n.emoji-2122 {\n    background-position: 93.333% 56.667%;\n}\n.emoji-2139 {\n    background-position: 93.333% 58.333%;\n}\n.emoji-2194 {\n    background-position: 93.333% 60.000%;\n}\n.emoji-2195 {\n    background-position: 93.333% 61.667%;\n}\n.emoji-2196 {\n    background-position: 93.333% 63.333%;\n}\n.emoji-2197 {\n    background-position: 93.333% 65.000%;\n}\n.emoji-2198 {\n    background-position: 93.333% 66.667%;\n}\n.emoji-2199 {\n    background-position: 93.333% 68.333%;\n}\n.emoji-21a9 {\n    background-position: 93.333% 70.000%;\n}\n.emoji-21aa {\n    background-position: 93.333% 71.667%;\n}\n.emoji-231a {\n    background-position: 93.333% 73.333%;\n}\n.emoji-231b {\n    background-position: 93.333% 75.000%;\n}\n.emoji-2328 {\n    background-position: 93.333% 76.667%;\n}\n.emoji-23cf {\n    background-position: 93.333% 78.333%;\n}\n.emoji-23e9 {\n    background-position: 93.333% 80.000%;\n}\n.emoji-23ea {\n    background-position: 93.333% 81.667%;\n}\n.emoji-23eb {\n    background-position: 93.333% 83.333%;\n}\n.emoji-23ec {\n    background-position: 93.333% 85.000%;\n}\n.emoji-23ed {\n    background-position: 93.333% 86.667%;\n}\n.emoji-23ee {\n    background-position: 93.333% 88.333%;\n}\n.emoji-23ef {\n    background-position: 93.333% 90.000%;\n}\n.emoji-23f0 {\n    background-position: 93.333% 91.667%;\n}\n.emoji-23f1 {\n    background-position: 93.333% 93.333%;\n}\n.emoji-23f2 {\n    background-position: 93.333% 95.000%;\n}\n.emoji-23f3 {\n    background-position: 93.333% 96.667%;\n}\n.emoji-23f8 {\n    background-position: 93.333% 98.333%;\n}\n.emoji-23f9 {\n    background-position: 93.333% 100.000%;\n}\n.emoji-23fa {\n    background-position: 95.000% 0.000%;\n}\n.emoji-24c2 {\n    background-position: 95.000% 1.667%;\n}\n.emoji-25aa {\n    background-position: 95.000% 3.333%;\n}\n.emoji-25ab {\n    background-position: 95.000% 5.000%;\n}\n.emoji-25b6 {\n    background-position: 95.000% 6.667%;\n}\n.emoji-25c0 {\n    background-position: 95.000% 8.333%;\n}\n.emoji-25fb {\n    background-position: 95.000% 10.000%;\n}\n.emoji-25fc {\n    background-position: 95.000% 11.667%;\n}\n.emoji-25fd {\n    background-position: 95.000% 13.333%;\n}\n.emoji-25fe {\n    background-position: 95.000% 15.000%;\n}\n.emoji-2600 {\n    background-position: 95.000% 16.667%;\n}\n.emoji-2601 {\n    background-position: 95.000% 18.333%;\n}\n.emoji-2602 {\n    background-position: 95.000% 20.000%;\n}\n.emoji-2603 {\n    background-position: 95.000% 21.667%;\n}\n.emoji-2604 {\n    background-position: 95.000% 23.333%;\n}\n.emoji-260e {\n    background-position: 95.000% 25.000%;\n}\n.emoji-2611 {\n    background-position: 95.000% 26.667%;\n}\n.emoji-2614 {\n    background-position: 95.000% 28.333%;\n}\n.emoji-2615 {\n    background-position: 95.000% 30.000%;\n}\n.emoji-2618 {\n    background-position: 95.000% 31.667%;\n}\n.emoji-261d {\n    background-position: 95.000% 33.333%;\n}\n.emoji-2620 {\n    background-position: 95.000% 43.333%;\n}\n.emoji-2622 {\n    background-position: 95.000% 45.000%;\n}\n.emoji-2623 {\n    background-position: 95.000% 46.667%;\n}\n.emoji-2626 {\n    background-position: 95.000% 48.333%;\n}\n.emoji-262a {\n    background-position: 95.000% 50.000%;\n}\n.emoji-262e {\n    background-position: 95.000% 51.667%;\n}\n.emoji-262f {\n    background-position: 95.000% 53.333%;\n}\n.emoji-2638 {\n    background-position: 95.000% 55.000%;\n}\n.emoji-2639 {\n    background-position: 95.000% 56.667%;\n}\n.emoji-263a {\n    background-position: 95.000% 58.333%;\n}\n.emoji-2640 {\n    background-position: 95.000% 60.000%;\n}\n.emoji-2642 {\n    background-position: 95.000% 61.667%;\n}\n.emoji-2648 {\n    background-position: 95.000% 63.333%;\n}\n.emoji-2649 {\n    background-position: 95.000% 65.000%;\n}\n.emoji-264a {\n    background-position: 95.000% 66.667%;\n}\n.emoji-264b {\n    background-position: 95.000% 68.333%;\n}\n.emoji-264c {\n    background-position: 95.000% 70.000%;\n}\n.emoji-264d {\n    background-position: 95.000% 71.667%;\n}\n.emoji-264e {\n    background-position: 95.000% 73.333%;\n}\n.emoji-264f {\n    background-position: 95.000% 75.000%;\n}\n.emoji-2650 {\n    background-position: 95.000% 76.667%;\n}\n.emoji-2651 {\n    background-position: 95.000% 78.333%;\n}\n.emoji-2652 {\n    background-position: 95.000% 80.000%;\n}\n.emoji-2653 {\n    background-position: 95.000% 81.667%;\n}\n.emoji-265f {\n    background-position: 95.000% 83.333%;\n}\n.emoji-2660 {\n    background-position: 95.000% 85.000%;\n}\n.emoji-2663 {\n    background-position: 95.000% 86.667%;\n}\n.emoji-2665 {\n    background-position: 95.000% 88.333%;\n}\n.emoji-2666 {\n    background-position: 95.000% 90.000%;\n}\n.emoji-2668 {\n    background-position: 95.000% 91.667%;\n}\n.emoji-267b {\n    background-position: 95.000% 93.333%;\n}\n.emoji-267e {\n    background-position: 95.000% 95.000%;\n}\n.emoji-267f {\n    background-position: 95.000% 96.667%;\n}\n.emoji-2692 {\n    background-position: 95.000% 98.333%;\n}\n.emoji-2693 {\n    background-position: 95.000% 100.000%;\n}\n.emoji-2694 {\n    background-position: 96.667% 0.000%;\n}\n.emoji-2695 {\n    background-position: 96.667% 1.667%;\n}\n.emoji-2696 {\n    background-position: 96.667% 3.333%;\n}\n.emoji-2697 {\n    background-position: 96.667% 5.000%;\n}\n.emoji-2699 {\n    background-position: 96.667% 6.667%;\n}\n.emoji-269b {\n    background-position: 96.667% 8.333%;\n}\n.emoji-269c {\n    background-position: 96.667% 10.000%;\n}\n.emoji-26a0 {\n    background-position: 96.667% 11.667%;\n}\n.emoji-26a1 {\n    background-position: 96.667% 13.333%;\n}\n.emoji-26a7 {\n    background-position: 96.667% 15.000%;\n}\n.emoji-26aa {\n    background-position: 96.667% 16.667%;\n}\n.emoji-26ab {\n    background-position: 96.667% 18.333%;\n}\n.emoji-26b0 {\n    background-position: 96.667% 20.000%;\n}\n.emoji-26b1 {\n    background-position: 96.667% 21.667%;\n}\n.emoji-26bd {\n    background-position: 96.667% 23.333%;\n}\n.emoji-26be {\n    background-position: 96.667% 25.000%;\n}\n.emoji-26c4 {\n    background-position: 96.667% 26.667%;\n}\n.emoji-26c5 {\n    background-position: 96.667% 28.333%;\n}\n.emoji-26c8 {\n    background-position: 96.667% 30.000%;\n}\n.emoji-26ce {\n    background-position: 96.667% 31.667%;\n}\n.emoji-26cf {\n    background-position: 96.667% 33.333%;\n}\n.emoji-26d1 {\n    background-position: 96.667% 35.000%;\n}\n.emoji-26d3 {\n    background-position: 96.667% 36.667%;\n}\n.emoji-26d4 {\n    background-position: 96.667% 38.333%;\n}\n.emoji-26e9 {\n    background-position: 96.667% 40.000%;\n}\n.emoji-26ea {\n    background-position: 96.667% 41.667%;\n}\n.emoji-26f0 {\n    background-position: 96.667% 43.333%;\n}\n.emoji-26f1 {\n    background-position: 96.667% 45.000%;\n}\n.emoji-26f2 {\n    background-position: 96.667% 46.667%;\n}\n.emoji-26f3 {\n    background-position: 96.667% 48.333%;\n}\n.emoji-26f4 {\n    background-position: 96.667% 50.000%;\n}\n.emoji-26f5 {\n    background-position: 96.667% 51.667%;\n}\n.emoji-26f7 {\n    background-position: 96.667% 53.333%;\n}\n.emoji-26f8 {\n    background-position: 96.667% 55.000%;\n}\n.emoji-26f9-200d-2640 {\n    background-position: 96.667% 56.667%;\n}\n.emoji-26f9-200d-2642 {\n    background-position: 96.667% 66.667%;\n}\n.emoji-26f9 {\n    background-position: 96.667% 76.667%;\n}\n.emoji-26fa {\n    background-position: 96.667% 86.667%;\n}\n.emoji-26fd {\n    background-position: 96.667% 88.333%;\n}\n.emoji-2702 {\n    background-position: 96.667% 90.000%;\n}\n.emoji-2705 {\n    background-position: 96.667% 91.667%;\n}\n.emoji-2708 {\n    background-position: 96.667% 93.333%;\n}\n.emoji-2709 {\n    background-position: 96.667% 95.000%;\n}\n.emoji-270a {\n    background-position: 96.667% 96.667%;\n}\n.emoji-270b {\n    background-position: 98.333% 5.000%;\n}\n.emoji-270c {\n    background-position: 98.333% 15.000%;\n}\n.emoji-270d {\n    background-position: 98.333% 25.000%;\n}\n.emoji-270f {\n    background-position: 98.333% 35.000%;\n}\n.emoji-2712 {\n    background-position: 98.333% 36.667%;\n}\n.emoji-2714 {\n    background-position: 98.333% 38.333%;\n}\n.emoji-2716 {\n    background-position: 98.333% 40.000%;\n}\n.emoji-271d {\n    background-position: 98.333% 41.667%;\n}\n.emoji-2721 {\n    background-position: 98.333% 43.333%;\n}\n.emoji-2728 {\n    background-position: 98.333% 45.000%;\n}\n.emoji-2733 {\n    background-position: 98.333% 46.667%;\n}\n.emoji-2734 {\n    background-position: 98.333% 48.333%;\n}\n.emoji-2744 {\n    background-position: 98.333% 50.000%;\n}\n.emoji-2747 {\n    background-position: 98.333% 51.667%;\n}\n.emoji-274c {\n    background-position: 98.333% 53.333%;\n}\n.emoji-274e {\n    background-position: 98.333% 55.000%;\n}\n.emoji-2753 {\n    background-position: 98.333% 56.667%;\n}\n.emoji-2754 {\n    background-position: 98.333% 58.333%;\n}\n.emoji-2755 {\n    background-position: 98.333% 60.000%;\n}\n.emoji-2757 {\n    background-position: 98.333% 61.667%;\n}\n.emoji-2763 {\n    background-position: 98.333% 63.333%;\n}\n.emoji-2764-200d-1f525 {\n    background-position: 98.333% 65.000%;\n}\n.emoji-2764-200d-1fa79 {\n    background-position: 98.333% 66.667%;\n}\n.emoji-2764 {\n    background-position: 98.333% 68.333%;\n}\n.emoji-2795 {\n    background-position: 98.333% 70.000%;\n}\n.emoji-2796 {\n    background-position: 98.333% 71.667%;\n}\n.emoji-2797 {\n    background-position: 98.333% 73.333%;\n}\n.emoji-27a1 {\n    background-position: 98.333% 75.000%;\n}\n.emoji-27b0 {\n    background-position: 98.333% 76.667%;\n}\n.emoji-27bf {\n    background-position: 98.333% 78.333%;\n}\n.emoji-2934 {\n    background-position: 98.333% 80.000%;\n}\n.emoji-2935 {\n    background-position: 98.333% 81.667%;\n}\n.emoji-2b05 {\n    background-position: 98.333% 83.333%;\n}\n.emoji-2b06 {\n    background-position: 98.333% 85.000%;\n}\n.emoji-2b07 {\n    background-position: 98.333% 86.667%;\n}\n.emoji-2b1b {\n    background-position: 98.333% 88.333%;\n}\n.emoji-2b1c {\n    background-position: 98.333% 90.000%;\n}\n.emoji-2b50 {\n    background-position: 98.333% 91.667%;\n}\n.emoji-2b55 {\n    background-position: 98.333% 93.333%;\n}\n.emoji-3030 {\n    background-position: 98.333% 95.000%;\n}\n.emoji-303d {\n    background-position: 98.333% 96.667%;\n}\n.emoji-3297 {\n    background-position: 98.333% 98.333%;\n}\n.emoji-3299 {\n    background-position: 98.333% 100.000%;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
